import { Component, HostListener, Inject, ElementRef, ViewChild, SimpleChanges, Input, NgZone } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
// tslint:disable-next-line: import-blacklist
import { Meta } from '@angular/platform-browser'
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, BehaviorSubject } from 'rxjs';
import { BarcodeFormat, VideoInputDevice, Result } from '@zxing/library';
import { Store } from '@ngrx/store';
import { v4 as uuid } from 'uuid';
import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { LocationStrategy } from '@angular/common';
import { HangHoa, optSearch, optionSearch, valueSearch } from '../../models/product.model';
import { CTHoaDon, HoaDon, HTTT, TTHD, ListHD, SoHD, HD, HTTTs } from '../../models/bill.model';
import { KhachHang, KHTV_SGC, KH_HCG } from '../../models/customer.model';
import { NhanVien } from '../../models/employees.model';
import { QuayBanCuaHang, CuaHangBillFormat, MaCQT_LuuTru, TPC_QuayBan_MaCQT, Waitbill_MaCQT, MaCQT, CuaHang_Store_CTQLocation } from '../../models/store_stalls.model';
import { BgColors } from '../../models/bg_color.model';
import { Logo } from '../../models/logo.model';
import { AuthenticationService } from '../../services/authentication.service';
import { CustomizeColorService } from '../../services/customizeColor.service';
import { UploadFileService } from '../../services/upload-file.service';
import { CustomerService } from '../../services/customer.service';
import { ProductService } from '../../services/product.service';
import { BillService } from '../../services/bill.service';
import { OfflineService } from '../../services/offline.service';
import { AppState } from '../../ngrx-store/app.state';
import { JWTService } from '../../services/JWTService';
import { catChuoi, ServerResponse, TPCloud_isNumber } from '../../models/types';
import printJS from 'print-js/src/index';
import { read, readFile } from 'fs';
import { async } from 'q';
import localforage, * as localForage from 'localforage';
import { GetLocalForageConFigService } from '../../services/getLocalForage.service';
import { Denomination, Menhgia, Menhgia_Cashin } from '../../models/Denomination.model';
import { ScannerQRService } from '../../services/ScannerQR.service';
import { Momo_Message, Momo_Query_Message, Voucher, ListVoucher, VNPay_Response, App_Response } from '../../models/payment.model';
import { VoucherService } from '../../services/voucher.service';
import { setTimeout } from 'timers';
import { SuKienGiaService } from '../../services/sukiengia.service';
import { SuKienGia } from '../../models/sukiengia.model';
import { type } from 'os';
import { from } from 'rxjs/observable/from';
import { EinvoiceService } from '../../services/einvoice.service';
import { EinvoiceReceive, KhachHangEinvoice } from '../../models/einvoice.model';
import { Cashin } from '../../models/cash.model';
import { b } from '@angular/core/src/render3';
import { ASTWithSource } from '@angular/compiler';
import { CashService } from '../../services/cash.service';
import { EmployeesService } from '../../services/employees.service';
import * as bwipjs from 'bwip-js';
import { User, User_CP } from '../../models/user.model';
import { isNull, isNullOrUndefined } from 'util';
import { take } from 'rxjs/operator/take';
import { map } from 'rxjs/operator/map';
import * as $ from "jquery";
import { ThousandPipe } from '../../pipe/thousand.pipe';
import * as signalR from '@microsoft/signalr';
import { Noti_Message } from '../../models/notification';
import * as domtoimage from 'dom-to-image';
import * as domtoimage2 from "dom-to-image-more";
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { forEach } from '@angular/router/src/utils/collection';
declare let html2canvas: any;
//interface Window { TPCGoWV: any; }
declare global {
  interface Window {
    TPCGoWV: any;
  }
}


@Component({
  selector: 'app-banhang',
  templateUrl: './banhang.component.html',
  styleUrls: ['./banhang.component.css'],
})


export class BanHangComponent {
  checkAmount = false;
  checkPageHome = true;
  checkCancelCart = true;
  checkMenuFooter = true;
  checkMenuFooter_B = true;
  checkMenuFooter_Money = false;
  checkMenuFooter_QR = false;
  checkMenuFooter_CreditCard = false;
  checkMenuFooter_Voucher = false;
  checkMenuFooter_Point = false;
  checkMenuFooter_HCG = false;
  finddefault = true;
  checkfind = false;
  findresult = false;
  checkPageFind = false;
  checkPageCustomer = false;
  checkPageOther = false;
  checkPageCamera = false;
  checkPagePayment = false;
  checkPagePayment_Money = false;
  checkPagePayment_QR = false;
  checkPagePayment_CreditCard = false;
  checkPagePayment_Voucher = false;
  checkPagePayment_Point = false;
  checkPagePayment_HCG = false;
  checkDisabledHTTT = false;
  isHadMomo = false;
  isHadPoint = false;
  isValidCheckMoney = true;
  isValidCheckEnter = true;
  isValidConfirmPayment = true;
  flag_nhapkh = false;
  flag_nhapSrcPrc = false;

  isCheckPageHelp_Home = false;
  flag_nhaptienHD = false;
  checktemplateBill = false;
  _isFocusPayment = false;
  _isCheckInputMoney = false;
  checktemplatePrintBill = false;
  _isDisabledState = false;
  isFirstTime_LoadHelp = false;
  checkPaymentBill = false;
  checkFooter = false;
  _isValisSubmit_QR = true;
  checkMoneyFace = false;
  checkQR = false;
  checkVoucher = false;
  checkCreditCard = false;
  //------ Trí biến E-Invoice
  checkPageE_Invoice = false;
  checkPage_ReturnITem = false;
  checkPage_ManyItems = false;
  checkPageCamera_New = false;
  checkPagePrice_Item = false;
  checkSearchPrice_Item = false;
  //--------------------- Biến thay đổi background icon
  checkChangeBG_IconCamera = false;
  checkChangeBG_IconFind = false;
  checkChangeBG_IconCustomer = false;
  checkChangeBG_IconGear = false;
  checkIconCamera_WhenEdit_InCamera = false;
  //--------------------- Biến thay đổi color icon
  checkChangeColor_IconCamera_New_PageCamera = false;
  checkChangeColor_IconEidt_PageCamera = false;


  config_Payment: number;
  billTemplate: string;


  newPrice: number;
  adjustItem: HangHoa;
  priceItem: HangHoa;
  priceItem_dc: number;
  priceItem_SKG: Array<SuKienGia>;
  priceItem_SKG_str: string;
  price0Item: HangHoa;
  priceadd: number = 1;
  productsTable: Array<HangHoa>;
  listCart: Array<CTHoaDon>;
  listCart_bef_discount: Array<CTHoaDon>;
  products: Array<HangHoa> = new Array<HangHoa>();
  checkCart: Array<HangHoa> = [];
  cart: Array<CTHoaDon> = [];
  dtCartProduct: CTHoaDon = null;
  customer: KhachHang = null;
  listHD_Tong: Array<HoaDon> = [];
  order: HoaDon = new HoaDon(this.listHD_Tong);
  orderCancel: Array<HoaDon> = [];
  orderWait: Array<HoaDon> = [];
  orderWait_temp: Array<HoaDon> = [];
  Waitbill_MaCQT: Array<Waitbill_MaCQT> = []
  account: Observable<NhanVien>;
  dtStore: Observable<QuayBanCuaHang>;
  user: NhanVien;
  manager: NhanVien;
  dtQBan: QuayBanCuaHang;
  valueBg_Color: BgColors = new BgColors();
  thanhToanHD: Array<HoaDon> = [];
  hinhThucThanhToans: Array<HTTT> = new Array<HTTT>();
  dsKHHCG: Array<KH_HCG> = new Array<KH_HCG>();
  selectedValue: HTTT;
  payBill: Array<TTHD> = [];
  payment: HoaDon;
  logo: Logo = new Logo();
  dtStoreHangHoa: Observable<HangHoa[]>;
  // dsHangHoa: HangHoa[];
  dtStoreNhanVien: Observable<NhanVien[]>;
  dsNhanVien: Array<NhanVien> = new Array<NhanVien>();
  ListHD: Array<ListHD> = [];
  dtStoreHTTT: Observable<HTTT[]>;
  dtStoreKHHCG: Observable<KH_HCG[]>;
  // dsHTTT: Array<HTTT> = new Array<HTTT>();
  BillTypeOne: HoaDon;
  dtStoreBill: Observable<CuaHangBillFormat[]>;
  dsBill: Array<CuaHangBillFormat> = new Array<CuaHangBillFormat>();
  dataBill: HD = new HD();
  menhGia: Array<Denomination> = Menhgia;
  menhGia_Cashin: Array<Denomination> = Menhgia_Cashin;
  vouchers: Array<Voucher> = [];
  lsVoucher: Array<ListVoucher> = new Array<ListVoucher>();
  optSearch: Array<optionSearch> = optSearch;
  urllogotopos: string;
  urllogoKH: string;
  momo: Momo_Message;
  momo_query: Momo_Query_Message;

  // ------------------------------ Trí thêm
  ChangeOrder: HoaDon = new HoaDon(this.listHD_Tong);
  payBillReturnItems: Array<TTHD> = [];
  listCart_ReturnItems: Array<CTHoaDon> = [];
  listCheckCart_ReturnItems: Array<CTHoaDon> = [];
  listItems_Return: Array<CTHoaDon> = [];

  // Test phần descrypt (su kiện giá)
  dtStoreSuKienGia: Observable<SuKienGia[]>;
  dsSuKienGia: Array<SuKienGia> = new Array<SuKienGia>();
  cartSKG: Array<CTHoaDon> = [];

  app_Version: string;
  closeResult: string;
  minOffline = 0;
  number = 0;
  intoMoney = 0;
  total = 0;
  totaldiscount_HD = 0;
  discount = 0;
  total_wo_discount = 0;
  valueProduct = '';
  numericalOrder = 1;
  today: number = Date.now();
  math = Math;
  valueNumber = '';
  valueInput = '';
  valueFind = '';
  userName = '';
  valueModal: number;
  numberHD: number;
  checkboxSelected = false;
  valueInputMoney: number;
  valueNumberLabel = 0;
  intervalTime = 1000;
  /*  heightPageFindN = '65vh';*/ /*thuộc tính cũ đã dùng comment ngày 07/04/2022*/
  heightPageFindN = '72vh';
  /*  heightPageFind = '54vh';*/ /*thuộc tính cũ đã dùng comment ngày 07/04/2022*/
  heightPageFind = '60vh';
  inz: any;
  messageError = '';
  messageNoti = '';
  valueContentError: any;
  mr: NgbModalRef;
  viewContent: any;
  helppart: any;
  valueNamePage = '';
  radioSelected: number;
  url: any;
  valueNumberBill: number;
  tbOrderWaitOpacityN = '1';
  tbOrderWaitOpacity = '0.5';
  isNumberBill = TPCloud_isNumber;
  catchuoi = catChuoi;
  valueMoney = 0;
  valuePoint = 0;
  valueCode_QR = '';
  valueCode_Voucher = '';
  valueMoney_CreditCard: number;
  valueMoney_HCG: number;
  valueReferenceCode_QR = '';
  valueReferenceCode_CreditCard = '';
  valueReferenceCode_HCG = '';
  valueMoney_All = 0;
  valueAll_excMoney = 0;
  valueAll_excPoint = 0;
  valueAll_excVoucher = 0;
  totalVoucher = 0;
  totalPoints = 0;
  isValidCheckVoucher;
  valueMoney_Voucher: string;
  valueMoney_Change = 0;
  checkDisabledAgree;
  // colorMessage;
  optionSearch: optionSearch = optSearch[0];
  _valueSearch: valueSearch = new valueSearch();
  // -----------------------
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;

  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ];

  hasDevices: boolean;
  hasPermission: boolean;

  qrResultString: string;

  torchEnabled = true;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;
  modalConfig: NgbModalOptions;
  blockall_modalConfig = { centered: true, backdrop: 'static', keyboard: false };
  sum = 5;
  onepartten_product = 0;
  FindProducts: Array<HangHoa> = new Array<HangHoa>();
  // Thêm biến form page E-Invoice
  NameCompany: string = "";
  BuyerName: string = "";
  taxcode: string = "";
  phone: string;
  Email: string = "";
  Address: string = "";
  selectItems_return: boolean;
  ChangeMoney_ReturnItems: number = 0;
  ChangeDiscount_ReturnITems: number = 0;
  urlXemEinvoice8: string = "";
  flaginv8: boolean = false;
  urlXemEinvoice0510: string = "";
  flaginv0510: boolean = false;
  EinvoiceID8: string = "";
  EinvoiceID0510: string = "";
  // Thêm biến Page Camera New
  valueUPC_PageCamera: string = "";
  valueQuanlity_PageCamera: number;
  //Thêm modal nhập số lượng cho HH khac DVT EA
  scan_quantity: number = 0;
  cashin_Amount: number;
  // Thêm biến chọn ngày cho phần trả hàng
  valueSelectDate: any;
  valueSelectDate_PrintBillAgain: any;
  discount_percent: number;
  us_cp: User_CP = new User_CP();
  tenNV_Vtat = '';
  imgKH_b64 = '';

  // -----------------------------
  @ViewChild('contentError') private contentError;
  @ViewChild('contentLitmit_CQT') private contentLitmit_CQT;
  @ViewChild('contentNoti') private contentNoti;
  @ViewChild('contentQB_MaCQT') private contentQBban_MaCQT;
  @ViewChild('contentEinvoice') private contentEinvoice;
  @ViewChild('contentLoading') private contentLoading;
  @ViewChild('contentPayment') private contentPayment;
  @ViewChild('PageFindLoad') private PageFindLoad;
  @ViewChild('PageFindLoadDefaut') private PageFindLoadDefaut;
  @ViewChild('ContentOuputE_Invoice') private ContentOutputE_Invoice;
  @ViewChild('ContentReturn_Item') private ContentReturn_Item;
  @ViewChild('contentConfirmTillKey') private contentConfirmTillKey;
  @ViewChild('contentInputQuantity') private contentInputQuantity;
  @ViewChild('contentCashin') private contentCashin;
  @ViewChild('contentChangePass') private contentChangePass;
  @ViewChild('contentDiscount') private contentDiscount;
  @ViewChild('contentPrint2') private contentPrint2;
  @ViewChild('ContentNotes') private contentNotes;
  @ViewChild('contentSearchKHTV') private contentSearchKHTV;
  @ViewChild('contentPriceInput') private contentPriceInput;

  codeAdjustItem: string;
  codePriceItem: string;
  billNotes: string;

  radioSelected_KHTV: string;
  value_searchSDT: string;
  lst_customer: Array<KHTV_SGC> = new Array<KHTV_SGC>();
  // @ViewChild('inputVoucherCode') private inputVoucherCode;
  constructor(
    private sanitized: DomSanitizer,
    private authenticationService: AuthenticationService,
    private bgColorService: CustomizeColorService,
    private uploadFileService: UploadFileService,
    private customerService: CustomerService,
    private productService: ProductService,
    private billService: BillService,
    private offlineService: OfflineService,
    private modalService: NgbModal,
    private store: Store<AppState>,
    private http: HttpClient,
    private jwtService: JWTService,
    private locationStrategy: LocationStrategy,
    private myScrollContainer: ElementRef,
    private getlocalconfig: GetLocalForageConFigService,
    private scannerQRService: ScannerQRService,
    private metaService: Meta,
    private voucherService: VoucherService,
    private einvoiceService: EinvoiceService,
    private cashService: CashService,
    //private router: Router,
    private employeesService: EmployeesService,
    private zone: NgZone,
    private sukiengiaService: SuKienGiaService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    //this.mr = this.modalService.open(this.contentLoading, { centered: true, backdrop: 'static' });
    window['app-banhang'] = {
      zone: this.zone,
      componentFn: (value) => this.updateFromMyJavaApp(value),
      component: this
    };
    this.http.get('manifest.json', { responseType: 'json' }).subscribe(async name => {
      this.config_Payment = +(await name['config_payment']);
      this.billTemplate = await name['bill_type'];
    });
    this.app_Version = environment.Version;

    this.url = baseUrl + 'assets/images/Logo/';

    this.urllogoKH = '';
    this.urllogotopos = '';

    if (this.listCart) {
      this.getInto();
    }
    this.account = this.store.select(state => state.user);
    this.account.subscribe(async x => {
      if (x) {
        this.user = x;
        this.tenNV_Vtat = this.VietTat_TenNhanVien(x.TenNV);
      } else {
        // const getState: NhanVien = JSON.parse(localStorage.getItem('_user'));
        let getState: NhanVien = new NhanVien();
        await localForage.getItem('_user').then((result: any) => {
          if (result) {
            getState = JSON.parse(result);
          }
        });
        console.log(getState);
        console.log(getState);
        if (getState) {
          console.log(getState);
          this.user = getState;
          this.tenNV_Vtat = this.VietTat_TenNhanVien(this.user.TenNV);
        } else {
          this.Logout();
        }
      }
    });

    this.dtStore = this.store.select(state => state.store);
    this.dtStore.subscribe(x => {
      if (x) {
        this.dtQBan = x[0];
        this.dtQBan.TenCH = catChuoi(this.dtQBan.TenCH, 30);
        console.log(this.dtQBan);
      } else {
        const getState: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
        if (getState) {
          console.log(getState[0]);
          this.dtQBan = getState[0];
          this.dtQBan.TenCH = catChuoi(this.dtQBan.TenCH, 30);
        } else {
          this.Logout();
        }
      }
    });

    // tslint:disable-next-line:no-shadowed-variable
    this.dtStoreNhanVien = this.store.select(state => state.dsnhanvien);
    this.dtStoreNhanVien.subscribe(async nv => {
      if (nv) {
        this.dsNhanVien = nv;
        console.log(this.dsNhanVien);
      } else {
        // const dsNV = localStorage.getItem('_dsNV');
        await localForage.getItem('_dsNV').then((result: string) => {
          const deCryptDSNV = this.jwtService.deCryptData(result);
          const danhsachNhanVien: Array<NhanVien> = JSON.parse(deCryptDSNV);
          console.log('danhsachNhanVien');
          console.log(danhsachNhanVien);
          // danhsachNhanVien.forEach(element => {
          //   this.dsNhanVien.push(element);
          // });
          this.dsNhanVien = danhsachNhanVien;
        });

        // const ds = new Promise(res => {
        //   localForage.getItem('_dsNV').then((result: any) => {
        //     if (result) {
        //       const deCryptDSNV = this.jwtService.deCryptData(result);
        //       const danhsachNhanVien = JSON.parse(deCryptDSNV);
        //       res(danhsachNhanVien);
        //     } else {
        //       res(null);
        //     }
        //   });
        // });
        // this.dsNhanVien = ds;


        // if (dsNV) {
        //   const deCryptDSNV = this.jwtService.deCryptData(dsNV);
        //   const danhsachNhanVien = JSON.parse(deCryptDSNV);
        //   this.dsNhanVien = danhsachNhanVien;
        //   console.log(this.dsNhanVien);
        // }
        console.log(this.dsNhanVien);
      }
    });
    const reader = new XMLHttpRequest();
    // tslint:disable-next-line:no-shadowed-variable
    this.dtStoreHangHoa = this.store.select(state => state.dshanghoa);
    this.dtStoreHangHoa.subscribe(async hh => {
      if (hh) {
        this.products = hh;
        const index: HangHoa = this.products.find(x => x.HinhAnh == true);
        this.onepartten_product = 4 * Math.round(this.products.length / 10);
        this.sum = this.onepartten_product;
        this.appendItemsDown(0, this.sum);
        //console.log(this.products);
      } else {
        // const dsHH = localStorage.getItem('_dsHH');
        // const dsHH = localForage.getItem('_dsHH').then();
        // const deCryptDSHH = this.jwtService.deCryptData(dsHH);
        // const danhsachHangHoa: Array<HangHoa> = JSON.parse(deCryptDSHH);
        // danhsachHangHoa.forEach(x => {
        //   productService.getImgProduct(x.MaHH).then(data => x.HinhAnh = data);
        // });
        // this.products = danhsachHangHoa;
        // console.log(this.products);

        this.GetPrductNewPrice();
      }
    });


    this.dtStoreHTTT = this.store.select(state => state.httt);
    this.dtStoreHTTT.subscribe(async httt => {
      if (httt) {
        this.hinhThucThanhToans = httt;
        this.selectedValue = httt[0];
        console.log('dieu kien dung cua dtStoreHTTT');
        console.log(this.hinhThucThanhToans);
      } else {
        await localForage.getItem('_dsHTTT').then((result: string) => {
          if (result) {
            const deCryptDSHTTT = jwtService.deCryptData(result);
            const danhsachHTTT = JSON.parse(deCryptDSHTTT);
            this.hinhThucThanhToans = danhsachHTTT;
            this.selectedValue = this.hinhThucThanhToans[0];
          }
        });
      }
    });

    this.dtStoreKHHCG = this.store.select(state => state.hcg);
    this.dtStoreKHHCG.subscribe(async hcg => {
      if (hcg) {
        this.dsKHHCG = hcg;
      } else {
        await localForage.getItem('_dsKHHCG').then((result: string) => {
          if (result) {
            const deCryptDSHCG = jwtService.deCryptData(result);
            const danhsachHCG = JSON.parse(deCryptDSHCG);
            this.dsKHHCG = danhsachHCG;
          }
        });
      }
    });


    this.dtStoreBill = this.store.select(state => state.bill);
    this.dtStoreBill.subscribe(async bill => {
      // console.log(bill);
      if (bill) {
        this.dsBill = bill;
      } else {
        // const dsachBill = localStorage.getItem('_dsBill');
        // const dsachBill = localForage.getItem('_dsBill').then();
        // if (dsachBill) {
        //   const deCryptDSBill = this.jwtService.deCryptData(dsachBill);
        //   const danhsachBill = JSON.parse(deCryptDSBill);
        //   this.dsBill = danhsachBill;
        //   console.log(this.dsBill);
        // }

        await localForage.getItem('_dsBill').then((result: string) => {
          if (result) {
            const deCryptDSBill = this.jwtService.deCryptData(result);
            const danhsachBill = JSON.parse(deCryptDSBill);
            this.dsBill = danhsachBill;
          }
        });
        console.log('this.dsBill');
        console.log(this.dsBill);
      }
    });


    this.dtStoreSuKienGia = this.store.select(state => state.skg);
    this.dtStoreSuKienGia.subscribe(async skg => {
      if (skg) {
        this.dsSuKienGia = skg;
      } else {
        await localForage.getItem('_dsSKG').then((result: string) => {
          const descryptDSSKG = jwtService.deCryptData(result);
          const danhsachSuKienGia: Array<SuKienGia> = JSON.parse(descryptDSSKG);
          // console.log('danhsachSuKienGia');
          // console.log(danhsachSuKienGia);
          this.dsSuKienGia = danhsachSuKienGia;
        });
        console.log('danhsachSuKienGia - Trong else', this.dsSuKienGia);
      }
    });
  }

  preventBackBtton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  }

  @HostListener('document:keydown', ['$event'])
  // @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event.keyCode);
    switch (event.keyCode) {
      case 116:
        event.returnValue = false;
        return false;
      case 82:
        if (event.ctrlKey) {
          event.returnValue = false;
          return false;
        }
      case 189:
      case 109:
      case 229:
        event.returnValue = false;
        return false;
      // case 8:
      // case 46:
      //     // || !this.checkPagePayment_Voucher || !this.checkPageCustomer
      //   if (!!this.checkAmount  ) {
      //     if (!this.checkPagePayment_CreditCard ) {
      //       event.returnValue = false;
      //       return false;
      //     }
      //     event.returnValue = false;
      //     return false;
      //   }

    }
    //if (this.checkPageCustomer === false && this.checkPageFind === false &&
    //  this.checkAmount === false && this.checktemplateBill === false &&
    //  this.checkPageOther === false && this.isValidCheckEnter === true &&
    //  this.checktemplatePrintBill === false && this.checkPage_ReturnITem === false &&
    //  this.checkPageCamera === false && this.checkPageCamera_New === false)
    if (!this.checkSearchPrice_Item && !this.checkPageFind &&
      !this.checkPageCamera_New && !this.checkPage_ManyItems &&
      !this.checkPagePrice_Item && !this.checkPage_ReturnITem &&
      !this.checkPageE_Invoice && !this.checktemplatePrintBill &&
      !this.checktemplateBill && !this.isCheckPageHelp_Home &&
      !this.checkPageCamera && !this.checkPageOther &&
      !this.checkPageCustomer && this.isValidCheckEnter) {
      if (event.keyCode === 13) {
        if (this.mr !== undefined) {
          this.closeModal();
        }
        this.submitInput(this.valueInput);
        this.valueInput = '';
      } else {
        this.valueInput += event.key;
      }
    } else
      //if (this.checkPageFind === false && this.checkPageOther === false
      //&& this.checkAmount === false && this.checktemplateBill === false
      //&& this.isValidCheckEnter === true && this.checktemplatePrintBill === false && this.checkPage_ReturnITem === false && this.checkPageCamera === false && this.checkPageCamera_New === false)
      if (!this.checkSearchPrice_Item && !this.checkPageFind &&
        !this.checkPageCamera_New && !this.checkPage_ManyItems &&
        !this.checkPagePrice_Item && !this.checkPage_ReturnITem &&
        !this.checkPageE_Invoice && !this.checktemplatePrintBill &&
        !this.checktemplateBill && !this.isCheckPageHelp_Home &&
        !this.checkPageCamera && !this.checkPageOther &&
        this.checkPageCustomer && this.isValidCheckEnter) {
        if (this.flag_nhapkh !== true && this._isFocusPayment !== true) {
          if (event.keyCode === 13) {
            this.submitCustomer_hieuth(this.valueContentError);
            this.valueNumber = '';
          } else {
            this.valueNumber += event.key;
          }
        }
      } else if (this.checkAmount === true) {
        if (event.keyCode === 109 || event.keyCode === 189 || event.keyCode === 229) {
          event.returnValue = false;
          return false;
        }
        else {
          if (event.keyCode === 13) {
            this.submitAmount(this.dtCartProduct.MaHH, this.dtCartProduct.Stt);
          }
        }
      }
      else if (this.checkSearchPrice_Item) {
        if (this.flag_nhapSrcPrc !== true && this._isFocusPayment !== true) {
          if (event.keyCode === 13) {
            this.findPriceItem(this.contentError);
            this.codePriceItem = '';
          } else {
            this.codePriceItem += event.key;
          }
        }
        //if (event.keyCode === 13) {
        //  this.findPriceItem(this.contentError);
        //} else {
        //  //this.codePriceItem += event.key;
        //}
      }
    // if(this.checktemplatePrintBill === true){
    //    if (event.keyCode === 13) {
    //     this.eventPrintBillAgain(this.contentError);
    //   }
    // }
    // if (this.checkPageCustomer === false && this.checkPageFind === false && this.checktemplatePrintBill === false
    //   && this.checkPageOther === false && this.isValidCheckEnter === true ) {
    //   if (event.keyCode === 13) {
    //     this.submitInput(this.valueInput);
    //     this.valueInput = '';
    //   } else {
    //     this.valueInput += event.key;
    //   }
    // } else if (this.checkPageFind === false && this.checkPageOther === false && this.checktemplatePrintBill === false
    //   && this.isValidCheckEnter === true) {
    //   if (this.flag_nhapkh !== true && this._isFocusPayment !== true) {
    //     if (event.keyCode === 13) {
    //       this.submitCustomer_hieuth(this.valueContentError);
    //       this.valueNumber = '';
    //     } else {
    //       this.valueNumber += event.key;
    //     }
    //   }
    // } else if (this.checkAmount === false) {
    //   if (event.keyCode === 109 || event.keyCode === 189 || event.keyCode === 229) {
    //     event.returnValue = false;
    //     return false;
    //   }
    // }
  }

  connecttoHub() {
    this.http.get('manifest.json', { responseType: 'json' }).subscribe(async name => {
      const urlSignalR: string = await name['config_signalr'];
      // const urlTPA_UID = urlTPA.replace(':uid', uid);
      if (urlSignalR != '' || urlSignalR == null) {
        const urlSignalR_Hub = urlSignalR + '/DataHub';
        const connection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.Debug)
          .withUrl(urlSignalR_Hub + "?userID=" + this.dtQBan.MaQuay
            //, {
            //  skipNegotiation: true,
            //  transport: signalR.HttpTransportType.LongPolling
            //}
          )
          .withAutomaticReconnect()
          .build();

        connection.start().then(function () {
          console.log('SignalR Connected!');
        }).catch(function (err) {
          return console.error(err.toString());
        });

        connection.on("PushMessageClient", (sender: string, content: string, hid: string) => {
          let content_obj: Noti_Message = JSON.parse(content);
          if (content_obj.Type == 1 && content_obj.SubType == 1) {
            localStorage.setItem('_updItems', 'true');
            window["TPCGoWV"].DayThongBao('TOPOS GO! Thông báo', 'Có cập nhật hàng hóa mới!');
          }
          else if (content_obj.Type == 3 && content_obj.SubType == 1) {
            window["TPCGoWV"].DayThongBao('TOPOS GO! Thông báo', 'Yêu cầu đăng xuất từ Admin!');
          }
          console.log(content_obj)
        });
      }
    });

  }


  ngOnInit(): void {

    this.manager = new NhanVien();
    this.manager.TenDangNhap = "";
    this.manager.MatKhau = "";

    var height = window.innerHeight;
    var width = window.innerWidth;
    this.metaService.updateTag({
      name: 'viewport',
      content: `height=${height}px, width=${width}px, initial-scale=1.0`
    },
      `name='viewport'`
    );
    window.addEventListener('beforeunload', (event) => {
      return false;
    });
    this.preventBackBtton();
    this.minOffline = 0;
    setInterval(this.KiemTra_KetNoi, this.intervalTime);
    setInterval(() => {
      if (window.navigator.onLine === false) {
        if (this.minOffline === undefined || this.minOffline === NaN) {
          this.minOffline = 0;
        }
        this.minOffline += 1;
      }
    }, this.intervalTime);
    setInterval(() => {
      if (this.today !== Date.now()) {
        this.today = Date.now();
      } else {

      }
    }, 10000);

    //"8934868149576"
    //setInterval(() => { this.onCodeResult("8934868149576",this.contentError); }, 20000);
    setInterval(() => { this.setCheckAllBill_AfterOffline(); }, 10000);
    this.getDataRefresh();
    // this.setNumberMaxBill();
    // const getcurHD = localForage.getItem('_curHD').then((result: string) => JSON.parse(result));
    // if (!getcurHD) {
    this.getNumberMaxBill();
    // }
    this.getBg_Color();
    this.uploadFileService.getFileName()
      .then((res: Logo) => {
        console.log(res);
        this.logo.lg_content = res.lg_content;
        this.logo.lg_overall = res.lg_overall;
        this.logo.lg_start = res.lg_start;
        // console.log(this.logo.lg_content);
        // console.log(this.logo.lg_overall);
        // console.log(this.logo.lg_start);
        this.offlineService.imgLoad(this.logo.lg_overall)
          .then((res: any) => {
            const imgURL = window.URL.createObjectURL(res[0]);
            this.urllogoKH = imgURL;
          });
        console.log('logoKH ' + this.urllogoKH);
        this.imageUrlToBase64(this.url + this.logo.lg_overall)
          .then((result: string) => this.imgKH_b64 = result);


        this.offlineService.imgLoad(this.logo.lg_content)
          .then((res: any) => {
            const imgURL = window.URL.createObjectURL(res[0]);
            this.urllogotopos = imgURL;
          });
        // console.log('logotopos ' + this.urllogotopos);
        // this.offlineService.findImages();
      });

    const now = moment().valueOf();
    const time = moment().endOf('day').valueOf();
    let numberTime = time - now;
    // console.log(time);
    // console.log(numberTime);
    if (numberTime < 0) {
      numberTime += 86400000;
    }
    setInterval(() => {
      this.Logout();
      clearInterval(1);
    }, numberTime);
    this.scrollToBottom();
    this.connecttoHub();
    const tngaytruoc = moment();
    const NgayTruoc = tngaytruoc.format('DD');
    var s = IntervalObservable.create(30000)
      .subscribe(async () => {
        console.log('Có chạy vào đây !!');
        const tngaysau = moment();
        const NgaySau = tngaysau.format('DD');
        if (NgayTruoc != NgaySau) {
          console.log('Có chạy vào check ngày !!');
          if (window.navigator.onLine === true) {
            this.Force_UpdateItem();
            await this.Force_Logout();
            if (s) {
              console.log('Chạy vào stop')
              s.unsubscribe();
            }
          }
        }
      });
  }

  VietTat_TenNhanVien(tennv: string) {
    var str = tennv;
    //var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    var matches = str.match(/(?:\s|^)(\S)/g); // ['J','S','O','N']
    matches.splice(matches.length - 1, 1);
    matches = matches.map(s => s.trim());
    var acronym = matches.join('.'); // JSON
    var words = str.split(' ');
    return acronym + '.' + words[words.length - 1].trim();
  }

  async Cashin_DauCa() {
    var data_cashin: any;
    await localForage.getItem('_cashin').then((result: any) => {
      data_cashin = JSON.parse(result);
    });
    if (data_cashin == null || data_cashin == undefined) {
      this.mr = this.modalService.open(this.contentCashin, { centered: true, backdrop: 'static', keyboard: false });
      //document.getElementById('cashin_input').focus();
      //await this.mr.result.then((result) => {
      //  if (result.toString() == 'true') {         
      //  }
      //});
    }
  }

  async imageUrlToBase64(urL: string) {
    console.log("Downloading image...");
    var res = await fetch(urL);
    var blob = await res.blob();

    const result = await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })

    return result;
  }

  Submit_cashin() {
    if (this.cashin_Amount > 0) {
      const t = moment();
      const s = t.format('HH:mm DD/MM/YYYY');
      localForage.setItem('_cashin', JSON.stringify({ MaNV: this.user.MaNV, NgayGioNhap: s, SoTienCashIn: this.cashin_Amount })).then();
      var cin = new Cashin();
      cin.MaCH = this.dtQBan.MaCH;
      cin.MaQuay = this.dtQBan.MaQuay;
      cin.MaNV = this.user.MaNV;
      cin.NgayGioNhap = s;
      cin.GiaTri = this.cashin_Amount;
      this.cashService.SetCashIn(cin);
      this.closeModal();
    }
    else {
      this.closeModal();
      this.messageError = "Tiền nhập đầu ca không được bằng 0";
      this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
      this.mr.result.then(x => {
        this.closeModal();
        this.mr = this.modalService.open(this.contentCashin, {
          centered: true, backdrop: 'static', keyboard: false
        });
      });
    }
  }

  async getDataRefresh() {
    const now = new Date();
    // if (localStorage.getItem('_curHD')) {
    const getcurHD = await localForage.getItem('_curHD').then((result: string) => JSON.parse(result));
    if (getcurHD) {
      // const curHD: HoaDon = JSON.parse(localStorage.getItem('_curHD'));
      let curHD: HoaDon;
      // const  = await localForage.getItem('_curHD').then((result: any) => {
      //   curHD = JSON.parse(result);
      // });
      curHD = getcurHD;
      this.numberHD = curHD.STTHD;
      console.log(curHD);
      this.order = await {
        CTHoaDons: curHD.CTHoaDons,
        HoaDonID: curHD.HoaDonID,
        LoaiHD: curHD.LoaiHD,
        MaKHTV: curHD.MaKHTV,
        MaNV: curHD.MaNV,
        MaQuay: curHD.MaQuay,
        MaCH: this.dtQBan.MaCH,
        MaHD: curHD.MaHD,
        NgayHD: now,
        STTHD: curHD.STTHD,
        TongTien: curHD.TongTien,
        intoMoney: curHD.intoMoney,
        GhiChu: curHD.GhiChu,
        //printBill: this.order.printBill,
        printWaitBill: this.order.printWaitBill
      };
      this.billNotes = curHD.GhiChu;
      if (this.order.CTHoaDons) {
        this.listCart = await this.order.CTHoaDons;
        this.getInto();
      }
    } else {
    }
    // if (localStorage.getItem('_curHDDoi')) {
    const getCurHDDoi = await localForage.getItem('_curHDDoi').then((result: string) => JSON.parse(result));
    if (getCurHDDoi) {
      // const curHDDoi: Array<HoaDon> = JSON.parse(localStorage.getItem('_curHDDoi'));
      let curHDDoi: Array<HoaDon> = new Array<HoaDon>();
      // await localForage.getItem('_curHDDoi').then((result: any) => {
      //   curHDDoi = JSON.parse(result);
      // });
      curHDDoi = getCurHDDoi;
      console.log(curHDDoi);
      curHDDoi.forEach(async (hd: HoaDon) => {
        const hddoi: HoaDon = await {
          CTHoaDons: hd.CTHoaDons,
          HoaDonID: hd.HoaDonID,
          LoaiHD: hd.LoaiHD,
          MaKHTV: hd.MaKHTV,
          KHTV: hd.KHTV,
          MaNV: hd.MaNV,
          MaQuay: hd.MaQuay,
          MaCH: this.dtQBan.MaCH,
          MaHD: hd.MaHD,
          NgayHD: now,
          STTHD: hd.STTHD,
          TongTien: hd.TongTien,
          intoMoney: hd.intoMoney,
          //printBill: this.order.printBill,
          printWaitBill: this.order.printWaitBill
        };
        this.orderWait.push(hddoi);
      });
    }
    const getcurHDTong = await localForage.getItem('_curHDTong').then((result: any) => JSON.parse(result));
    if (getcurHDTong) {
      // const curHDTong: Array<HoaDon> = JSON.parse(localStorage.getItem('_curHDTong'));
      let curHDTong: Array<HoaDon> = new Array<HoaDon>();
      curHDTong = getcurHDTong;
      console.log(curHDTong);
      let numberHD = 0;
      curHDTong.forEach(async (hd: HoaDon) => {
        const hdTong: HoaDon = await {
          CTHoaDons: hd.CTHoaDons,
          HoaDonID: hd.HoaDonID,
          LoaiHD: hd.LoaiHD,
          MaKHTV: hd.MaKHTV,
          MaNV: hd.MaNV,
          MaQuay: hd.MaQuay,
          MaCH: this.dtQBan.MaCH,
          MaHD: hd.MaHD,
          NgayHD: now,
          STTHD: hd.STTHD,
          TongTien: hd.TongTien,
          intoMoney: hd.intoMoney,
          GhiChu: hd.GhiChu,
          //printBill: this.order.printBill,
          printWaitBill: this.order.printWaitBill
        };
        if (numberHD < hd.STTHD) {
          numberHD = hd.STTHD;
        }
        this.listHD_Tong.push(hdTong);
        // if (!getcurHD){
        if (this.numberHD === 0 || this.numberHD === null) {
          this.numberHD = numberHD + 1;
        }
        // }
      });
    }
    // if (localStorage.getItem('_customer')) {
    const getCustomer = await localForage.getItem('_customer').then((result: string) => JSON.parse(result));
    if (getCustomer) {
      // const customer: KhachHang = JSON.parse(localStorage.getItem('_customer'));
      let customer: KhachHang = new KhachHang();
      // await localForage.getItem('_customer').then((result: any) => {
      //   customer = JSON.parse(result);
      // });
      customer = getCustomer;
      console.log(customer);
      this.customer = {
        MaKHTV: customer.MaKHTV,
        TenKH: customer.TenKH,
        Diem: customer.Diem,
        MaCapDo: customer.MaCapDo,
        TenCapDo: customer.TenCapDo
      };
      this.apDungLaiSuKienGia(this.order);
    }

    const dataQR = JSON.parse(localStorage.getItem('_dataQR'));
    if (dataQR) {
      this.payBill.push(dataQR);
      this.openPayment(this.contentPayment, this.contentError);
    }
    const dataPoint = JSON.parse(localStorage.getItem('_dataPoint'));
    if (dataPoint) {
      this.payBill.push(dataPoint);
      this.openPayment(this.contentPayment, this.contentError);
    }
  }
  async getPayments() {
    const cuaHang: NhanVien = JSON.parse(localStorage.getItem('_dtQBan'));
    await this.billService.getPayments(cuaHang[0].MaCH)
      .then((data: Array<HTTT>) => {
        data.forEach(element => {
          this.hinhThucThanhToans.push(element);
        });
        console.log(this.hinhThucThanhToans);
        this.selectedValue = data[0];
      })
      .catch(err => console.log(err));
  }

  // Trí thêm phần đồng bộ Sự Kiện Giá
  async GetAllSuKienGia(MaCH: string) {
    await this.sukiengiaService.getSuKienGia(MaCH)
      .then(result => {
        console.log('lấy dữ liệu sự kiện giá thành công');
        this.dsSuKienGia = result;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getAllProduct() {
    this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
    const qBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'))[0];
    console.log('qBan');
    console.log(qBan);
    this.GetAllSuKienGia(qBan.MaCH);
    await this.productService.getProduct(qBan.MaKhuVuc)
      .then((result: Array<HangHoa>) => {
        if (result) {
          result.forEach(element => {
            const product: HangHoa = {
              HangHoaID: element.HangHoaID,
              MaHH: element.MaHH,
              SKU: element.SKU,
              GiaBanLe: element.GiaBanLe,
              TenHH: element.TenHH,
              VATDauRa: element.VATDauRa,
              DonViTinh: element.DonViTinh,
              checked: false,
              MaKhuVuc: element.MaKhuVuc
            };
            this.products.push(product);
          });
          this.closeModal();
          this.messageNoti = "Đồng bộ danh mục thành công!";
          this.modalService.open(this.contentNoti, { centered: true, backdrop: 'static', keyboard: false });
          return;
        }
      })
      .catch(err => {
        this.closeModal();
        console.log(err);
        this.messageError = "Đồng bộ danh mục thất bại! Vui lòng refresh để thử lại";
        this.openMessageError(this.contentError);
      });
  }

  // Xử lý lazyloading Tìm hàng hóa
  ScrollDownFindItem() {
    const start = this.sum;
    this.sum += 50;
    this.appendItemsDown(start, this.sum);
    if (this.sum < this.products.length) {
      const start = this.sum;
      this.sum += this.onepartten_product;
      this.appendItemsDown(start, this.sum);
    } else {
      return;
    }
  }

  appendItemsDown(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      if (i < this.products.length) {
        this.FindProducts.push(this.products[i]);
      }
    }
  }



  async callPageHelp() {
    if (window.navigator.onLine === true) {
      await this.LoadPageHelp();
      if (this.isCheckPageHelp_Home !== true) {
        this.isFirstTime_LoadHelp = false;
      } else {
        this.isFirstTime_LoadHelp = true;
      }
    }
    else {
      this.messageError = 'Đang trong trạng thái offline, vui lòng thử lại sau!';
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
  }

  async LoadPageHelp() {
    let nameHtml: string;
    this.helppart = null;
    this.viewContent = null;
    if (this.checkPageCamera) {
      // nameHtml = 'tabHelpCamera.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'begincamera';
    } else if (this.checkPageCustomer) {
      // nameHtml = 'tabHelpCustomer.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'begincustomer';
    } else if (this.checkPageFind) {
      // nameHtml = 'tabHelpFind.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'beginfind';
    } else if (this.checkPageOther) {
      // nameHtml = 'tabHelpOther.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'beginother';
    } else if (this.checktemplateBill) {
      // nameHtml = 'tabHelpBillRecovery.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'beginbillrecovery';
    } else {
      // nameHtml = 'tabHelpHome.html';
      nameHtml = 'tabHelp.html';
      this.helppart = 'beginhome';
    }
    if (this.valueNamePage === '') {
      this.valueNamePage = nameHtml;
      this.CheckPageHelp(this.valueNamePage);
    } else {
      this.CheckPageHelp(this.valueNamePage);
      this.valueNamePage = '';
    }
    const headers: HttpHeaders = new HttpHeaders({ 'Accept': 'text/html' });
    await this.http.get('assets/template/' + nameHtml, { headers: headers, responseType: 'text' }).subscribe(data => {
      this.viewContent = this.sanitized.bypassSecurityTrustHtml(data);

    });
    this.isCheckPageHelp_Home = !this.isCheckPageHelp_Home;
  }

  loadtoanchor() {

    const el = document.getElementById(this.helppart);
    el.scrollIntoView({ behavior: 'smooth' });
  }
  CheckPageHelp(name: string) {
    if (name === 'tabHelpCamera.html') {
      this.checkAllPage('Page_Camera');
    } else if (name === 'tabHelpCustomer.html') {
      this.checkAllPage('Page_Customer');
    } else if (name === 'tabHelpFind.html') {
      this.checkAllPage('Page_Find');
    } else if (name === 'tabHelpOther.html') {
      this.checkAllPage('Page_Other');
    } else if (name === 'tabHelpBillRecovery.html') {
      this.checkAllPage('Page_Order_Wait');
    } else {
      this.checkAllPage('');
    }
  }

  async getLengthHD() {
    if (this.listHD_Tong.length === 0) {
      this.numberHD = 1;
    } else {
      let number = 0;
      await this.listHD_Tong.forEach(x => {
        if (x.STTHD > number) {
          number = x.STTHD;
        }
      });
      this.numberHD = number + 1;
    }
    this.order = new HoaDon(this.listHD_Tong);
    this.order.CTHoaDons = null;
    this.order.HoaDonID = uuid();
    this.order.MaQuay = this.dtQBan.MaQuay;
    this.order.MaCH = this.dtQBan.MaCH;
    this.order.TongTien = 0;
    this.order.STTHD = this.numberHD;
    this.billNotes = '';
    const t = moment();
    const s = t.format('DDMMYY');
    this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0'); /*Thêm ngày 09062022*/
    this.billService.saveBillRefresh(this.order);
    console.log(this.order);
    console.log(this.numberHD);
  }

  async submitInput(value: string) {
    this.valueInput = value;
    if (this.valueInput != null) {
      var MaPLU = "";
      console.log(this.valueInput.substring(0, 3));
      if (this.valueInput.substring(0, 2) == "29") {
        MaPLU = this.valueInput.substring(2, 7);
      } else if (this.valueInput.substring(0, 3) === "029") {
        MaPLU = this.valueInput.substring(3, 8);
      } else if (this.valueInput.substring(0, 6) === "000000") {
        MaPLU = this.valueInput.substring(8, 13);
      }
      let soLuongCuaHangHoaPLU = 1;
      let index: HangHoa = new HangHoa();
      if (MaPLU != "") {
        index = this.products.find(x => x.PLU === MaPLU);
      }
      else {
        index = this.products.find(x => x.MaHH === this.valueInput.toString());
      }
      if (this.valueInput.substring(0, 2) == "29" && MaPLU !== "") {
        let catSoLuongCuaHangHoaPLU: any = this.valueInput.substring(7, 12);
        soLuongCuaHangHoaPLU = catSoLuongCuaHangHoaPLU / 1000;
      }
      else if (this.valueInput.substring(0, 3) === "029" && MaPLU !== "" || this.valueInput.substring(0, 5) === "000000" && MaPLU !== "") {
        soLuongCuaHangHoaPLU = soLuongCuaHangHoaPLU;
      }
      //if (index.PLU == MaPLU) {
      //  let catSoLuongCuaHangHoaPLU: any = this.valueInput.substring(7, 12);
      //  soLuongCuaHangHoaPLU = catSoLuongCuaHangHoaPLU / 1000;
      //}
      //else {
      //  soLuongCuaHangHoaPLU = soLuongCuaHangHoaPLU;
      //}
      if (index && this.valueInput !== '') {
        if (index.ChoChinhGia === true) {
          this.price0Item = index;
          let slnhap = 1;
          if (!isNullOrUndefined(this.valueQuanlity_PageCamera)) {
            slnhap = this.valueQuanlity_PageCamera;
          }

          await this.show0PriceItem().then((res: boolean) => {
            if (res) {
              if (this.listCart == null) {
                let CartNull: CTHoaDon = {
                  HangHoaID: index.HangHoaID,
                  VATDauRa: index.VATDauRa,
                  Stt: 1,
                  HinhAnh: index.HinhAnh,
                  MaHH: index.MaHH,
                  TenHH: index.TenHH,
                  DGBan: this.priceadd,
                  DGBanCK: this.priceadd,
                  SoLuong: slnhap,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: index.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: index.MaNCC
                };
                this.SuKienGia(CartNull, index);
                this.cart.push(CartNull);
                this.listCart = this.cart;
                this.valueInput = null;
                this.getInto();
              } else {
                const length = this.listCart.length + 1;
                let Cart: CTHoaDon = {
                  VATDauRa: index.VATDauRa,
                  HangHoaID: index.HangHoaID,
                  Stt: length,
                  HinhAnh: index.HinhAnh,
                  MaHH: index.MaHH,
                  TenHH: index.TenHH,
                  DGBan: this.priceadd,
                  DGBanCK: this.priceadd,
                  SoLuong: slnhap,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: index.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: index.MaNCC
                };
                this.SuKienGia(Cart, index);
                this.listCart.push(Cart);
              }
              this.getInto();

              this.order.CTHoaDons = this.listCart;
              this.order.TongTien = this.total;
              this.order.TienCK = this.order.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
              this.billService.saveBillRefresh(this.order);
              this.priceadd = 1;
              this.price0Item = null;
            }
          })
        }
        else {

          if (this.listCart == null) {
            let cartNull: CTHoaDon = {
              HangHoaID: index.HangHoaID,
              VATDauRa: index.VATDauRa,
              Stt: 1,
              HinhAnh: index.HinhAnh,
              MaHH: index.MaHH,
              TenHH: index.TenHH,
              DGBan: index.GiaBanLe,
              DGBanCK: index.GiaBanLe,
              SoLuong: soLuongCuaHangHoaPLU,
              ChietKhau: 0,
              TienCK: 0,
              TyLeCK: 0,
              TienCKHD: 0,
              TyLeCKHD: 0,
              SKU: index.SKU,
              NgayGioQuet: this.GetCurTime_UTC(),
              MaNCC: index.MaNCC
            };
            this.SuKienGia(cartNull, index);
            this.cart.push(cartNull);
            this.listCart = this.cart;
            this.valueInput = null;
            this.getInto();
          } else {
            const indexCart: CTHoaDon = this.listCart.find(x => x.MaHH === index.MaHH && index.GiaBanLe == x.DGBan);
            if (indexCart) {
              const i = this.listCart.indexOf(indexCart);
              //var soluongbef = this.listCart[i].SoLuong;
              /*this.listCart[i].SoLuong = this.listCart[i].SoLuong + 1;*/
              this.listCart[i].SoLuong = this.listCart[i].SoLuong + soLuongCuaHangHoaPLU;
              //this.listCart[i].TienCK = (this.listCart[i].TienCK / soluongbef) ;
              this.listCart[i].ChietKhau = this.listCart[i].TienCK * this.listCart[i].SoLuong;

            } else {
              const length = this.listCart.length + 1;
              let cart: CTHoaDon = {
                VATDauRa: index.VATDauRa,
                HangHoaID: index.HangHoaID,
                Stt: length,
                HinhAnh: index.HinhAnh,
                MaHH: index.MaHH,
                TenHH: index.TenHH,
                DGBan: index.GiaBanLe,
                DGBanCK: index.GiaBanLe,
                SoLuong: soLuongCuaHangHoaPLU,
                ChietKhau: 0,
                TienCK: 0,
                TyLeCK: 0,
                TienCKHD: 0,
                TyLeCKHD: 0,
                SKU: index.SKU,
                NgayGioQuet: this.GetCurTime_UTC(),
                MaNCC: index.MaNCC
              };
              this.SuKienGia(cart, index);
              this.listCart.push(cart);
            }
            this.valueInput = null;
            this.getInto();
          }
          this.order.CTHoaDons = this.listCart;
          this.order.TongTien = this.total;
          this.order.TienCK = this.order.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
          this.billService.saveBillRefresh(this.order);
        }

      } else {
        this.messageError = 'Mã hàng không tồn tại!';
        this.mr = this.modalService.open(this.contentError, { centered: true });
        this.valueInput = null;
      }
    }
    this.cart = [];
    console.log(this.order);
  }

  round(num, decimalPlaces = 0) {
    var p = Math.pow(10, decimalPlaces);
    var n = (num * p) * (1 + Number.EPSILON);
    return Math.round(n) / p;
  }


  getInto() {
    this.intoMoney = 0;
    this.total = 0;
    this.discount = 0;
    this.totaldiscount_HD = 0;
    if (this.listCart != undefined) {
      this.listCart.forEach(x => {
        this.intoMoney = this.round((Math.abs(x.SoLuong) * x.DGBan) + this.intoMoney, 2);
        this.discount = this.round(x.ChietKhau + this.discount, 2);
        this.totaldiscount_HD += this.round((x.SoLuong * x.TienCKHD), 2) + this.round((x.ChietKhau), 2);
      });
      //this.total_wo_discount = this.intoMoney;
      this.total = this.round(this.intoMoney - this.discount, 2);
    }
  }
  setAmount(id: string, stt: number, contentError) {
    const index = this.listCart.find(x => x.MaHH === id && x.Stt === stt);
    if (!index) {
      this.messageError = 'Sản phẩm hiện không có trong giỏ hàng!';
      this.openMessageError(contentError);
    } else {
      console.log("this.checkAmount" + this.checkAmount)
      this.checkAmount = !this.checkAmount;
      this.checkPageFind = false;
      this.finddefault = false;
      this.findresult = false;
      this.checkfind = false;
      this.number = index.SoLuong;
      this.dtCartProduct = index;
    }
  }
  cancelAmount() {
    this.checkAmount = !this.checkAmount;
  }

  up() {
    if (this.number < 999) {
      this.number = this.number + 1;
    } else {
      return;
    }
  }
  down() {
    if (this.number > 0) {
      const kq = this.number - 1;
      if (kq <= 1) {
        this.number = 1;
      } else {
        this.number = this.number - 1;
      }
    }
  }

  async show0PriceItem(): Promise<boolean> {
    var checked_till = false;
    this.mr = await this.modalService.open(this.contentPriceInput, { centered: true, backdrop: 'static' });
    await this.mr.result.then((result) => {
      if (result.toString() == 'true') {
        this.closeModal();
        checked_till = true;
      }
    });
    return checked_till;
  }


  async showConfirmTillKey(): Promise<boolean> {
    var checked_till = false;
    this.mr = await this.modalService.open(this.contentConfirmTillKey, { centered: true, backdrop: 'static' });
    await this.mr.result.then((result) => {
      if (result.toString() == 'true') {
        this.closeModal();
        this.authenticationService.check_manager(this.manager.TenDangNhap, this.manager.MatKhau)
          .then((result: any) => {
            checked_till = true;
            this.manager.TenDangNhap = "";
            this.manager.MatKhau = "";
          })
          .catch(error => {
            this.messageError = error;
            this.closeModal();
            this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
            checked_till = false; // chút xíu sửa lại thành false
            this.manager.TenDangNhap = "";
            this.manager.MatKhau = "";
          });
      }
    });
    return checked_till;
  }


  async showInputQuanty(): Promise<boolean> {
    var checked_till = false;
    this.mr = await this.modalService.open(this.contentInputQuantity, { centered: true, backdrop: 'static' });
    document.getElementById('scan_quantity').focus();
    await this.mr.result.then((result) => {
      if (result.toString() == 'true') {
        this.closeModal();
        checked_till = true;
      }
      else {
        this.scan_quantity = 0;
        this.closeModal();
      }
    });
    return checked_till;
  }

  async deleteProduct(id: string, stt: number) {
    await this.showConfirmTillKey().then((res: boolean) => {
      if (res) {
        const index: CTHoaDon = this.listCart.find(x => x.MaHH === id && x.Stt === stt);
        if (index) {
          const i = this.listCart.indexOf(index);
          this.listCart.splice(i, 1);
          this.getInto();
          this.order.CTHoaDons = this.listCart;
          this.order.TongTien = this.total;
          this.billService.saveBillRefresh(this.order);
          this.cancelAmount();
        }
      }
    });
  }

  submitAmount(id: string, stt: number) {
    if (this.number === null || this.number <= 0) { this.number = 1; }
    if (this.number > 999) { this.number = 999; }
    if (this.number % 1 != 0) {
      const h = this.products.find(x => x.MaHH == id)
      if (h.ChoChinhGia === false) {
        if (h.DonViTinh != "met" && h.DonViTinh != "KG" && h.DonViTinh != "MET") {
          this.messageError = "Hàng hóa đơn vị tính EA không được phép nhập số thập phân! Vui lòng chỉnh sửa số lượng!";
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          return;
        }
      }
    }
    const index: CTHoaDon = this.listCart.find(x => x.MaHH === id && x.Stt === stt);
    console.log(index);
    if (index) {
      const i = this.listCart.indexOf(index);
      let listcartChietKhau = this.listCart[i].ChietKhau / this.listCart[i].SoLuong;
      this.listCart[i].SoLuong = this.number;
      this.listCart[i].ChietKhau = listcartChietKhau * this.number;
      this.getInto();
      this.order.CTHoaDons = this.listCart;
      this.order.TongTien = this.total;
      this.apDungLaiSuKienGia(this.order);
      this.billService.saveBillRefresh(this.order);
      this.cancelAmount();
    }
  }
  eventNumber(value) {
    if (value.target.value == '') {

    } else if (value.target.value > '999') {
      this.number = 999;
    } else if (value.target.value <= '0') {
      this.number = 1;
    }
  }
  async setCheckAllBill_AfterOffline() {
    if (this.minOffline > 0 && window.navigator.onLine === true) {
      const hd: Object[] = [{ status: null, STTHD: null }];
      console.log(this.ListHD);
      // this.save_salebackup();
      const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
      var deCryptDSHD;
      if (getDSHD !== null) {
        deCryptDSHD = this.jwtService.deCryptData(getDSHD);
      }
      else {
        deCryptDSHD = null;
      }
      const ListHD: Array<HD> = JSON.parse(deCryptDSHD);
      console.log(ListHD)
      try {
        if (window.navigator.onLine === true) {
          ListHD.forEach(async x => {
            let obj: Object;
            const _hd: HoaDon = {
              CTHoaDons: x.CTHoaDon,
              HoaDonID: x.HoaDonId,
              LoaiHD: x.LoaiHD,
              MaKHTV: x.MaKHTV,
              MaNV: x.MaNV,
              MaQuay: x.MaQuay,
              MaCH: this.dtQBan.MaCH,
              NgayHD: x.NgayHD,
              MaHD: x.MaHD,
              STTHD: x.STTHD,
              TienCK: x.TongTienCK,
              TienTraKhach: x.TienTraKhach,
              TongTienTraHang: x.TongTienTraHang,
              TongTien: x.TongTien,
              intoMoney: null,
              //printBill: null,
              printWaitBill: null
            }
            let arr_tthd: Array<TTHD> = new Array<TTHD>();
            x.HTThanhToan.forEach((data: HTTTs) => {
              const hhtt: HTTT = {
                DoUuTien: data.DoUuTien,
                MaHinhThuc: data.MaHinhThuc,
                MaNhomThanhToan: data.MaNhomThanhToan,
                MaThe: data.MaThe,
                TenHinhThuc: data.TenHinhThuc,
                TenNhom: data.TenNhom
              }
              const tthd: TTHD = {
                HTTT: hhtt,
                SoTienThanhToanHD: data.SoTienThanhToanHD
              }
              arr_tthd.push(tthd);
            })
            return await this.billService.getCheckBill(x.HoaDonId, x.MaCH)
              .then(async (result: ServerResponse) => {
                if (result.code === 2) {
                  if (x.LoaiHD === 1) {
                    return await this.billService.setBillLogout(_hd, arr_tthd)
                      .then(bool => {
                        if (bool === false) {
                          obj = { status: false, STTHD: x.STTHD };
                          hd.push(obj);
                        }
                      })
                      .catch(err => {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      });
                  } else if (x.LoaiHD === 4) {
                    return await this.billService.cancelBill(_hd)
                      .then(bool => {
                        if (bool === false) {
                          obj = { status: false, STTHD: x.STTHD };
                          hd.push(obj);
                        }
                      })
                      .catch(err => {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      });
                  }
                  else if (x.LoaiHD === 3 || x.LoaiHD === 5) {
                    return await this.billService.setBillLogout_ReturnItems(_hd, arr_tthd)
                      .then(bool => {
                        if (bool === false) {
                          obj = { status: false, STTHD: x.STTHD };
                          hd.push(obj);
                        }
                      })
                      .catch(err => {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      });
                  }
                }
              })
              .catch(err => {
                obj = { status: false, STTHD: x.STTHD };
                hd.push(obj);
              });
          });
        }
        this.minOffline = 0;
        return hd;
      } catch {
        return hd.push({ status: false, STTHD: null });
      }
    }
  }

  async printEndShift(ListHD: Array<HD>) {
    let arr_tthd: Array<TTHD> = new Array<TTHD>();
    ListHD.forEach(async x => {
      x.HTThanhToan.forEach((data: HTTTs) => {
        const hhtt: HTTT = {
          DoUuTien: data.DoUuTien,
          MaHinhThuc: data.MaHinhThuc,
          MaNhomThanhToan: data.MaNhomThanhToan,
          MaThe: data.MaThe,
          TenHinhThuc: data.TenHinhThuc,
          TenNhom: data.TenNhom
        }
        const tthd: TTHD = {
          HTTT: hhtt,
          SoTienThanhToanHD: data.SoTienThanhToanHD
        }
        arr_tthd.push(tthd);
      })
    })
    var result = [];
    arr_tthd.reduce(function (res, value) {
      if (!res[value.HTTT.MaHinhThuc]) {
        res[value.HTTT.MaHinhThuc] = { TenHinhThuc: value.HTTT.TenHinhThuc, SoTienThanhToanHD: 0 };
        result.push(res[value.HTTT.MaHinhThuc])
      }
      res[value.HTTT.MaHinhThuc].SoTienThanhToanHD += value.SoTienThanhToanHD;
      return res;
    }, {});
    await this.GenerateBill_Endshift(ListHD, result);
    //this.GenerateBill();
    this.PrintCart();
  }




  async setCheckAllBill() {
    const hd: Object[] = [{ status: null, STTHD: null }];
    console.log(this.ListHD);
    this.save_salebackup();
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    var deCryptDSHD;
    if (getDSHD !== null) {
      deCryptDSHD = this.jwtService.deCryptData(getDSHD);
    }
    else {
      deCryptDSHD = null;
    }
    const ListHD: Array<HD> = JSON.parse(deCryptDSHD);
    console.log(ListHD)
    //this.printEndShift(ListHD);
    try {
      if (window.navigator.onLine === true) {
        ListHD.forEach(async x => {
          let obj: Object;
          const _hd: HoaDon = {
            CTHoaDons: x.CTHoaDon,
            HoaDonID: x.HoaDonId,
            LoaiHD: x.LoaiHD,
            MaKHTV: x.MaKHTV,
            MaNV: x.MaNV,
            MaQuay: x.MaQuay,
            MaCH: this.dtQBan.MaCH,
            NgayHD: x.NgayHD,
            STTHD: x.STTHD,
            MaHD: x.MaHD,
            TienTraKhach: x.TienTraKhach,
            TienCK: x.TongTienCK,
            TongTien: x.TongTien,
            intoMoney: null,
            //printBill: null,
            printWaitBill: null,
            HDGoc: x.HDGoc,
            TongTienTraHang: x.TongTienTraHang
          }
          let arr_tthd: Array<TTHD> = new Array<TTHD>();
          x.HTThanhToan.forEach((data: HTTTs) => {
            const hhtt: HTTT = {
              DoUuTien: data.DoUuTien,
              MaHinhThuc: data.MaHinhThuc,
              MaNhomThanhToan: data.MaNhomThanhToan,
              MaThe: data.MaThe,
              TenHinhThuc: data.TenHinhThuc,
              TenNhom: data.TenNhom
            }
            const tthd: TTHD = {
              HTTT: hhtt,
              SoTienThanhToanHD: data.SoTienThanhToanHD
            }
            arr_tthd.push(tthd);
          })
          return await this.billService.getCheckBill(x.HoaDonId, x.MaCH)
            .then(async (result: ServerResponse) => {
              if (result.code === 2) {
                if (x.LoaiHD === 1) {
                  return await this.billService.setBillLogout(_hd, arr_tthd)
                    .then(bool => {
                      if (bool === false) {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      }
                    })
                    .catch(err => {
                      obj = { status: false, STTHD: x.STTHD };
                      hd.push(obj);
                    });
                } else if (x.LoaiHD === 3 || x.LoaiHD === 5) {
                  return await this.billService.setBillLogout_ReturnItems(_hd, arr_tthd)
                    .then(bool => {
                      if (bool === false) {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      }
                    })
                    .catch(err => {
                      obj = { status: false, STTHD: x.STTHD };
                      hd.push(obj);
                    });
                } else if (x.LoaiHD === 4) {
                  return await this.billService.cancelBill(_hd)
                    .then(bool => {
                      if (bool === false) {
                        obj = { status: false, STTHD: x.STTHD };
                        hd.push(obj);
                      }
                    })
                    .catch(err => {
                      obj = { status: false, STTHD: x.STTHD };
                      hd.push(obj);
                    });
                }
              }
            })
            .catch(err => {
              obj = { status: false, STTHD: x.STTHD };
              hd.push(obj);
            });
        });
      }
      return hd;
    } catch {
      return hd.push({ status: false, STTHD: null });
    }
  }

  async save_salebackup() {
    // const dsHD = localStorage.getItem('_dsHD'); // test thử cái dưới
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    const dsHD = getDSHD;
    window["TPCGoWV"].LuuFileTXT(dsHD);
    //console.log(dsHD);
    //const blob = await new Blob([dsHD], { type: 'text/plain;charset=utf-8' });
    //const t = moment();
    //const s = t.format('YYYY-MM-DD HH-mm');
    //const filename = this.dtQBan.MaQuay;
    //await saveAs(blob, filename + '_' + s + '.txt');
  }


  async save_salebackup_POS(data: any, quayBan: string, maCQT: string) {
    window["TPCGoWV"].LuuFileTXT_CQT(data, quayBan, maCQT);
  }

  async upload_saleBackup_FTP_CQT(fileNameCQT, maCQT: any) {
    return this.uploadFileService.uploadFile_Sale_FTP(fileNameCQT, maCQT)
      .then(bool => bool)
      .catch(err => false);
  }


  async upload_saleBackup_FTP_CQT_Logout() {
    var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
    var kytu = "";
    // const dsHD = localStorage.getItem('_dsHD'); // test thử cái dưới
    await localForage.getItem('_MaCQT').then((result: any) => TPCQuayBanMaCQT = JSON.parse(result));
    var finalname = TPCQuayBanMaCQT.Register + "_" + TPCQuayBanMaCQT.CQT_Location;
    var socuoinam = TPCQuayBanMaCQT.Year.substring(2, 4);
    if (TPCQuayBanMaCQT.MACQT.toString().length === 1) {
      kytu = "0000" + TPCQuayBanMaCQT.MACQT;
    } else if (TPCQuayBanMaCQT.MACQT.toString().length === 2) {
      kytu = "000" + TPCQuayBanMaCQT.MACQT;
    } else if (TPCQuayBanMaCQT.MACQT.toString().length === 3) {
      kytu = "00" + TPCQuayBanMaCQT.MACQT;
    } else if (TPCQuayBanMaCQT.MACQT.toString().length === 4) {
      kytu = "0" + TPCQuayBanMaCQT.MACQT;
    } else {
      kytu = TPCQuayBanMaCQT.MACQT.toString();
    }
    var strmaCQT = "M1" + "-" + socuoinam + "-" + TPCQuayBanMaCQT.CQT_Location + TPCQuayBanMaCQT.Register + kytu;
    let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + strmaCQT + "";
    return this.uploadFileService.uploadFile_Sale_FTP_MACQT(finalname, data)
      .then(bool => bool)
      .catch(err => false);
  }

  async upload_saleBackup_FTP() {
    // const dsHD = localStorage.getItem('_dsHD'); // test thử cái dưới
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    const dsHD = getDSHD;
    console.log(dsHD);
    const blob = await new Blob([dsHD], { type: 'text/plain;charset=utf-8' });
    const t = moment();
    const s = t.format('YYYY-MM-DD HH-mm');
    const filename = this.dtQBan.MaQuay;
    const finalname = filename + '_' + s;
    return this.uploadFileService.uploadFile_Sale_FTP(finalname, dsHD)
      .then(bool => bool)
      .catch(err => false);
  }

  setCheckOneBill(number: number, bill: HoaDon, paybill: Array<TTHD>, strmaCQT?, TPCQuayBanMaCQT?) {
    if (window.navigator.onLine === true) {
      if (number === 4) {
        return this.billService.cancelBill(bill, strmaCQT, TPCQuayBanMaCQT)
          .then(bool => bool)
          .catch(err => false);
      } else if (number === 1 || number === 3) {
        return this.billService.setBill(bill, paybill, strmaCQT, TPCQuayBanMaCQT)
          .then(bool => bool)
          .catch(err => false);
      }
    } else {
      return this.billService.setBillOffline(bill, paybill)
        .then(result => result)
        .catch(err => false);
    }
  }

  // ----------------------- Trí Thêm
  setCheckOneBill_TraHang(number: number, bill: HoaDon, paybill: Array<TTHD>, strmaCQT?, TPCQuayBanMaCQT?) {
    if (window.navigator.onLine === true) {
      if (number === 4) {
        return this.billService.cancelBill(bill)
          .then(bool => bool)
          .catch(err => false);
      } else if (number === 1 || number === 3 || number === 5) {
        return this.billService.setBill_TraHang(bill, paybill, strmaCQT, TPCQuayBanMaCQT)
          .then(bool => bool)
          .catch(err => false);
      }
    } else {
      return this.billService.setBillOffline(bill, paybill)
        .then(result => result)
        .catch(err => false);
    }
  }

  async setCheckOneBill_SBU(number: number, bill: HoaDon, paybill: Array<TTHD>) {
    var result = false;
    if (window.navigator.onLine === true) {
      if (number === 4) {
        result = await this.billService.cancelBill_SBU(bill)
          .then(bool => true)
          .catch(err => false);
      } else if (number === 1) {
        result = await this.billService.setBill_SBU(bill, paybill)
          .then(bool => true)
          .catch(err => false);
      }
      return result;
    }
    else {
      return false;
    }
  }

  async cancelCart(contentLitmit_CQT, contentError, contentHuyHD) {
    const index_orderwait_temp: any = this.orderWait_temp.find(x => x.HoaDonID === this.order.HoaDonID);
    if (index_orderwait_temp) {
      const index_waitBill_MaCQT = this.Waitbill_MaCQT.find(x => x.HoaDonID === this.order.HoaDonID);
      var strmaCQT = "";
      var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
      var MACQT: MaCQT = new MaCQT();
      var kytu = "";
      MACQT = {
        MaCQT: index_waitBill_MaCQT.MaCQT,
        MaKhuVuc: index_waitBill_MaCQT.MaKhuVuc,
        MaQuay: index_waitBill_MaCQT.MaQuay,
        Nam: index_waitBill_MaCQT.Nam,
        TenQuay: index_waitBill_MaCQT.TenQuay,
        CQT_location: index_waitBill_MaCQT.CQT_location,
        StoreID: index_waitBill_MaCQT.StoreID
      }
      var socuoinam = MACQT.Nam.substring(2, 4)
      if (MACQT.MaCQT.toString().length === 1) {
        kytu = "0000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 2) {
        kytu = "000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 3) {
        kytu = "00" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 4) {
        kytu = "0" + MACQT.MaCQT;
      } else {
        kytu = MACQT.MaCQT.toString();
      }
      // chuyển sang lưu local cho phần này
      strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;

      // Kết thúc phần Trí thêm
      if (await this._checkDate().then(data => data)) {
        this._cancelCartNextDate();
        return null;
      }
      const now = new Date();
      const indexQR = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '013');
      if (indexQR) {
        this.messageError = 'Không thể hủy hóa đơn vì dã thanh toán hình thức Momo!';
        this.openMessageError(contentError);
        return null;
      }
      const indexPoint = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '006');
      if (indexPoint) {
        this.messageError = 'Không thể hủy hóa đơn vì dã thanh toán hình thức Điểm KHTV!';
        this.openMessageError(contentError);
        return null;
      }
      if (this.listCart) {
        this.checkCancelCart = false;
        let hd;
        let isValid: boolean;
        setTimeout(async () => {
          const index: HoaDon = this.listHD_Tong.find(x => this.numberHD === x.STTHD);
          if (index) {
            const i = this.listHD_Tong.indexOf(index);
            this.listHD_Tong[i].NgayHD = now;
            this.listHD_Tong[i].LoaiHD = 4;
            this.listHD_Tong[i].MaQuay = this.dtQBan.MaQuay;
            this.listHD_Tong[i].MaCH = this.dtQBan.MaCH;
            //var ctHD_am: Array<CTHoaDon> = [];
            this.listHD_Tong[i].CTHoaDons.forEach((cthd: CTHoaDon) => {
              cthd.SoLuong = 0;
              //var ct_am: CTHoaDon = {
              //  ChietKhau: cthd.ChietKhau,
              //  SoLuong: -cthd.SoLuong,
              //  DGBan: cthd.DGBan,
              //  DGBanCK: cthd.DGBanCK,
              //  TenHH: cthd.TenHH,
              //  HangHoaID: cthd.HangHoaID,
              //  LoaiVAT: cthd.LoaiVAT,
              //  MaHH: cthd.MaHH,
              //  Method: '',
              //  NgayGioQuet: cthd.NgayGioQuet,
              //  Stt: cthd.Stt,
              //  VATDauRa: cthd.VATDauRa,
              //  TyLeCK: cthd.TyLeCK,
              //  TienCK: cthd.TienCK,
              //  TienCKHD: cthd.TienCKHD,
              //  TyLeCKHD: cthd.TyLeCKHD,
              //  SKU: cthd.SKU,
              //};
              //ctHD_am.push(ct_am);
              //ct_am. = cthd.MaHH;


            });
            //this.listHD_Tong[i].CTHoaDons = this.listHD_Tong[i].CTHoaDons.concat(ctHD_am);
            this.ListHD.push({ HoaDon: this.listHD_Tong[i], TTHD: null });
            this.billService.saveTotalBillRefresh(this.listHD_Tong);
            hd = await this.setCheckOneBill(4, this.listHD_Tong[i], null, strmaCQT, "");
            isValid = hd;
          } else {
            this.order.CTHoaDons = this.listCart;
            var ctHD_am: Array<CTHoaDon> = [];
            this.order.CTHoaDons.forEach((cthd: CTHoaDon) => {
              cthd.SoLuong = 0;

              //var ct_am: CTHoaDon = {
              //  ChietKhau: cthd.ChietKhau,
              //  SoLuong: -cthd.SoLuong,
              //  DGBan: cthd.DGBan,
              //  DGBanCK: cthd.DGBanCK,
              //  TenHH: cthd.TenHH,
              //  HangHoaID: cthd.HangHoaID,
              //  LoaiVAT: cthd.LoaiVAT,
              //  MaHH: cthd.MaHH,
              //  Method: '',
              //  NgayGioQuet: cthd.NgayGioQuet,
              //  Stt: cthd.Stt,
              //  VATDauRa: cthd.VATDauRa,
              //  TyLeCK: cthd.TyLeCK,
              //  TienCK: cthd.TienCK,
              //  TienCKHD: cthd.TienCKHD,
              //  TyLeCKHD: cthd.TyLeCKHD,
              //  SKU: cthd.SKU,
              //};
              //ctHD_am.push(ct_am);
              //ct_am. = cthd.MaHH;


            });
            //this.order.CTHoaDons = this.order.CTHoaDons.concat(ctHD_am);
            this.order.LoaiHD = 4;
            this.order.NgayHD = now;
            this.order.MaNV = this.user.MaNV;
            this.order.STTHD = this.numberHD;
            this.order.TongTien = 0;
            this.order.TienCK = 0;
            const t = moment();
            const s = t.format('DDMMYY');
            this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0'); /*Thêm ngày 09062022*/
            this.listHD_Tong.push(this.order);
            this.billService.saveTotalBillRefresh(this.listHD_Tong);
            this.ListHD.push({ HoaDon: this.order, TTHD: null });
            hd = await this.setCheckOneBill(4, this.order, null, strmaCQT, "");
            isValid = hd;
          }
          if (isValid === true) {
            this.intoMoney = 0;
            this.total = 0;
            //this.total_wo_discount = 0;
            this.discount = 0;
            this.listCart = [];
            this.getLengthHD();
            this.customer = null;
            this.valueNumber = '';
            this.setNumberMaxBill();
            // localStorage.removeItem('_customer');
            localForage.removeItem('_customer');
            await localStorage.removeItem('_dataQR');
            await localStorage.removeItem('_dataPoint');
            // Trí thêm
            if (index_orderwait_temp) {
              const i = this.orderWait_temp.indexOf(index_orderwait_temp);
              this.orderWait_temp.splice(i, 1);
              this.billService.saveWaitingBillLocal(this.orderWait_temp);
            }
            if (index_waitBill_MaCQT) {
              const i = this.Waitbill_MaCQT.indexOf(index_waitBill_MaCQT);
              this.Waitbill_MaCQT.splice(i, 1);
              this.billService.saveWaitingBillLocal_CQT(this.Waitbill_MaCQT);
            }
            // Kết thúc phần Trí thêm
            this.mr = this.modalService.open(contentHuyHD, { centered: true });
          } else if (isValid === false) {
            // this.messageError = 'Hủy Hóa Đơn Thất Bại!';
            this.messageError = 'Hủy Giao Dịch Thất Bại!';
            this.openMessageError(contentError);

          }
          this.checkCancelCart = !this.checkCancelCart;
          //console.log(this.listHD_Tong);
          //console.log(this.listCart);
          //console.log(this.order);
          //console.log(this.orderWait);
        }, 1000);
      } else {
        this.messageError = 'Không có sản phẩm nào ở giỏ hàng!';
        this.openMessageError(contentError);
      }
    } else {
      const Now_Date = moment().format('YYYY-MM-DD');
      let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
      await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
      let _dtQBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
      let tpc_Till: CuaHang_Store_CTQLocation = new CuaHang_Store_CTQLocation();
      let macqt_luutru_bandau: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
      await this.authenticationService.GetStore_CQTLocation(_dtQBan[0].MaQuay)
        .then(result => {
          tpc_Till = {
            CQT_Location: result[0].cqT_Location,
            StoreID: result[0].storeID,
            TillID: result[0].tillID
          }
        });
      await this.authenticationService.getQuayBan_MaCQT(_dtQBan[0].MaQuay)
        .then(result => {
          if (result[0] === null) {
            macqt_luutru_bandau = {
              CQT_Location: tpc_Till.CQT_Location,
              MACQT: macqt_luutru.MaCQT.toString(),
              Register: tpc_Till.TillID,
              Store: tpc_Till.StoreID,
              Update_Date: Now_Date,
              Year: macqt_luutru.Nam
            }
          } else {
            macqt_luutru_bandau = {
              CQT_Location: result[0].maCQT_Location,
              MACQT: result[0].macqt,
              Register: result[0].register,
              Store: result[0].store,
              Update_Date: result[0].update_Date,
              Year: result[0].year
            }
          }
        });
      if (tpc_Till.CQT_Location === macqt_luutru_bandau.CQT_Location) {
        if (macqt_luutru.MaCQT.toString() === "99999") {
          this.mr = this.modalService.open(this.contentLitmit_CQT, { centered: true, backdrop: 'static' })
        } else {
          const t = moment();
          const date = t.format('YYYY-MM-DD');
          var strmaCQT = "";
          var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
          var MACQT: MaCQT = new MaCQT();
          await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
          var kytu = "";
          let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1
          MACQT = {
            MaCQT: MaCQTCongDon,
            MaKhuVuc: MACQT.MaKhuVuc,
            MaQuay: MACQT.MaQuay,
            Nam: MACQT.Nam,
            TenQuay: MACQT.TenQuay,
            CQT_location: MACQT.CQT_location,
            StoreID: MACQT.StoreID
          }
          await localForage.setItem('_MaCQT', JSON.stringify(MACQT))
          var socuoinam = MACQT.Nam.substring(2, 4)
          if (MACQT.MaCQT.toString().length === 1) {
            kytu = "0000" + MACQT.MaCQT;
          } else if (MACQT.MaCQT.toString().length === 2) {
            kytu = "000" + MACQT.MaCQT;
          } else if (MACQT.MaCQT.toString().length === 3) {
            kytu = "00" + MACQT.MaCQT;
          } else if (MACQT.MaCQT.toString().length === 4) {
            kytu = "0" + MACQT.MaCQT;
          } else {
            kytu = MACQT.MaCQT.toString();
          }
          // chuyển sang lưu local cho phần này
          strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
          TPCQuayBanMaCQT = {
            Store: MACQT.StoreID,
            Register: MACQT.MaQuay,
            MACQT: MACQT.MaCQT.toString(),
            Update_Date: date,
            Year: MACQT.Nam,
            CQT_Location: MACQT.CQT_location
          }
          console.log(TPCQuayBanMaCQT)
          console.log(TPCQuayBanMaCQT.MACQT)
          let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + TPCQuayBanMaCQT.CQT_Location + "\n" + strmaCQT + "";
          //this.save_salebackup_POS(data, TPCQuayBanMaCQT.Register, MACQT.CQT_location);
          var fileNameCQT = TPCQuayBanMaCQT.Register + "_" + MACQT.CQT_location
          this.upload_saleBackup_FTP_CQT(fileNameCQT, data)
          // Kết thúc phần Trí thêm
          if (await this._checkDate().then(data => data)) {
            this._cancelCartNextDate();
            return null;
          }
          const now = new Date();
          const indexQR = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '013');
          if (indexQR) {
            this.messageError = 'Không thể hủy hóa đơn vì dã thanh toán hình thức Momo!';
            this.openMessageError(contentError);
            return null;
          }
          const indexPoint = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '006');
          if (indexPoint) {
            this.messageError = 'Không thể hủy hóa đơn vì dã thanh toán hình thức Điểm KHTV!';
            this.openMessageError(contentError);
            return null;
          }
          if (this.listCart) {
            this.checkCancelCart = false;
            let hd;
            let isValid: boolean;
            setTimeout(async () => {
              const index: HoaDon = this.listHD_Tong.find(x => this.numberHD === x.STTHD);
              if (index) {
                const i = this.listHD_Tong.indexOf(index);
                this.listHD_Tong[i].NgayHD = now;
                this.listHD_Tong[i].LoaiHD = 4;
                this.listHD_Tong[i].MaQuay = this.dtQBan.MaQuay;
                this.listHD_Tong[i].MaCH = this.dtQBan.MaCH;
                //var ctHD_am: Array<CTHoaDon> = [];
                this.listHD_Tong[i].CTHoaDons.forEach((cthd: CTHoaDon) => {
                  cthd.SoLuong = 0;
                  //var ct_am: CTHoaDon = {
                  //  ChietKhau: cthd.ChietKhau,
                  //  SoLuong: -cthd.SoLuong,
                  //  DGBan: cthd.DGBan,
                  //  DGBanCK: cthd.DGBanCK,
                  //  TenHH: cthd.TenHH,
                  //  HangHoaID: cthd.HangHoaID,
                  //  LoaiVAT: cthd.LoaiVAT,
                  //  MaHH: cthd.MaHH,
                  //  Method: '',
                  //  NgayGioQuet: cthd.NgayGioQuet,
                  //  Stt: cthd.Stt,
                  //  VATDauRa: cthd.VATDauRa,
                  //  TyLeCK: cthd.TyLeCK,
                  //  TienCK: cthd.TienCK,
                  //  TienCKHD: cthd.TienCKHD,
                  //  TyLeCKHD: cthd.TyLeCKHD,
                  //  SKU: cthd.SKU,
                  //};
                  //ctHD_am.push(ct_am);
                  //ct_am. = cthd.MaHH;


                });
                //this.listHD_Tong[i].CTHoaDons = this.listHD_Tong[i].CTHoaDons.concat(ctHD_am);
                this.ListHD.push({ HoaDon: this.listHD_Tong[i], TTHD: null });
                this.billService.saveTotalBillRefresh(this.listHD_Tong);
                hd = await this.setCheckOneBill(4, this.listHD_Tong[i], null, strmaCQT, TPCQuayBanMaCQT);
                isValid = hd;
              } else {
                this.order.CTHoaDons = this.listCart;
                var ctHD_am: Array<CTHoaDon> = [];
                this.order.CTHoaDons.forEach((cthd: CTHoaDon) => {
                  cthd.SoLuong = 0;

                  //var ct_am: CTHoaDon = {
                  //  ChietKhau: cthd.ChietKhau,
                  //  SoLuong: -cthd.SoLuong,
                  //  DGBan: cthd.DGBan,
                  //  DGBanCK: cthd.DGBanCK,
                  //  TenHH: cthd.TenHH,
                  //  HangHoaID: cthd.HangHoaID,
                  //  LoaiVAT: cthd.LoaiVAT,
                  //  MaHH: cthd.MaHH,
                  //  Method: '',
                  //  NgayGioQuet: cthd.NgayGioQuet,
                  //  Stt: cthd.Stt,
                  //  VATDauRa: cthd.VATDauRa,
                  //  TyLeCK: cthd.TyLeCK,
                  //  TienCK: cthd.TienCK,
                  //  TienCKHD: cthd.TienCKHD,
                  //  TyLeCKHD: cthd.TyLeCKHD,
                  //  SKU: cthd.SKU,
                  //};
                  //ctHD_am.push(ct_am);
                  //ct_am. = cthd.MaHH;


                });
                //this.order.CTHoaDons = this.order.CTHoaDons.concat(ctHD_am);
                this.order.LoaiHD = 4;
                this.order.NgayHD = now;
                this.order.MaNV = this.user.MaNV;
                this.order.STTHD = this.numberHD;
                this.order.TongTien = 0;
                this.order.TienCK = 0;
                const t = moment();
                const s = t.format('DDMMYY');
                this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0'); /*Thêm ngày 09062022*/
                this.listHD_Tong.push(this.order);
                this.billService.saveTotalBillRefresh(this.listHD_Tong);
                this.ListHD.push({ HoaDon: this.order, TTHD: null });
                hd = await this.setCheckOneBill(4, this.order, null, strmaCQT, TPCQuayBanMaCQT);
                isValid = hd;
              }
              if (isValid === true) {
                this.intoMoney = 0;
                this.total = 0;
                //this.total_wo_discount = 0;
                this.discount = 0;
                this.listCart = [];
                this.getLengthHD();
                this.customer = null;
                this.valueNumber = '';
                this.setNumberMaxBill();
                // localStorage.removeItem('_customer');
                localForage.removeItem('_customer');
                await localStorage.removeItem('_dataQR');
                await localStorage.removeItem('_dataPoint');
                this.mr = this.modalService.open(contentHuyHD, { centered: true });
              } else if (isValid === false) {
                // this.messageError = 'Hủy Hóa Đơn Thất Bại!';
                this.messageError = 'Hủy Giao Dịch Thất Bại!';
                this.openMessageError(contentError);

              }
              this.checkCancelCart = !this.checkCancelCart;
              //console.log(this.listHD_Tong);
              //console.log(this.listCart);
              //console.log(this.order);
              //console.log(this.orderWait);
            }, 1000);
          } else {
            this.messageError = 'Không có sản phẩm nào ở giỏ hàng!';
            this.openMessageError(contentError);
          }
        }
      } else {
        this.messageError = 'Vui lòng kết ca để nhập quầy lại.';
        this.openMessageError(contentError);
      }
    }
  }


  async openPayment(contentPayment, contentError) {
    const Now_Date = moment().format('YYYY-MM-DD');
    let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
    await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
    let _dtQBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
    let tpc_Till: CuaHang_Store_CTQLocation = new CuaHang_Store_CTQLocation();
    let macqt_luutru_bandau: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();

    await this.authenticationService.GetStore_CQTLocation(_dtQBan[0].MaQuay)
      .then(result => {
        tpc_Till = {
          CQT_Location: result[0].cqT_Location,
          StoreID: result[0].storeID,
          TillID: result[0].tillID
        }
      });
    await this.authenticationService.getQuayBan_MaCQT(_dtQBan[0].MaQuay)
      .then(result => {
        if (result[0] === null) {
          macqt_luutru_bandau = {
            CQT_Location: tpc_Till.CQT_Location,
            MACQT: macqt_luutru.MaCQT.toString(),
            Register: tpc_Till.TillID,
            Store: tpc_Till.StoreID,
            Update_Date: Now_Date,
            Year: macqt_luutru.Nam
          }
        } else {
          macqt_luutru_bandau = {
            CQT_Location: result[0].maCQT_Location,
            MACQT: result[0].macqt,
            Register: result[0].register,
            Store: result[0].store,
            Update_Date: result[0].update_Date,
            Year: result[0].year
          }
        }
      });
    if (tpc_Till.CQT_Location === macqt_luutru_bandau.CQT_Location) {
      if (macqt_luutru.MaCQT.toString() === "99999") {
        this.mr = this.modalService.open(this.contentLitmit_CQT, { centered: true, backdrop: 'static' })
      } else {
        if (await this._checkDate().then(data => data)) {
          this._cancelCartNextDate();
          return null;
        }
        this.isValidCheckEnter = false;
        if (this.listCart !== undefined) {
          if (this.listCart.length !== 0) {
            if (this.config_Payment === 0) {
              this.mr = this.modalService.open(contentPayment, { centered: true, backdrop: 'static' });
            } else {
              this.checkPagePayment = true;
              this.checkPageHome = false;
              this.checkMenuFooter = false;
            }
          } else {
            // this.messageError = 'Không có hóa đơn nào để thanh toán!';
            this.messageError = 'Không có giao dịch nào để thanh toán!';
            this.openMessageError(contentError);
          }
        } else {
          // this.messageError = 'Không có hóa đơn nào để thanh toán!';
          this.messageError = 'Không có giao dịch nào để thanh toán!';
          this.openMessageError(contentError);
        }
        this.valueInputMoney = null;
        this.valueNumberLabel = 0;
        this.checkPayBill();
        if (this.config_Payment === 0) {
          this.changeCheckMoney();
        } else { this.changeCheckMoney_Payment(); }
        this.apDungLaiSuKienGia(this.order);
        this.getInto();
      }
    } else {
      this.messageError = 'Mã cơ quan thuế vượt quá số lượng.';
      this.openMessageError(contentError);
    } 
  }

  checkPayBill() {
    if (this.payBill.length !== 0) {
      this.payBill = [];
      const dataQR = JSON.parse(localStorage.getItem('_dataQR'));
      if (dataQR) {
        this.payBill.push(dataQR);
      }
      const dataPoint = JSON.parse(localStorage.getItem('_dataPoint'));
      if (dataPoint) {
        this.payBill.push(dataPoint);
      }
      this.setChange_Payment();
    } else {
      this.payBill = [];
    }
  }

  async submitHTTT() {
    if (window.navigator.onLine === false &&
      (this.selectedValue.MaNhomThanhToan === '013' || this.selectedValue.MaNhomThanhToan === '006')) {
      this.messageError = 'Hiện tại đang trong trạng thái offline, bạn không thể thực hiện bằng hình thức thanh toán này!';
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
      return null;
    }
    if (this.selectedValue.MaNhomThanhToan === '201') {
      window["TPCGoWV"].ThanhToanVNPAY_POS(this.order.MaHD, this.total, this.selectedValue.MaHinhThuc);
    } else if (this.selectedValue.MaNhomThanhToan === '202') {
      window["TPCGoWV"].ThanhToanVNPAY_QR(this.order.MaHD, this.total, this.selectedValue.MaHinhThuc);
    }
    this.checkPagePayment = false;
    this.checkMenuFooter_B = false;
    if (this.selectedValue.MaNhomThanhToan === '001') {
      const indexMoney = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
      if (indexMoney) {
        this.valueAll_excMoney = this.valueMoney_All - (indexMoney.SoTienThanhToanHD);
      }
      else {
        this.valueAll_excMoney = this.valueMoney_All;
      }
      this.checkPagePayment_Money = true;
      this.checkMenuFooter_Money = true;
    } else if (this.selectedValue.MaNhomThanhToan === '013') {
      this.checkPagePayment_QR = true;
      this.checkMenuFooter_QR = true;
      this.valueCode_QR = '';
      this.valueReferenceCode_QR = '';
      setTimeout(x => document.getElementById('MomoCode').focus(), 300);
    } else if (this.selectedValue.MaNhomThanhToan === '005') {
      const indexVoucher = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
      if (indexVoucher) {
        this.valueAll_excVoucher = this.valueMoney_All - (indexVoucher.SoTienThanhToanHD);
      }
      else {
        this.valueAll_excVoucher = this.valueMoney_All;
      }
      this.checkPagePayment_Voucher = true;
      this.checkMenuFooter_Voucher = true;
      setTimeout(x => document.getElementById('VoucherCode').focus(), 300);
    } else
      if (this.selectedValue.MaNhomThanhToan === '006') {
        if (this.customer === null || this.customer.MaKHTV === undefined) {
          this.messageError = 'Hiện tại chưa thêm thành viên trên giao dịch này. Không thể thực hiện thanh toán điểm!';
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          this.checkPagePayment = true;
          this.checkMenuFooter_B = true;
          return null;
        }
        if (this.customer.MaKHTV === null || this.customer.MaKHTV === '') {
          this.messageError = 'Hiện tại chưa thêm thành viên trên giao dịch này. Không thể thực hiện thanh toán điểm!';
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          this.checkPagePayment = true;
          this.checkMenuFooter_B = true;
          return null;
        }
        if ((this.customer.MaKHTV !== null || this.customer.MaKHTV !== '') && this.customer.MaCapDo === 'N/A') {
          this.messageError = 'Thông tin KHTV không chính xác nên không thể thành toán với hình thức điểm!';
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          this.checkPagePayment = true;
          this.checkMenuFooter_B = true;
          return null;
        }
        const dataPoint = JSON.parse(localStorage.getItem('_dataPoint'));
        if (dataPoint) {
          this.messageError = 'Bạn đã thanh toán với hình thức này, không thể thanh toán lại!';
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          this.checkPagePayment = true;
          this.checkMenuFooter_B = true;
          return null;
        }
        this.totalPoints = Number(this.customer.Diem);
        const indexMoney = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
        if (indexMoney) {
          this.valueAll_excPoint = this.valueMoney_All - (indexMoney.SoTienThanhToanHD);
        }
        else {
          this.valueAll_excPoint = this.valueMoney_All;
        }
        this.checkPagePayment_Point = true;
        this.checkMenuFooter_Point = true;
      }
      else
        if (this.selectedValue.MaNhomThanhToan === '012') {
          if (this.customer === null || this.customer.MaKHTV === undefined || this.customer.MaKHTV === '') {
            this.messageError = 'Giao dịch này chưa có mã thành viên. Không thể thực hiện thanh toán HouseCharge!';
            this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
            this.checkPagePayment = true;
            this.checkMenuFooter_B = true;
            return null;
          }
          if ((this.customer.MaKHTV !== null || this.customer.MaKHTV !== '') && this.customer.MaCapDo === 'N/A') {
            this.messageError = 'Thông tin KHTV không chính xác nên không thể thành toán với hình thức HouseCharge!';
            this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
            this.checkPagePayment = true;
            this.checkMenuFooter_B = true;
            return null;
          }
          else if ((this.customer.MaKHTV !== null || this.customer.MaKHTV !== '') && this.customer.MaCapDo.trim() === 'HCG') {
            this.totalPoints = Number(this.customer.Diem);
            const indexMoney = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
            if (indexMoney) {
              this.valueMoney_HCG = this.total - this.valueMoney_All;
              this.valueAll_excPoint = this.valueMoney_All - (indexMoney.SoTienThanhToanHD);
            }
            else {
              this.valueAll_excPoint = this.valueMoney_All;
            }
            this.checkPagePayment_HCG = true;
            this.checkMenuFooter_HCG = true;
          }
          else {
            return null;
          }
        }
        else
          if (this.selectedValue.MaNhomThanhToan === '003') {
            this.valueMoney_CreditCard = this.total - this.valueMoney_All;
            this.checkPagePayment_CreditCard = true;
            this.checkMenuFooter_CreditCard = true;
          } else {
            this.checkPagePayment = true;
            this.checkMenuFooter_B = true;
          }
  }

  checkDisabled_Voucher() {
    if (this.vouchers.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  checkDisabled_Money() {
    if (this.valueMoney <= 0) {
      return true;
    } else {
      return false;
    }
  }

  checkDisabled_queryQR() {
    if (this.momo !== undefined) {
      if (this.momo !== null) {
        if (this.momo.self_status !== 0) {
          return false;
        }
        else { return true; }
      }
      else { return true; }
    }
    else {
      return true;
    }
  }


  checkDisabled_confirmQR() {
    if (this.valueReferenceCode_QR !== '' && this._isValisSubmit_QR === false) {
      return false;
    } else {
      return true;
    }
  }

  numberchanged(event: number) {
    if (Number(event) >= 0) {
      this.valueMoney = event;
    }
  }
  numberchanged_Cashin(event: number) {
    if (Number(event) >= 0) {
      this.cashin_Amount = event;
    }
  }

  numberchanged_Point(event: number) {
    if (Number(event) >= 0) {
      if (Number(event) <= Number(this.customer.Diem)) {
        if (Number(event) <= (this.total - this.valueMoney_All)) {
          this.valuePoint = event;
        }
        else {
          this.valuePoint = 0;
        }
      }
      else {
        this.valuePoint = 0;
      }
    }
  }

  inputMoney(item) {
    // if (this.valueMoney === 0) {
    //   this.valueMoney = item.number;
    // } else {
    this.valueMoney = this.valueMoney + item.number;
    // }
  }

  inputMoney_Cashin(item) {
    // if (this.valueMoney === 0) {
    //   this.valueMoney = item.number;
    // } else {
    this.cashin_Amount = this.cashin_Amount + item.number;
    // }
  }

  inputMoney_exact() {
    // if (this.valueMoney === 0) {
    //   this.valueMoney = item.number;
    // } else {
    this.valueMoney = this.total - this.valueAll_excMoney;
    // }
  }

  inputMoney_HCG(item) {
    this.valueMoney_HCG = this.valueMoney_HCG + item.number;
  }

  inputMoney_HCG_exact() {
    this.valueMoney_HCG = this.total - this.valueMoney_All;
  }

  openBackHome() {
    // this.payBill = [];
    if (this.listCart_bef_discount && this.listCart_bef_discount.length > 0) {
      this.listCart = JSON.parse(JSON.stringify(this.listCart_bef_discount));
    }
    this.getInto();
    this.discount_percent = 0;
    this.isValidCheckEnter = true;
    this.checkPagePayment = false;
    this.checkPageHome = true;
    this.checkMenuFooter = true;
    this.vouchers = [];
    this.valueMoney_Voucher = null;
    this.totalVoucher = null;
    this.valueMoney_All = 0;
    this.valueMoney_Change = 0;
    this.valueMoney = 0;
    this.checkDisabledHTTT = false;
    this.valueMoney_CreditCard = null;
    this.valueReferenceCode_CreditCard = null;
  }

  openBackPayment_Money() {
    this.valueMoney = 0;
    this.checkPagePayment = true;
    this.checkPagePayment_Money = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_Money = false;
  }
  openBackPayment_QR() {
    this.checkPagePayment = true;
    this.checkPagePayment_QR = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_QR = false;
  }
  openBackPayment_Voucher() {
    const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    if (!index) {
      this.totalVoucher = 0;
      this.vouchers = [];
    }
    this.checkPagePayment = true;
    this.checkPagePayment_Voucher = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_Voucher = false;
  }

  openBackPayment_CreditCard() {
    const index = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '003' && x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    if (!index) {
      this.valueMoney_CreditCard = null;
      this.valueReferenceCode_CreditCard = null;
    }
    this.checkPagePayment = true;
    this.checkPagePayment_CreditCard = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_CreditCard = false;
  }

  openBackPayment_HCG() {
    const index = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '012' && x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    if (!index) {
      this.valueMoney_HCG = null;
      this.valueReferenceCode_HCG = null;
    }
    this.checkPagePayment = true;
    this.checkPagePayment_HCG = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_HCG = false;
  }

  checkSubmit_CreditCard() {
    if (this.valueMoney_CreditCard === 0
      || this.valueMoney_CreditCard === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkSubmit_HCG() {
    if (this.valueMoney_HCG === 0
      || this.valueMoney_HCG === null || this.valueMoney_HCG === undefined
    ) {
      return true;
    } else {
      return false;
    }
  }

  openModalPayment(contentPayment, contentError) {
    this.isValidCheckEnter = false;
    if (this.listCart !== undefined) {
      if (this.listCart.length !== 0) {
        if (this.config_Payment === 0) {
          this.mr = this.modalService.open(contentPayment, { centered: true, backdrop: 'static' });
        }
        this.checkPaymentBill = false;
        this.checkPageHome = true;
        this.checkFooter = false;
      } else {
        // this.messageError = 'Không có hóa đơn nào để thanh toán!';
        this.messageError = 'Không có giao dịch nào để thanh toán!';
        this.openMessageError(contentError);
      }
    } else {
      // this.messageError = 'Không có hóa đơn nào để thanh toán!';
      this.messageError = 'Không có giao dịch nào để thanh toán!';
      this.openMessageError(contentError);
    }
    this.valueInputMoney = null;
    this.valueNumberLabel = 0;
    this.payBill = [];
  }

  TroLaiTrangThanhToan() {
    if (this.selectedValue.MaNhomThanhToan === '001') {
      this.checkPaymentBill = true;
      this.checkMoneyFace = false;
    } else if (this.selectedValue.MaNhomThanhToan === '003') {
      this.checkPaymentBill = true;
      this.checkCreditCard = false;
    } else if (this.selectedValue.MaNhomThanhToan === '005') {
      this.checkPaymentBill = true;
      this.checkVoucher = false;
    } else if (this.selectedValue.MaNhomThanhToan === '013') {
      this.checkPaymentBill = true;
      this.checkQR = false;
    }
  }

  openInputMoney(contentInputMoney) {
    this.mr = this.modalService.open(contentInputMoney, { centered: true, backdrop: 'static' });
  }

  submitEnterInputMoney(contentPrintPayment) {
    this.changeCheckMoney();
    if (!this.isValidConfirmPayment) {
      console.log('Close');
      this.closeModal();
      this.setChange();
      this.openPrintOrder(contentPrintPayment);
      this.selectedValue = this.hinhThucThanhToans[0];
    }
  }

  public closeModal() {
    if (this.mr != undefined) {
      this.mr.dismiss();
      this.mr.close();
    }
  }

  async openPrintOrder_triph() {
    var MACQT: MaCQT = new MaCQT();
    await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
    var kytu = "";
    let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1;
    MACQT = {
      MaCQT: MaCQTCongDon,
      MaKhuVuc: MACQT.MaKhuVuc,
      MaQuay: MACQT.MaQuay,
      Nam: MACQT.Nam,
      TenQuay: MACQT.TenQuay,
      CQT_location: MACQT.CQT_location,
      StoreID: MACQT.StoreID
    }
    var socuoinam = MACQT.Nam.substring(2, 4)
    if (MACQT.MaCQT.toString().length === 1) {
      kytu = "0000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 2) {
      kytu = "000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 3) {
      kytu = "00" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 4) {
      kytu = "0" + MACQT.MaCQT;
    } else {
      kytu = MACQT.MaCQT.toString();
    }
    var strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;

    const payBillAfter: Array<TTHD> = new Array<TTHD>();
    let totalPayment = 0;
    this.payBill.forEach(x => {
      totalPayment = totalPayment + x.SoTienThanhToanHD;
      x.QuyDoiNgoaiTe = x.SoTienThanhToanHD;
    });
    this.order.TienTraKhach = totalPayment - this.total;
    await this.payBill.forEach(x => {

      const payment: HTTT = {
        DoUuTien: x.HTTT.DoUuTien,
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        TenNhom: x.HTTT.TenNhom,
        MaThe: x.HTTT.MaThe
      };

      let xSoTienThanhToanHD: number;
      if (x.HTTT.MaHinhThuc === '0001') {
        xSoTienThanhToanHD = x.SoTienThanhToanHD - this.order.TienTraKhach;
      } else {
        xSoTienThanhToanHD = x.SoTienThanhToanHD;
      }
      const pay: TTHD = { HTTT: payment, SoTienThanhToanHD: this.round(xSoTienThanhToanHD, 2) };
      payBillAfter.push(pay);
    });
    await this.GenerateBill("PHIẾU TÍNH TIỀN",
      this.dtQBan.TenQuay,
      strmaCQT,
      this.user.TenDangNhap,
      this.VietTat_TenNhanVien(this.user.TenNV),
      this.order.STTHD,
      this.order.CTHoaDons,
      this.payBill,
      this.dtQBan.MaCH,
      payBillAfter,
      this.customer,
      this.order.MaHD,
      this.billNotes);
    this.changeCheckMoney_Payment();
    // this.mr = this.modalService.open(contentPrintPayment, { centered: true, backdrop: 'static' });
  }

  async openPrintOrder(contentPrintPayment) {
    var MACQT: MaCQT = new MaCQT();
    await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
    var kytu = "";
    let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1;
    MACQT = {
      MaCQT: MaCQTCongDon,
      MaKhuVuc: MACQT.MaKhuVuc,
      MaQuay: MACQT.MaQuay,
      Nam: MACQT.Nam,
      TenQuay: MACQT.TenQuay,
      CQT_location: MACQT.CQT_location,
      StoreID: MACQT.StoreID
    }
    var socuoinam = MACQT.Nam.substring(2, 4)
    if (MACQT.MaCQT.toString().length === 1) {
      kytu = "0000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 2) {
      kytu = "000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 3) {
      kytu = "00" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 4) {
      kytu = "0" + MACQT.MaCQT;
    } else {
      kytu = MACQT.MaCQT.toString();
    }
    var strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
    const payBillAfter: Array<TTHD> = new Array<TTHD>();
    let totalPayment = 0;
    this.payBill.forEach(x => {
      totalPayment = totalPayment + x.SoTienThanhToanHD;
    });
    this.order.TienTraKhach = totalPayment - this.total;
    await this.payBill.forEach(x => {

      const payment: HTTT = {
        DoUuTien: x.HTTT.DoUuTien,
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        TenNhom: x.HTTT.TenNhom
      };

      let xSoTienThanhToanHD: number;
      if (x.HTTT.MaHinhThuc === '0001') {
        xSoTienThanhToanHD = x.SoTienThanhToanHD - this.order.TienTraKhach;
      } else {
        xSoTienThanhToanHD = x.SoTienThanhToanHD;
      }
      const pay: TTHD = { HTTT: payment, SoTienThanhToanHD: xSoTienThanhToanHD };
      payBillAfter.push(pay);
    });
    await this.GenerateBill("PHIẾU TÍNH TIỀN",
      this.dtQBan.TenQuay,
      strmaCQT,
      this.user.TenDangNhap,
      this.VietTat_TenNhanVien(this.user.TenNV),
      this.order.STTHD,
      this.order.CTHoaDons,
      this.payBill,
      this.dtQBan.MaCH,
      payBillAfter,
      this.customer,
      this.order.MaHD,
      this.billNotes);
    this.changeCheckMoney();
    this.mr = this.modalService.open(contentPrintPayment, { centered: true, backdrop: 'static' });
  }


  async submitPrintCart_TriPH(contentLitmit_CQT, contentError) {
    const index_orderwait_temp: any = this.orderWait_temp.find(x => x.HoaDonID === this.order.HoaDonID);
    if (index_orderwait_temp) {
      const index_waitBill_MaCQT = this.Waitbill_MaCQT.find(x => x.HoaDonID === this.order.HoaDonID);
      var strmaCQT = "";
      var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
      var MACQT: MaCQT = new MaCQT();
      var kytu = "";
      MACQT = {
        MaCQT: index_waitBill_MaCQT.MaCQT,
        MaKhuVuc: index_waitBill_MaCQT.MaKhuVuc,
        MaQuay: index_waitBill_MaCQT.MaQuay,
        Nam: index_waitBill_MaCQT.Nam,
        TenQuay: index_waitBill_MaCQT.TenQuay,
        CQT_location: index_waitBill_MaCQT.CQT_location,
        StoreID: index_waitBill_MaCQT.StoreID
      }
      var socuoinam = MACQT.Nam.substring(2, 4)
      if (MACQT.MaCQT.toString().length === 1) {
        kytu = "0000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 2) {
        kytu = "000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 3) {
        kytu = "00" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 4) {
        kytu = "0" + MACQT.MaCQT;
      } else {
        kytu = MACQT.MaCQT.toString();
      }
      // chuyển sang lưu local cho phần này
      strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;

      // Kết thúc phần Trí thêm
      this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

      const index: TTHD = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '005');
      if (index) {
        if (window.navigator.onLine === false) {
          this.messageError = 'Không thể cập nhật tình trạng phiếu mua hàng vui lòng thử lại sau!';
          this.openMessageError(contentError);
          return;
        }
      }
      const now = new Date();
      this.isValidCheckEnter = true;
      this.order.CTHoaDons = this.listCart;
      this.order.MaQuay = this.dtQBan.MaQuay;
      this.order.MaCH = this.dtQBan.MaCH;
      this.order.LoaiHD = 1;
      this.order.MaNV = this.user.MaNV;
      this.order.NgayHD = now;
      this.order.STTHD = this.numberHD;
      this.order.TongTien = this.intoMoney;
      this.order.TienCK = this.intoMoney - this.total;
      this.order.TongTien = this.total;
      this.order.GhiChu = this.billNotes;
      const t = moment();
      const s = t.format('DDMMYY');
      this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
      // this.payment = this.order;
      let isValid;
      const isValidPayment = await this.checkPayments();
      if (isValidPayment) {
        console.log(this.listHD_Tong);
        const index: HoaDon = this.listHD_Tong.find(x => x.STTHD === this.numberHD);
        if (!index) {
          this.listHD_Tong.push(this.order);
        } else {
          const i = this.listHD_Tong.indexOf(index);
          this.listHD_Tong[i].LoaiHD = 1;
          this.listHD_Tong[i].NgayHD = now;
        }
        this.billService.saveTotalBillRefresh(this.listHD_Tong);
        console.log('submitPrintCart \n');
        console.log(this.listHD_Tong);
        this.ListHD.push({ HoaDon: this.order, TTHD: this.payBill });
        console.log(this.ListHD);
        isValid = await this.setCheckOneBill(1, this.order, this.payBill, strmaCQT, "");
        if (isValid === false && !isNull(this.valueMoney_Voucher)) {
          this.closeModal();
          this.messageError = 'Lỗi Thanh Toán! Không thể thanh toán voucher với internet không ổn định!';
          this.openMessageError(contentError);
        }
        else {
          if (!isNull(this.valueMoney_Voucher)) {
            this.updateVoucher(this.valueMoney_Voucher);
          }
          var coHTTT_The: boolean = this.payBill.findIndex(x => x.HTTT.MaNhomThanhToan === '003') >= 0 ? true : false;
          var coHTTT_The: boolean = this.payBill.findIndex(x => x.HTTT.MaNhomThanhToan === '201') >= 0 ? true : false;
          this.listCart = [];
          this.customer = null;
          this.momo = null;
          this.isHadMomo = false;
          this.isHadPoint = false;
          this.isValidCheckMoney = false;
          this.valueNumber = '';
          this.selectedValue = this.hinhThucThanhToans[0];
          await this.getLengthHD();
          await this.getInto();
          this.valueInputMoney = null;
          this.valueNumberLabel = 0;
          this.payment = null;
          this.payBill = [];
          this.listCart_bef_discount = [];
          // localStorage.removeItem('_customer');
          await localForage.removeItem('_customer');
          await localStorage.removeItem('_dataQR');
          await localStorage.removeItem('_dataPoint');
          this.openBackHome();
          this.valueCode_QR = '';
          this.valueReferenceCode_QR = '';
          this.valueMoney_CreditCard = null;
          this.valueReferenceCode_CreditCard = null;
          this.setNumberMaxBill();
          if (index_orderwait_temp) {
            const i = this.orderWait_temp.indexOf(index_orderwait_temp);
            this.orderWait_temp.splice(i, 1);
            this.billService.saveWaitingBillLocal(this.orderWait_temp);
          }
          if (index_waitBill_MaCQT) {
            const i = this.Waitbill_MaCQT.indexOf(index_waitBill_MaCQT);
            this.Waitbill_MaCQT.splice(i, 1);
            this.billService.saveWaitingBillLocal_CQT(this.Waitbill_MaCQT);
          }
          if (coHTTT_The) {
            this.PrintCart();
            this.closeModal();
            this.mr = await this.modalService.open(this.contentPrint2, { centered: true, backdrop: 'static' });
          }
          else {
            this.PrintCart();
            this.closeModal();
            if (this.billTemplate.toLowerCase() !== 'cf') {
              this.modalService.open(this.ContentOutputE_Invoice, { centered: true });
            }
          }        // this.closeModal();
        }
        //else {
        //  this.closeModal();
        //  this.messageError = 'Lỗi Thanh Toán!';
        //  this.openMessageError(contentError);
        //}
      } else {
        this.closeModal();
        this.messageError = 'Vui lòng nhập đúng số tiền cần phải trả với hình thức thanh toán này';
        this.openMessageError(contentError);
      }
    } else {
      const tdate = moment();
      const date = tdate.format('YYYY-MM-DD');
      var strmaCQT = "";
      var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
      var MACQT: MaCQT = new MaCQT();
      await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
      var kytu = "";
      let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1
      MACQT = {
        MaCQT: MaCQTCongDon,
        MaKhuVuc: MACQT.MaKhuVuc,
        MaQuay: MACQT.MaQuay,
        Nam: MACQT.Nam,
        TenQuay: MACQT.TenQuay,
        CQT_location: MACQT.CQT_location,
        StoreID: MACQT.StoreID
      }
      await localForage.setItem('_MaCQT', JSON.stringify(MACQT))
      var socuoinam = MACQT.Nam.substring(2, 4)
      if (MACQT.MaCQT.toString().length === 1) {
        kytu = "0000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 2) {
        kytu = "000" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 3) {
        kytu = "00" + MACQT.MaCQT;
      } else if (MACQT.MaCQT.toString().length === 4) {
        kytu = "0" + MACQT.MaCQT;
      } else {
        kytu = MACQT.MaCQT.toString();
      }
      // chuyển sang lưu local cho phần này
      strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
      TPCQuayBanMaCQT = {
        Store: MACQT.StoreID,
        Register: MACQT.MaQuay,
        MACQT: MACQT.MaCQT.toString(),
        Update_Date: date,
        Year: MACQT.Nam,
        CQT_Location: MACQT.CQT_location
      }
      console.log(TPCQuayBanMaCQT)
      console.log(TPCQuayBanMaCQT.MACQT)
      let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + TPCQuayBanMaCQT.CQT_Location + "\n" + strmaCQT + "";
      //this.save_salebackup_POS(data, TPCQuayBanMaCQT.Register, MACQT.CQT_location);
      /* if (window.navigator.onLine === true) {*/
      var fileNameCQT = TPCQuayBanMaCQT.Register + "_" + MACQT.CQT_location
      this.upload_saleBackup_FTP_CQT(fileNameCQT, data)
      // Kết thúc phần Trí thêm
      this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

      const index: TTHD = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '005');
      if (index) {
        if (window.navigator.onLine === false) {
          this.messageError = 'Không thể cập nhật tình trạng phiếu mua hàng vui lòng thử lại sau!';
          this.openMessageError(contentError);
          return;
        }
      }
      const now = new Date();
      this.isValidCheckEnter = true;
      this.order.CTHoaDons = this.listCart;
      this.order.MaQuay = this.dtQBan.MaQuay;
      this.order.MaCH = this.dtQBan.MaCH;
      this.order.LoaiHD = 1;
      this.order.MaNV = this.user.MaNV;
      this.order.NgayHD = now;
      this.order.STTHD = this.numberHD;
      this.order.TongTien = this.intoMoney;
      this.order.TienCK = this.intoMoney - this.total;
      this.order.TongTien = this.total;
      this.order.GhiChu = this.billNotes;
      const t = moment();
      const s = t.format('DDMMYY');
      this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
      // this.payment = this.order;
      let isValid;
      const isValidPayment = await this.checkPayments();
      if (isValidPayment) {
        console.log(this.listHD_Tong);
        const index: HoaDon = this.listHD_Tong.find(x => x.STTHD === this.numberHD);
        if (!index) {
          this.listHD_Tong.push(this.order);
        } else {
          const i = this.listHD_Tong.indexOf(index);
          this.listHD_Tong[i].LoaiHD = 1;
          this.listHD_Tong[i].NgayHD = now;
        }
        this.billService.saveTotalBillRefresh(this.listHD_Tong);
        console.log('submitPrintCart \n');
        console.log(this.listHD_Tong);
        this.ListHD.push({ HoaDon: this.order, TTHD: this.payBill });
        console.log(this.ListHD);
        isValid = await this.setCheckOneBill(1, this.order, this.payBill, strmaCQT, TPCQuayBanMaCQT);
        if (isValid === false && !isNull(this.valueMoney_Voucher)) {
          this.closeModal();
          this.messageError = 'Lỗi Thanh Toán! Không thể thanh toán voucher với internet không ổn định!';
          this.openMessageError(contentError);
        }
        else {
          if (!isNull(this.valueMoney_Voucher)) {
            this.updateVoucher(this.valueMoney_Voucher);
          }
          var coHTTT_The: boolean = this.payBill.findIndex(x => x.HTTT.MaNhomThanhToan === '003') >= 0 ? true : false;
          var coHTTT_The: boolean = this.payBill.findIndex(x => x.HTTT.MaNhomThanhToan === '201') >= 0 ? true : false;
          this.listCart = [];
          this.customer = null;
          this.momo = null;
          this.isHadMomo = false;
          this.isHadPoint = false;
          this.isValidCheckMoney = false;
          this.valueNumber = '';
          this.selectedValue = this.hinhThucThanhToans[0];
          await this.getLengthHD();
          await this.getInto();
          this.valueInputMoney = null;
          this.valueNumberLabel = 0;
          this.payment = null;
          this.payBill = [];
          this.listCart_bef_discount = [];
          // localStorage.removeItem('_customer');
          await localForage.removeItem('_customer');
          await localStorage.removeItem('_dataQR');
          await localStorage.removeItem('_dataPoint');
          this.openBackHome();
          this.valueCode_QR = '';
          this.valueReferenceCode_QR = '';
          this.valueMoney_CreditCard = null;
          this.valueReferenceCode_CreditCard = null;
          this.setNumberMaxBill();
          if (coHTTT_The) {
            this.PrintCart();
            this.closeModal();
            this.mr = await this.modalService.open(this.contentPrint2, { centered: true, backdrop: 'static' });
          }
          else {
            this.PrintCart();
            this.closeModal();
            if (this.billTemplate.toLowerCase() !== 'cf') {
              this.modalService.open(this.ContentOutputE_Invoice, { centered: true });
            }
          }        // this.closeModal();
        }
        //else {
        //  this.closeModal();
        //  this.messageError = 'Lỗi Thanh Toán!';
        //  this.openMessageError(contentError);
        //}
      } else {
        this.closeModal();
        this.messageError = 'Vui lòng nhập đúng số tiền cần phải trả với hình thức thanh toán này';
        this.openMessageError(contentError);
      }
    }
  }

  printandOpenEinvoice() {
    this.closeModal;
    this.PrintCart();
    if (this.billTemplate.toLowerCase() !== 'cf') {
      this.mr = this.modalService.open(this.ContentOutputE_Invoice, { centered: true, backdrop: 'static' });
    }
  }


  xc_ForeignCurr(amount: number): number {

    var curr: any = localForage.getItem('_currency').then((Result: any) => { return Result; });
    const objCurr = JSON.parse(curr);
    const final = objCurr.ExchageRate * amount;
    return final;

  }

  async xc_ForeignCurr_async(amount: number) {
    const curr: any = await localForage.getItem('_currency');
    const objCurr = JSON.parse(curr);
    const final = 1 * amount;
    const exRate = 1;
    return { TyLe: exRate, QuyDoi: final };
  }

  checkPayments() {
    let totalPayment = 0;
    this.payBill.forEach(x => {
      totalPayment = totalPayment + x.SoTienThanhToanHD;
    });
    if (totalPayment > this.total) {
      const index: TTHD = this.payBill.find(x => x.HTTT.MaHinhThuc === '0001');
      if (index) {
        const i = this.payBill.indexOf(index);
        this.payBill[i].SoTienThanhToanHD = this.payBill[i].SoTienThanhToanHD - (totalPayment - this.total);
        this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
          .then((result: any) => {
            this.payBill[i].QuyDoiNgoaiTe = result.QuyDoi;
            this.payBill[i].TyLeQuyDoi = result.TyLe;
          });

        if (this.payBill[i].SoTienThanhToanHD < 0) {
          this.isValidCheckMoney = true;
          return false;
        } else {
          this.order.TienTraKhach = totalPayment - this.total;
          this.payment = this.order;
          console.log('checkPayments payment: ');
          console.log(this.payment);
        }
      } else {
        this.isValidCheckMoney = true;
        return false;
      }
    }
    return true;
  }

  openMessageError(contentError) {
    if (this.messageError !== '') {
      this.modalService.open(contentError, { centered: true })
        .result.then((result) => {
          if (this.checkPagePayment_Voucher === true) {
            setTimeout(x => document.getElementById('VoucherCode').focus(), 1000);
          }
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          if (this.checkPagePayment_Voucher === true) {
            setTimeout(x => document.getElementById('VoucherCode').focus(), 1000);
          }
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  wait(ms) {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }
  // In qua service
  printtoimage() {
    var mr2 = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
    console.time('printomage');

    console.time('tao html');
    var el = window.document.createElement('div');
    el.setAttribute('style', 'white-space: nowrap; position: relative; z-index: -99;  display: inline-block; background: white !important;');
    el.setAttribute('id', 'test');
    el.innerHTML = this.inz;
    let scale = 1.3;
    window.document.body.appendChild(el);
    console.timeEnd('tao html');
    console.time('tao image');

    domtoimage
      .toJpeg(el, {
        width: el.clientWidth * scale,
        height: el.clientHeight * scale,
        style: { transform: 'scale(' + scale + ')', transformOrigin: 'top left' }
      })
      .then(function (dataUrl) {
        console.timeEnd('tao image');
        console.time('tai image');

        //// Hàm in thông qua browser cho debug
        //var link = document.createElement('a');
        //link.download = 'my-image-name.jpeg';  
        //link.href = dataUrl;
        //link.click();
        //// Hàm in thông qua browser cho debug


        //// Hàm in thông qua app
        window["TPCGoWV"].In(dataUrl);
        //// Hàm in thông qua app
        document.body.removeChild(el);
        console.timeEnd('tai image');
        console.timeEnd('printomage');
        mr2.close();
        //document.body.appendChild(img);
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
      });
  }
  async GenerateBill(b_title: string, b_TenQuay: string, b_MaCQT: string, b_MaNV: string, b_TenNV: string, b_STTHD: number, b_cthd: CTHoaDon[], b_tthd: TTHD[], b_MaCH: string, b_paybillafter: TTHD[], b_customer: KhachHang, b_MaHD: string, b_note: string, b_reprint: boolean = false) {
    const deCryptDSBill = await localForage.getItem('_dsBill').then();
    const danhsBill = this.jwtService.deCryptData(deCryptDSBill);
    const danhsBills = JSON.parse(danhsBill);
    console.log(danhsBills);
    /*    const h = danhsBills[0].BillHeader;*/
    const name = this.billService.padcenter('Saigon Co.op', ' ', 30, true) + '\n';
    const storeName = this.billService.padcenter(danhsBills[0].StoreName, ' ', 30, true) + '\n';
    const maSoThue = this.billService.padcenter(`Mã số thuế: ${danhsBills[0].MST}`, ' ', 30, true) + '\n';
    var lineFist = "";
    var lineSecond = "";
    var separateLines = danhsBills[0].Address.split(',');
    var soDem = 0;
    separateLines.forEach(x => {
      if (x !== "" && soDem < 3) {
        lineFist += x + ","
        soDem++;
      } else if (x !== "" && soDem >= 3) {
        lineSecond += x + ",";
        soDem++;
      }
    })
    var FirstSecondAddress = this.billService.padcenter(lineFist, ' ', 30, true) + "\n" + this.billService.padcenter(lineSecond.substring(0, lineSecond.length - 1), ' ', 30, true);
    const diaChi = this.billService.padcenter(FirstSecondAddress, ' ', 30, true) + '\n';
    const email = this.billService.padcenter(`Email: ${danhsBills[0].email}`, ' ', 30, true) + '\n';
    const webSite = this.billService.padcenter(`Website: ${danhsBills[0].WebSite}`, ' ', 30, true) + '\n';
    let soDienThoai = "";
    if (danhsBills[0].phonenumber != "") {
      soDienThoai = this.billService.padcenter(`DT: ${danhsBills[0].phonenumber}`, ' ', 30, true) + '\n';
    }
    /*const h = `\t  Saigon Co.op\n        ${danhsBills[0].StoreName}\n     Mã số thuế: ${danhsBills[0].MST}\n${danhsBills[0].Address}\n   DT: ${danhsBills[0].phonenumber}\n  Email: ${danhsBills[0].email}\n Website: ${danhsBills[0].WebSite}`;*/
    const h = name + storeName + maSoThue + diaChi + soDienThoai + email + webSite;
    const f = danhsBills[0].BillFooter;
    const t = moment();
    const s = t.format('HH:mm DD/MM/YYYY');
    let body_receipt = [];
    body_receipt = this.billService.splitted_receiptformat();
    const body = this.billService.Generate_Receipt(body_receipt, b_TenQuay, b_MaCQT,
      s, b_MaNV, b_TenNV, b_STTHD,
      b_cthd, b_tthd, 0, b_MaCH, b_note);
    let bodyVAT = [];
    let receipt_print = [];
    // Bill Guardian remove VAT part
    if (this.billTemplate.toLowerCase() !== 'grd') {
      bodyVAT = this.billService.Generate_Receipt_VAT(body, b_cthd);
      receipt_print = this.billService.Add_VAT_to_Receipt(body, bodyVAT);
    }
    else {
      receipt_print = body;
    }
    // Bill Guardian remove VAT part

    const bodyHH = this.billService.Generate_Receipt_HH(body, b_cthd);
    receipt_print = this.billService.Add_CTHH_to_Receipt(receipt_print, bodyHH);
    const bodyTTHD = this.billService.Generate_Receipt_TTHD(body, b_paybillafter);
    receipt_print = this.billService.Add_TTHD_to_Receipt(receipt_print, bodyTTHD);
    let bodyCustomer = [];
    if (!isNullOrUndefined(b_customer)) {
      if (!isNullOrUndefined(b_customer.MaKHTV)) {
        if (b_customer.MaKHTV.length > 0) {
          bodyCustomer = this.billService.Generate_Receipt_Customer(body, b_customer.MaKHTV);
          receipt_print = this.billService.Add_Customer_to_Receipt(receipt_print, bodyCustomer);
        }
      }
    }
    else {
      receipt_print = this.billService.Add_Customer_to_Receipt(receipt_print, bodyCustomer);
    }

    const reformated = [];
    receipt_print.forEach((data, l) => {
      reformated.push(this.billService.fullline_reformat(receipt_print[l]));
    });
    const final = reformated.join('\n');
    if (this.billTemplate.toLowerCase() !== 'grd') {
      this.inz = this.billService.print_generate_bill(h, f, final, this.imgKH_b64, b_title, b_reprint, this.bareCode_ForBill(b_MaHD), await this.QRCode_ForBill(b_MaHD), b_MaHD);
    }
    else {
      this.inz = this.billService.print_generate_bill(h, f, final, this.imgKH_b64, b_title, b_reprint, null,null, b_MaHD);
    }
  }

  async GenerateBill_Endshift(ListHD: HD[], result: any[]) {
    const deCryptDSBill = await localForage.getItem('_dsBill').then();
    const danhsBill = this.jwtService.deCryptData(deCryptDSBill);
    const danhsBills = JSON.parse(danhsBill);
    const h = danhsBills[0].BillHeader;
    const f = danhsBills[0].BillFooter;
    const t = moment();
    const s = t.format('HH:mm DD/MM/YYYY');
    let endshift_format = [];
    endshift_format = this.billService.splitted_endshiftformat();
    let body_endshift = [];
    body_endshift = this.billService.Generate_Receipt_endshift(endshift_format, this.dtQBan.TenQuay,
      s, this.user.MaNV, this.user.TenNV, this.dtQBan.MaCH);
    const body_tt = this.billService.Generate_EndofShift_TTHD(body_endshift, result);
    body_endshift = this.billService.Add_TTHD_to_Receipt(body_endshift, body_tt)
    body_endshift = this.billService.Add_EndofShift_SHD(body_endshift, ListHD.length);
    const reformated = [];
    body_endshift.forEach((data, l) => {
      reformated.push(this.billService.fullline_reformat(body_endshift[l]));
    });
    const final = reformated.join('\n');
    this.inz = this.billService.print_generate_bill(h, "", final, this.imgKH_b64, "BẢNG IN KẾT CA");
  }

  PrintCart() {
    var inhd = '<a style="text-decoration: none; color: black" onclick="javascipt:window.close();" href="print:">' + '\n';
    inhd += this.inz;
    inhd += '<\a>';
    this.printtoimage();

  }

  // End Home Page

  // Begin Code Find Page
  /**
   * event xử lý checkbox
   * @param id
   */
  checkBox(id: string) {
    const product: HangHoa = this.products.find(x => x.MaHH === id);
    if (product !== null) {
      const cart = this.checkCart.findIndex(n => n.MaHH === product.MaHH);
      console.log(cart);
      if (cart >= 0) {
        product.checked = false;
        this.checkCart.splice(cart, 1);
      } else {
        product.checked = true;
        this.checkCart.push(product);
      }
    }
  }

  /**
 * event xóa tất cả checkbox đã chọn
 */
  clearCheck() {
    this.products.forEach(function (n) {
      n.checked = false;
    });
    this.checkCart = [];
    this.clearValueFind();
  }

  async addCart(contentError) {
    const product: Array<HangHoa> = this.checkCart;
    if (product.length !== 0) {
      if (isNullOrUndefined(this.listCart)) {
        await product.forEach(async x => {
          let cthd: CTHoaDon;
          if (x.ChoChinhGia === true) {
            this.price0Item = x;
            await this.show0PriceItem().then((res: boolean) => {
              if (res) {
                const index: CTHoaDon = {
                  VATDauRa: x.VATDauRa,
                  HangHoaID: x.HangHoaID,
                  Stt: this.numericalOrder,
                  HinhAnh: x.HinhAnh,
                  MaHH: x.MaHH,
                  TenHH: x.TenHH,
                  SoLuong: 1,
                  DGBan: this.priceadd,
                  DGBanCK: this.priceadd,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: x.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: x.MaNCC
                };
                cthd = index;
                this.price0Item = null;
                this.priceadd = 1;
                this.SuKienGia(cthd, x);
                this.cart.push(cthd);
                this.listCart = this.cart;
                this.numericalOrder++;
              }
            })

          }
          else {
            const index: CTHoaDon = {
              VATDauRa: x.VATDauRa,
              HangHoaID: x.HangHoaID,
              Stt: this.numericalOrder,
              HinhAnh: x.HinhAnh,
              MaHH: x.MaHH,
              TenHH: x.TenHH,
              SoLuong: 1,
              DGBan: x.GiaBanLe,
              DGBanCK: x.GiaBanLe,
              ChietKhau: 0,
              TienCK: 0,
              TyLeCK: 0,
              TienCKHD: 0,
              TyLeCKHD: 0,
              SKU: x.SKU,
              NgayGioQuet: this.GetCurTime_UTC(),
              MaNCC: x.MaNCC
            };
            cthd = index;
            this.SuKienGia(cthd, x);
            this.cart.push(cthd);
            this.listCart = this.cart;
            this.numericalOrder++;
          }
          if (this.cart.length === this.checkCart.length) {
            this.cart = [];
            this.cartSKG = [];
            this.checkPageFind = !this.checkPageFind;
            this.getInto();
            this.order.CTHoaDons = this.listCart;
            this.order.TongTien = this.total;
            this.billService.saveBillRefresh(this.order);
            this.clearCheck();
            const valueIcon = "TurnOffIcon_BGDefault";
            this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
          }
        });

      } else {
        await product.forEach(async x => {
          const index: CTHoaDon = this.listCart.find(n => n.MaHH === x.MaHH && n.DGBan === x.GiaBanLe);
          if (!index) {
            if (x.ChoChinhGia === true) {
              const stt = this.listCart.length + 1;
              this.price0Item = x;
              await this.show0PriceItem().then((res: boolean) => {
                if (res) {
                  let n: CTHoaDon = {
                    VATDauRa: x.VATDauRa,
                    HangHoaID: x.HangHoaID,
                    Stt: stt,
                    HinhAnh: x.HinhAnh,
                    MaHH: x.MaHH,
                    TenHH: x.TenHH,
                    SoLuong: 1,
                    DGBan: this.priceadd,
                    DGBanCK: this.priceadd,
                    ChietKhau: 0,
                    TienCK: 0,
                    TyLeCK: 0,
                    TienCKHD: 0,
                    TyLeCKHD: 0,
                    SKU: x.SKU,
                    NgayGioQuet: this.GetCurTime_UTC(),
                    MaNCC: x.MaNCC
                  };
                  this.SuKienGia(n, x);
                  this.listCart.push(n);
                  this.price0Item = null;
                  this.priceadd = 1;
                  this.cart.push(n);
                }
              })

            }
            else {
              const stt = this.listCart.length + 1;
              let n: CTHoaDon = {
                VATDauRa: x.VATDauRa,
                HangHoaID: x.HangHoaID,
                Stt: stt,
                HinhAnh: x.HinhAnh,
                MaHH: x.MaHH,
                TenHH: x.TenHH,
                SoLuong: 1,
                DGBan: x.GiaBanLe,
                DGBanCK: x.GiaBanLe,
                ChietKhau: 0,
                TienCK: 0,
                TyLeCK: 0,
                TienCKHD: 0,
                TyLeCKHD: 0,
                SKU: x.SKU,
                NgayGioQuet: this.GetCurTime_UTC(),
                MaNCC: x.MaNCC
              };
              console.log("Dữ liệu N" + n);
              this.SuKienGia(n, x);
              console.log("Dữ liệu N1" + n);
              this.listCart.push(n);
              console.log("Dữ liệu N2" + n);
              this.cart.push(n);
            }
          } else {
            const amount = index.SoLuong;
            const i = this.listCart.indexOf(index);
            this.listCart[i].SoLuong = amount + 1;
            this.listCart[i].ChietKhau = this.listCart[i].ChietKhau * this.listCart[i].SoLuong;
            this.apDungLaiSuKienGia(this.order);
            this.cart.push(this.listCart[i]);
          }
          if (this.cart.length === this.checkCart.length) {
            this.cart = [];
            this.cartSKG = [];
            this.checkPageFind = !this.checkPageFind;
            this.getInto();
            this.order.CTHoaDons = this.listCart;
            this.order.TongTien = this.total;
            this.billService.saveBillRefresh(this.order);
            this.clearCheck();
            const valueIcon = "TurnOffIcon_BGDefault";
            this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
          }
        });
      }
      //this.cart = [];
      //this.cartSKG = [];
      //this.checkPageFind = !this.checkPageFind;
      //this.getInto();
      //this.order.CTHoaDons = this.listCart;
      //this.order.TongTien = this.total;
      //this.billService.saveBillRefresh(this.order);
      //this.clearCheck();
      //const valueIcon = "TurnOffIcon_BGDefault";
      //this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    } else {
      this.messageError = 'Bạn chưa chọn sản phẩm!';
      this.openMessageError(contentError);
    }
    console.log(this.listCart);
    console.log(this.order);
  }

  // submitFind() {
  //   this.checkfind = !this.checkfind;   
  // }

  submitFindReturn() {
    this.findresult = false;
    this.finddefault = true;
    this.checkfind = false;
    this.valueFind = '';
    this._valueSearch = new valueSearch();
  }
  submitFindReturn_new() {
    this.findresult = false;
    this.finddefault = true;
    this.checkfind = false;
    this.checkPageFind = false;
    this.valueFind = '';
    this._valueSearch = new valueSearch();
    const valueIcon = "TurnOffIcon_BGDefault";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
  }
  CheckSearch() {
    this.optionSearch = optSearch[0];
    this.finddefault = false;
    this.findresult = false;
    this.checkfind = true;
    this.valueFind = '';
    this._valueSearch = new valueSearch();
  }

  async submitFindOKItems() {
    this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
    await this.submitFindOk().then(async result => {
      this.mr.dismiss();
    });
  }

  async submitFindOk() {
    if (this.valueFind !== '') {
      if (this.valueFind.length >= 3) {
        var lstHH: Array<HangHoa> = new Array<HangHoa>();;
        this._valueSearch.option = this.optionSearch.name;
        this._valueSearch.value = this.valueFind;
        if (this._valueSearch.option === 'UPC') {
          lstHH = this.products.filter(x => x.MaHH.toLowerCase().indexOf(this._valueSearch.value.toLowerCase()))
        } else if (this._valueSearch.option === 'SKU') {
          lstHH = this.products.filter(x => x.SKU.toLowerCase().indexOf(this._valueSearch.value.toLowerCase()))
        } else if (this._valueSearch.option === 'Tên hàng hóa') {
          lstHH = this.products.filter(x => x.TenHH.toLowerCase().indexOf(this._valueSearch.value.toLowerCase()))
        }
        console.log(lstHH);
        if (lstHH.length === this.products.length) {
          this.mr = this.modalService.open(this.PageFindLoadDefaut, { centered: true, backdrop: 'static' });
        } else {
          if (this.valueFind !== '') {
            this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
            return new Promise(resolve => {
              setTimeout(async () => {
                console.time('findresult');
                this.findresult = await true;
                console.timeEnd('findresult');
                this.finddefault = await false;
                this.checkfind = await false;
                this.mr.dismiss();
              }, 100);
            });
          } else {
            this.findresult = false;
            this.finddefault = true;
            this.checkfind = false;
          }
        }
      } else {
        this.messageError = "Vui lòng nhập thông tin lớn hơn 3 ký tự!";
        this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
      }
    } else {
      this.messageError = "Vui lòng nhập thông tin tìm kiếm!";
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }

    // ------------------------------------- Phần code cũ 
    //if (this.valueFind !== '') {
    //  this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
    //  return new Promise(resolve => {
    //    setTimeout(async () => {
    //      this._valueSearch.option = this.optionSearch.name;
    //      this._valueSearch.value = this.valueFind;
    //      if (this._valueSearch.option === 'UPC') {
    //        lstHH = this.products.filter(x => x.MaHH.concat(this._valueSearch.value))
    //      } else if (this._valueSearch.option === 'UPC')
    //      console.time('findresult');
    //      this.findresult = await true;
    //      console.timeEnd('findresult');
    //      this.finddefault = await false;
    //      this.checkfind = await false;
    //      this.mr.dismiss();
    //    }, 100);
    //  });
    //} else {
    //  this.findresult = false;
    //  this.finddefault = true;
    //  this.checkfind = false;
    //}
  }
  // End Code Find Page
  // closeModelFind(closeModelPageFind) {
  //   closeModelPageFind.close();
  // }
  // test
  async checkRouterFindItems() {
    if (this.checkPageFind === false) {
      this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
      return new Promise(resolve => {
        setTimeout(async () => {
          await this.checkRouterFind();
          this.mr.dismiss();
        }, 100);
      });
    } else {
      const value = 'Page_Find';
      this.checkAllPageItems(value);
      this.clearCheck();
      this.BillTypeOne = null;
    }

  }

  // Begin Code Footer
  async checkRouterFind() {
    // if (this.checkPageFind === false) {
    // this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static'});
    // await setTimeout(function() {alert('ssse')}, 5000);

    const value = 'Page_Find';
    console.time('CheckRouterFind');
    await this.checkAllPageItems(value);
    this.optionSearch = optSearch[0];
    this.finddefault = await false;
    this.findresult = await false;
    this.checkfind = await true;
    console.timeEnd('CheckRouterFind');
    console.time('ClearCheck');
    await this.clearCheck();
    console.timeEnd('ClearCheck');
    const valueIcon = "iconFind";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    this.BillTypeOne = await null;
    return null;


    // await this.closeModal();
    // } else {
    //   const value = 'Page_Find';
    //   console.time('CheckRouterFind');
    //   this.checkAllPageItems(value);
    //   console.timeEnd('CheckRouterFind');
    //   console.time('ClearCheck');
    //   this.clearCheck();
    //   console.timeEnd('ClearCheck');
    //   this.BillTypeOne = null;
    // }
  }

  checkRouterCustomer() {
    const value = 'Page_Customer';
    this.checkAllPage(value);
    const valueIcon = "iconCustomer";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    this.BillTypeOne = null;
  }
  checkRouterCamera() {
    if (this.checkIconCamera_WhenEdit_InCamera === true && this.checkChangeColor_IconEidt_PageCamera == false) {
      const value = 'Page_Camera';
      this.checkAllPage(value);
      const valueIcon = "iconCamera";
      this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    }
    else if (this.checkIconCamera_WhenEdit_InCamera === true && this.checkChangeColor_IconEidt_PageCamera === true) {
      const value = '';
      this.checkAllPage(value);
      const valueIcon = "iconCamera";
      this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    }
    else {

      const value = 'Page_Camera';
      this.checkAllPage(value);
      const valueIcon = "iconCamera";
      this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
      this.checkChangeColor_IconCamera_New_PageCamera = true;
      this.checkChangeColor_IconEidt_PageCamera = false;

    }
    this.BillTypeOne = null;
  }

  async checkRouterOther() {

    if (!this.listCart || this.listCart.length !== 0) {
      const t = moment();
      const s = t.format('HH:mm DD/MM/YYYY');
      const chPrintWaitBill: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
      let dataNhanVien: NhanVien;
      await localForage.getItem('_user').then((resultNV: any) => {
        dataNhanVien = JSON.parse(resultNV);
      });
      // Print wait by class (old)
      //this.order.printWaitBill(s, chPrintWaitBill[0].TenCH, chPrintWaitBill[0].TenQuay, dataNhanVien.TenNV)
      //  .then(result => {
      //    this.inz = result;
      //  });

      // Print wait by service (new)

      this.inz = this.billService.printWaitBill(s, chPrintWaitBill[0].TenCH, chPrintWaitBill[0].TenQuay, this.VietTat_TenNhanVien(dataNhanVien.TenNV), this.order.STTHD);
    }
    const value = 'Page_Other';
    this.checkAllPage(value);
    const valueIcon = "iconGear";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
    this.BillTypeOne = null;
  }

  checkAllPage(value: string) {
    console.time('SubmitFindReturn')
    this.submitFindReturn()
    console.timeEnd('SubmitFindReturn')
    if (value === 'Page_Find') {
      this.checkPageFind = !this.checkPageFind;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checkfind = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'Page_Customer') {
      this.checkPageFind = false;
      this.checkPageCustomer = !this.checkPageCustomer;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'Page_Other') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = !this.checkPageOther;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'Page_Camera') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageCamera = !this.checkPageCamera;
      this.ngOnCameraClicked();
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'Page_Order_Wait') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checktemplatePrintBill = false;
      this.checktemplateBill = !this.checktemplateBill;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'Page_Find_PrintBill') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = !this.checktemplatePrintBill;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'PageE_Invoice') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = !this.checkPageE_Invoice;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'PageReturn_Item') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = !this.checkPage_ReturnITem;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'PageMany_Items') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = !this.checkPage_ManyItems;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    }
    else if (value === 'PagePrice_Item') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = !this.checkPagePrice_Item;
      this.checkPageCamera_New = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();

    } else if (value === 'PageSearchPrice_Item') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkSearchPrice_Item = !this.checkSearchPrice_Item;
      this.checkPageCamera_New = false;
      this.clear_PrcItem();

    } else if (value === 'Page_CameraNew') {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageCamera = false;
      this.ngOnCameraClicked();
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = !this.checkPageCamera_New;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();
    } else {
      this.checkPageFind = false;
      this.checkPageCustomer = false;
      this.checkPageOther = false;
      this.checkPageCamera = false;
      this.checktemplateBill = false;
      this.checktemplatePrintBill = false;
      this.checkPageE_Invoice = false;
      this.checkPage_ReturnITem = false;
      this.checkPage_ManyItems = false;
      this.checkPagePrice_Item = false;
      this.checkPageCamera_New = false;
      this.checkIconCamera_WhenEdit_InCamera = false;
      this.checkChangeColor_IconCamera_New_PageCamera = false;
      this.checkChangeColor_IconEidt_PageCamera = false;
      this.checkSearchPrice_Item = false;
      this.clear_PrcItem();
    }
  }


  async checkAllPageItems(value: string) {
    console.time('SubmitFindReturn');
    this.submitFindReturn();
    console.timeEnd('SubmitFindReturn');
    switch (value) {
      case 'Page_Find':
        this.checkPageFind = await !this.checkPageFind;
        this.checkPageCustomer = await false;
        this.checkPageOther = await false;
        this.checkPageCamera = await false;
        this.checktemplateBill = await false;
        this.checkfind = await false;
        this.checktemplatePrintBill = await false;
        this.checkPageE_Invoice = await false;
        this.checkPage_ReturnITem = await false;
        this.checkPage_ManyItems = await false;
        this.checkPageCamera_New = false;
        break;
      case 'Page_Customer':
        this.checkPageFind = false;
        this.checkPageCustomer = !this.checkPageCustomer;
        this.checkPageOther = false;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'Page_Other':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = !this.checkPageOther;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'Page_Camera':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageCamera = !this.checkPageCamera;
        this.ngOnCameraClicked();
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'Page_Order_Wait':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checktemplatePrintBill = false;
        this.checktemplateBill = !this.checktemplateBill;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'Page_Find_PrintBill':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = !this.checktemplatePrintBill;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'PageE_Invoice':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = !this.checkPageE_Invoice;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'PageReturn_Item':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = !this.checkPage_ReturnITem;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = false;
        break;
      case 'PageMany_Items':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checkPageCamera = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = !this.checkPage_ManyItems;
        this.checkPageCamera_New = false;
        break;
      case 'Page_CameraNew':
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageCamera = false;
        this.ngOnCameraClicked();
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera_New = !this.checkPageCamera_New;
        break;
      default:
        this.checkPageFind = false;
        this.checkPageCustomer = false;
        this.checkPageOther = false;
        this.checkPageCamera_New = false;
        this.checktemplateBill = false;
        this.checktemplatePrintBill = false;
        this.checkPageE_Invoice = false;
        this.checkPage_ReturnITem = false;
        this.checkPage_ManyItems = false;
        this.checkPageCamera = false;
        break;
    }
  }
  // End Code Footer


  // Begin Khach Hang
  deleteCutumer(contentError) {
    if (this.customer != null) {
      this.customer = null;
      this.valueNumber = '';
      this.order.MaKHTV = null;
      this.billService.saveBillRefresh(this.order);
      // localStorage.removeItem('_customer');
      localForage.removeItem('_customer');
      this.checkRouterCustomer();
      this.apDungLaiSuKienGia(this.order);
      this.getInto();
    } else {
      this.messageError = 'Không có Khách hàng để xóa!';
      this.openMessageError(contentError);
    }
  }


  async submitCustomer_hieuth(contentError) {
    const Makh = this.valueNumber.toString();
    this.flag_nhapkh_off();
    console.log(Makh.length);
    if (Makh.length === 13) {
      if (window.navigator.onLine) {
        await this.customerService.getCustomer_API(Makh)
          .then(async result => {
            if (result === 0) {
              this.messageError = 'Mã khách hàng không tồn tại!';
              this.openMessageError(contentError);
            } else {
              // const data: KhachHang = JSON.parse(localStorage.getItem('_customer'));
              let data: KhachHang = new KhachHang();
              await localForage.getItem('_customer').then((result: any) => {
                data = JSON.parse(result);
              });
              const name = data.TenKH;
              const idCus = data.MaKHTV;
              const Score = data.Diem;
              const LevelName = data.TenCapDo;
              const IdLevel = data.MaCapDo;
              this.order.MaKHTV = idCus;
              this.order.KHTV = data;
              this.billService.saveBillRefresh(this.order);
              this.customer = { MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel };
              this.checkRouterCustomer();
              this.apDungLaiSuKienGia(this.order);
              this.getInto();
            }
          })
          .catch(async err => {
            // err = 'Mã khách hàng không tồn tại';
            // this.messageError = err;
            // this.openMessageError(contentError);
            this.order.MaKHTV = Makh;
            this.billService.saveBillRefresh(this.order);
            this.customer = { MaKHTV: Makh, TenKH: Makh.replace(Makh.substring(4, 11), "*******"), TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' };
            this.order.KHTV = this.customer;
            this.getlocalconfig.getConfigLocalForage()
              .then(async result => {
                // tslint:disable-next-line:max-line-length
                await localForage.setItem('_customer', JSON.stringify({ MaKHTV: Makh, TenKH: Makh.replace(Makh.substring(4, 11), "*******"), TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' })).then();
              });
            this.checkRouterCustomer();
            this.apDungLaiSuKienGia(this.order);
            this.getInto();
          });
      } else {
        this.order.MaKHTV = Makh;
        this.billService.saveBillRefresh(this.order);
        this.customer = { MaKHTV: Makh, TenKH: Makh.replace(Makh.substring(4, 11), "*******"), TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' };
        this.order.KHTV = this.customer;
        this.getlocalconfig.getConfigLocalForage()
          .then(async result => {
            // tslint:disable-next-line:max-line-length
            await localForage.setItem('_customer', JSON.stringify({ MaKHTV: Makh, TenKH: Makh.replace(Makh.substring(4, 11), "*******"), TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' })).then();
          });
        this.checkRouterCustomer();
        this.apDungLaiSuKienGia(this.order);
        this.getInto();
      }
    }
    else if (Makh.length === 10) {
      const kh_hit = this.dsKHHCG.find(x => x.id === Makh)
      if (kh_hit == undefined) {
        this.messageError = 'Mã khách hàng HouseCharge không tồn tại!';
        this.openMessageError(contentError);
      } else {
        // const data: KhachHang = JSON.parse(localStorage.getItem('_customer'));

        const name = kh_hit.name;
        const idCus = kh_hit.id;
        const Score = '0';
        const LevelName = kh_hit.typeName;
        const IdLevel = kh_hit.type;
        this.order.MaKHTV = idCus;
        this.customer = { MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel };
        this.order.KHTV = this.customer;
        this.billService.saveBillRefresh(this.order);
        this.getlocalconfig.getConfigLocalForage()
          .then(async result => {
            // tslint:disable-next-line:max-line-length
            await localForage.setItem('_customer', JSON.stringify({ MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel })).then();
          });
        this.checkRouterCustomer();
        this.apDungLaiSuKienGia(this.order);
        this.getInto();
      }
    }
    else {
      this.messageError = 'Mã khách hàng không đúng định dạng!';
      this.openMessageError(contentError);
    }
  }

  // End Khach Hang
  async setNumberMaxBill() {
    // const data: Array<HoaDon> = JSON.parse(localStorage.getItem('_curHDTong'));
    let data: Array<HoaDon> = new Array<HoaDon>();
    await localForage.getItem('_curHDTong').then((result: any) => {
      data = JSON.parse(result);
    });
    console.log('data');
    console.log(data);
    let numberMax = 0;
    let ngayLapHD = new Date;
    if (data) {
      data.forEach(x => {
        if (x.STTHD > numberMax) {
          numberMax = x.STTHD;
          ngayLapHD = x.NgayHD;
        }
      });
    } else {
      if (this.numberHD > 1) {
        numberMax = this.numberHD - 1;
      }
    }
    const curSoHD: SoHD = {
      SoHD: numberMax,
      NgayLapHD: ngayLapHD
    };
    this.getlocalconfig.getConfigLocalForage()
      .then(async res => {
        localForage.setItem('_curSoHD', JSON.stringify(curSoHD));
      });
  }

  async getNumberMaxBill() {
    // const data: SoHD = JSON.parse(localStorage.getItem('_curSoHD'));
    let data: SoHD = new SoHD();
    // await localForage.getItem('_curSoHD').then((result: any) => {
    //   data = JSON.parse(result);
    //   console.log(data);
    // })
    // .catch (err => {
    //   console.log('Lỗi');
    // });

    const getcurSoHD = await localForage.getItem('_curSoHD').then((result: any) => JSON.parse(result));
    data = getcurSoHD;
    console.log(data);
    const now = new Date;
    if (data) {
      const date = new Date(data.NgayLapHD);
      if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth()) {
        let curHDTong: Array<HoaDon> = new Array<HoaDon>();
        let numberMax = await localForage.getItem('_curHDTong').then((result: any) => {
          let numberHD = 0;
          if (result) {
            curHDTong = JSON.parse(result);
            curHDTong.forEach(x => {
              if (x.STTHD > numberHD) {
                numberHD = x.STTHD;
              }
            });
          }
          return numberHD;
        });
        console.log('numberMax');
        console.log(numberMax);
        if (numberMax < data.SoHD) {
          numberMax = data.SoHD;
        }
        if (!this.numberHD || this.numberHD < numberMax) {
          const getcurHD = await localForage.getItem('_curHD').then((result: string) => JSON.parse(result));
          if (getcurHD === null ||
            (getcurHD !== null && (getcurHD.STTHD === null || getcurHD.STTHD === undefined)) ||
            getcurHD === undefined) {
            this.numberHD = numberMax + 1;
          }
          this.order.HoaDonID = uuid();
          this.order.MaQuay = this.dtQBan.MaQuay;
          this.order.MaCH = this.dtQBan.MaCH;
          const t = moment();
          const s = t.format('DDMMYY');
          this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
          this.order.STTHD = this.numberHD;
          this.billService.saveBillRefresh(this.order);
        }
      } else {
        this.getLengthHD();
      }
    } else {
      this.getLengthHD();
    }

  }

  async Logout() {
    const Now_Date = moment().format('YYYY-MM-DD');
    let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
    await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
    var tpcQuayBanMaCQT: any = {
      Store: macqt_luutru.StoreID,
      Register: macqt_luutru.MaQuay,
      Year: macqt_luutru.Nam,
      MACQT: macqt_luutru.MaCQT,
      Update_Date: Now_Date,
      CQT_Location: macqt_luutru.CQT_location
    }
    this.products = [];
    this.upload_saleBackup_FTP();
    this.upload_saleBackup_FTP_CQT_Logout();
    await this.authenticationService.UpdateQuayBan_MaCQT_Logout(tpcQuayBanMaCQT);
    await this.setCheckAllBill();
    await this.setNumberMaxBill();
    await this.authenticationService.logout();
  }

  async Force_Logout() {
    await this.authenticationService.check_force_logout()
      .then(result => {
        return;
      })
      .catch(err => {
        console.log(err);
        this.messageError = err.message;
        this.openMessageError(this.contentError);
        this.authenticationService.force_logout();
      });
  }

  async Force_UpdateItem() {
    await this.productService.check_force_update()
      .then((result: any) => {
        if (result == true) {
          this.messageNoti = "Cập nhật hàng hóa thành công!";
          this.modalService.open(this.contentNoti, { centered: true, backdrop: 'static', keyboard: false });
          return;
        }
      })
      .catch(err => {
        console.log(err);
        this.messageError = "Cập nhật hàng hóa thất bại! Vui lòng refresh để thử lại";
        this.openMessageError(this.contentError);
      });
  }

  refresh() {
    window.location.reload();
  }

  // Tim san pham
  setValueFind(value: string) {
    this.valueFind = this.valueFind + value;
  }

  backValueFind(value: string) {
    const index = value.substring(0, value.length - 1);
    this.valueFind = index;
    console.log(index);
  }
  clearValueFind() {
    this.valueFind = '';
  }

  async openVerticallyCentered(contentError) {
    if (await this._checkDate().then(data => data)) {
      this._cancelCartNextDate();
      return null;
    }
    if (this.orderWait.length === 0) {
      // this.messageError = 'Không có Hóa Đơn đợi!';
      this.messageError = 'Không có Giao Dịch đợi!';
      this.openMessageError(contentError);
    } else {
      const openOrderWait = 'Page_Order_Wait';
      this.checkAllPage(openOrderWait);
    }

  }

  async submitWaitbill(contentError) {
    const tdate = moment();
    const date = tdate.format('YYYY-MM-DD');
    var strmaCQT = "";
    var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
    var MACQT: MaCQT = new MaCQT();
    await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
    var kytu = "";
    let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1
    MACQT = {
      MaCQT: MaCQTCongDon,
      MaKhuVuc: MACQT.MaKhuVuc,
      MaQuay: MACQT.MaQuay,
      Nam: MACQT.Nam,
      TenQuay: MACQT.TenQuay,
      CQT_location: MACQT.CQT_location,
      StoreID: MACQT.StoreID
    }
    await localForage.setItem('_MaCQT', JSON.stringify(MACQT))
    var socuoinam = MACQT.Nam.substring(2, 4)
    if (MACQT.MaCQT.toString().length === 1) {
      kytu = "0000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 2) {
      kytu = "000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 3) {
      kytu = "00" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 4) {
      kytu = "0" + MACQT.MaCQT;
    } else {
      kytu = MACQT.MaCQT.toString();
    }
    // chuyển sang lưu local cho phần này
    strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
    TPCQuayBanMaCQT = {
      Store: MACQT.StoreID,
      Register: MACQT.MaQuay,
      MACQT: MACQT.MaCQT.toString(),
      Update_Date: date,
      Year: MACQT.Nam,
      CQT_Location: MACQT.CQT_location
    }
    console.log(TPCQuayBanMaCQT)
    console.log(TPCQuayBanMaCQT.MACQT)
    let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + TPCQuayBanMaCQT.CQT_Location + "\n" + strmaCQT + "";
    //this.save_salebackup_POS(data, TPCQuayBanMaCQT.Register, MACQT.CQT_location);
    //if (window.navigator.onLine === true) {
    var fileNameCQT = TPCQuayBanMaCQT.Register + "_" + MACQT.CQT_location
    this.upload_saleBackup_FTP_CQT(fileNameCQT, data)
    // Kết thúc phần Trí thêm
    if (await this._checkDate().then(data => data)) {
      this._cancelCartNextDate();
      return null;
    }
    if (this.orderWait.length >= 5) {
      this.messageError = 'Số lượng hóa đơn đợi không vượt quá 5. \n Vui lòng xử lý các hóa đơn đợi trước đó.';
      this.openMessageError(contentError);
      return false;
    }
    const index: HoaDon = this.listHD_Tong.find(x => x.STTHD === this.numberHD);
    const now = new Date();
    let maKH;
    console.log(this.listCart);
    if (this.customer) {
      maKH = this.customer.MaKHTV;
    } else {
      maKH = '';
    }
    if (this.listCart !== undefined) {
      if (this.listCart.length === 0) {
        this.messageError = 'Không có hàng hóa để đưa vào hàng đợi!';
        this.openMessageError(contentError);
      } else {
        this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

        if (index) {
          const i = this.listHD_Tong.indexOf(index);
          if (this.customer) {
            this.listHD_Tong[i].KHTV = this.customer;
          }
          this.listHD_Tong[i].MaKHTV = maKH;
          this.listHD_Tong[i].CTHoaDons = this.listCart;
          this.listHD_Tong[i].LoaiHD = 2;
          this.listHD_Tong[i].STTHD = this.numberHD;
          this.listHD_Tong[i].NgayHD = now;
          this.listHD_Tong[i].TongTien = this.total;
          this.listHD_Tong[i].GhiChu = this.billNotes;
          this.billService.saveTotalBillRefresh(this.listHD_Tong);
        } else {
          if (this.customer) {
            this.order.KHTV = this.customer;
          }
          this.order.CTHoaDons = this.listCart;
          this.order.MaKHTV = maKH;
          this.order.MaNV = this.user.MaNV;
          this.order.NgayHD = now;
          this.order.TongTien = this.total;
          this.order.LoaiHD = 2; /*(2: là hoá đơn đợi)*/
          this.order.STTHD = this.numberHD;
          this.order.GhiChu = this.billNotes;

          const t = moment();
          const s = t.format('DDMMYY');
          this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
          this.listHD_Tong.push(this.order);
          this.billService.saveTotalBillRefresh(this.listHD_Tong);
        }
        const hd_wait: HoaDon = JSON.parse(JSON.stringify(this.order));
        var get_MaCQT: MaCQT = new MaCQT();
        await localForage.getItem('_MaCQT').then((result: any) => get_MaCQT = JSON.parse(result));
        var waitbillmacqt: Waitbill_MaCQT = {
          CQT_location: get_MaCQT.CQT_location,
          HoaDonID: this.order.HoaDonID,
          MaCQT: get_MaCQT.MaCQT,
          MaKhuVuc: get_MaCQT.MaKhuVuc,
          MaQuay: get_MaCQT.MaQuay,
          Nam: get_MaCQT.Nam,
          StoreID: get_MaCQT.StoreID,
          TenQuay: get_MaCQT.TenQuay,
          LoaiHoaDon: 2
        }
        const waitbill_cqt: Waitbill_MaCQT = JSON.parse(JSON.stringify(waitbillmacqt));
        this.Waitbill_MaCQT.push(waitbill_cqt);
        this.orderWait.push(hd_wait);
        this.orderWait_temp.push(hd_wait);
        this.billService.saveWaitingBillLocal_CQT(this.Waitbill_MaCQT);
        this.billService.saveWaitingBillLocal(this.orderWait_temp);
        this.billService.saveWaitingBillRefresh(this.orderWait);
        this.listCart = [];
        this.billNotes = '';
        this.customer = null;
        this.valueNumber = '';
        // localStorage.removeItem('_customer');
        localForage.removeItem('_customer');
        this.getInto();
        this.PrintCart();
        this.getLengthHD();
        this.checkRouterOther();
        this.closeModal();
      }
    } else {
      this.closeModal();
      this.messageError = 'Không có hàng hóa để đưa vào hàng đợi!';
      this.openMessageError(contentError);
    }
  }
  submitReturnBill(contentError) {
    this._isDisabledState = false;
    let _valuenumber: number;
    if (this.valueModal && this.radioSelected) {
      this.messageError = 'Chỉ được chọn 1 trong 2.';
      this.openMessageError(contentError);
    } else if (!this.valueModal && !this.radioSelected) {
      // this.messageError = 'Hãy nhập số hoá đơn cần phục hồi.';
      this.messageError = 'Hãy nhập số giao dịch cần phục hồi.';
      this.openMessageError(contentError);
    } else {
      if (this.valueModal && !this.radioSelected) {
        _valuenumber = this.valueModal;
      } else {
        _valuenumber = this.radioSelected;
        this.radioSelected = null;
      }
      const index: HoaDon = this.orderWait.find(x => x.STTHD === +_valuenumber);
      if (index) {
        if (this.listCart === undefined || this.listCart.length === 0) {
          if (this.order.CTHoaDons === null || this.order.CTHoaDons.length === 0) {
            this.order = index;
            this.billNotes = index.GhiChu;
            this.order.MaKHTV = index.MaKHTV;
            if (index.KHTV) {
              this.customer = index.KHTV;
            }
            this.order.LoaiHD = 1;
            this.billService.saveBillRefresh(this.order);
            this.apDungGiaSauChinhSua(index.CTHoaDons);
            this.listCart = index.CTHoaDons;
            this.numberHD = index.STTHD;
            const i = this.orderWait.indexOf(index);
            this.orderWait.splice(i, 1);
            this.billService.saveWaitingBillRefresh(this.orderWait);
            if (index.KHTV && index.KHTV.MaCapDo === 'N/A') {
              this.getCustomer(index.MaKHTV);
            }
            // Trí thêm test
            this.apDungLaiSuKienGia(this.order);
            // kết thúc phần Trí test
            this.checkAllPage('');
            this.getInto();
          }
          else {
            this.messageError = 'Hãy hủy hoặc thanh toán hóa đơn hiện tại rồi tiếp tục chức năng này.';
            this.openMessageError(contentError);
          }
        } else {
          this.messageError = 'Có hàng hoá trong lưới bạn cần phải đưa vào hàng chờ hoặc huỷ giao dịch để thực hiện chức năng này!';
          this.openMessageError(contentError);
        }
      } else {
        this.messageError = 'Không có số giao dịch cần phục hồi !!!!';
        this.openMessageError(contentError);
      }
    }
    this.valueModal = null;
    const valueIcon = "TurnOffIcon_BGDefault";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
  }
  apDungGiaSauChinhSua(CTHoaDons: CTHoaDon[]) {
    CTHoaDons.forEach(x => {
      let checkPriceNew = this.products.find(y => y.HangHoaID === x.HangHoaID);
      if (checkPriceNew) {
        x.DGBan = checkPriceNew.GiaBanLe;
        x.DGBanCK = checkPriceNew.GiaBanLe - (x.TienCK + x.TienCKHD);
        x.ChietKhau = (x.TienCK * x.SoLuong) + (x.TienCKHD * x.SoLuong);
      }
    });
  }

  async getCustomer(id: string) {
    if (id !== '') {
      if (window.navigator.onLine) {
        await this.customerService.getCustomer_API(id)
          .then(async result => {
            // const data: KhachHang = JSON.parse(localStorage.getItem('_customer'));
            let data: KhachHang = new KhachHang();
            await localForage.getItem('_customer').then((result: any) => {
              data = JSON.parse(result);
            });
            const name = data.TenKH;
            const idCus = data.MaKHTV;
            const Score = data.Diem;
            const LevelName = data.TenCapDo;
            const IdLevel = data.MaCapDo;
            this.order.MaKHTV = idCus;
            this.order.KHTV = data;
            this.billService.saveBillRefresh(this.order);
            this.customer = { MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel };
            this.apDungLaiSuKienGia(this.order);
            this.getInto();
            //this.billService.saveBillRefresh(this.order);
            //this.customer = { MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel };
            //this.apDungLaiSuKienGia(this.order);
          })
          .catch(err => {
            console.log(err)
            this.order.MaKHTV = id;
            this.billService.saveBillRefresh(this.order);
            this.customer = { MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' };
            this.order.KHTV = this.customer;
            this.getlocalconfig.getConfigLocalForage()
              .then(async result => {
                // tslint:disable-next-line:max-line-length
                await localForage.setItem('_customer', JSON.stringify({ MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' })).then();
              });
            this.apDungLaiSuKienGia(this.order);
            this.getInto();
            //this.order.MaKHTV = id;
            //this.customer = { MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' };

            //this.getlocalconfig.getConfigLocalForage()
            //  .then(async result => {
            //    // tslint:disable-next-line:max-line-length
            //    await localForage.setItem('_customer', JSON.stringify({ MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' })).then();
            //  });
          });
      } else {
        this.order.MaKHTV = id;
        this.billService.saveBillRefresh(this.order);
        this.customer = { MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' };
        this.order.KHTV = this.customer;
        this.getlocalconfig.getConfigLocalForage()
          .then(async result => {
            // tslint:disable-next-line:max-line-length
            await localForage.setItem('_customer', JSON.stringify({ MaKHTV: id, TenKH: 'Không xác định', TenCapDo: 'N/A', Diem: 'N/A', MaCapDo: 'N/A' })).then();
          });
        this.apDungLaiSuKienGia(this.order);
        this.getInto();
      }
    }
  }

  public KiemTra_KetNoi() {
    const onl_flag = document.getElementsByClassName('online-flag') as HTMLCollectionOf<HTMLElement>;
    const off_flag = document.getElementsByClassName('offline-flag') as HTMLCollectionOf<HTMLElement>;
    if (window.navigator.onLine === true) {
      // if(this.minOffline > 0)
      // {
      //   // this.mr = await this.modalService.open(this.contentLoading, { centered: true, backdrop: 'static', keyboard: false });
      //   await this.setCheckAllBill();
      //   this.minOffline = 0;
      //   this.closeModal();
      // }
      // this.minOffline = 0;
      if (onl_flag.length !== 0) {
        onl_flag[0].style.opacity = '1';
      }
      if (off_flag.length !== 0) {
        off_flag[0].style.opacity = '0.2';
      }
    } else {
      if (this.minOffline === undefined || this.minOffline === NaN) {
        this.minOffline = 0;
      }
      this.minOffline += 1;
      if (onl_flag.length !== 0) {
        onl_flag[0].style.opacity = '0.2';
      }
      if (off_flag.length !== 0) {
        off_flag[0].style.opacity = '1';
      }
    }
  }

  changeCheckMoney() {
    if (this.total > this.valueNumberLabel) {
      this.isValidCheckMoney = true;
    } else {
      this.isValidCheckMoney = false;
    }
    if (this.valueNumberLabel === 0 || this.valueNumberLabel === null) {
      this.isValidConfirmPayment = true;
    } else {
      this.isValidConfirmPayment = false;
    }
  }

  changeCheckMoney_Payment() {
    if (this.total > this.valueMoney_All) {
      this.isValidCheckMoney = true;
    } else {
      this.isValidCheckMoney = false;
    }
    // if (this.valueMoney_All === 0 || this.valueMoney_All === null) {
    //   this.isValidConfirmPayment = true;
    // } else {
    //   this.isValidConfirmPayment = false;
    // }
  }

  async openCancelOrder(contentCancelOrder, contentError) {
    await this.showConfirmTillKey().then((res: boolean) => {
      if (res) {
        this.isValidCheckEnter = true;
        if (!this.listCart || this.listCart.length === 0) {
          // this.messageError = 'Không có hoá đơn nào để huỷ!';
          this.messageError = 'Không có giao dịch nào để huỷ!';
          this.openMessageError(contentError);
        } else {
          this.modalService.open(contentCancelOrder, { centered: true });

        }
      }
    });
  }

  openKetCa(contentEndWord, contentError) {
    if (window.navigator.onLine === true) {
      console.log(this.listCart);
      if (!this.listCart || this.listCart.length === 0) {
        if (this.orderWait.length > 0) {
          // this.messageError = 'Vui lòng kết thúc hóa đơn đợi trước khi đăng xuất!';
          this.messageError = 'Vui lòng kết thúc giao dịch đợi trước khi đăng xuất!';
          this.modalService.open(contentError, { centered: true });
        } else {
          if (this.modalService.open(contentEndWord, { centered: true })) {

          }
        }
      } else {
        // this.messageError = 'Vui lòng kết thúc hóa đơn hiện tại trước khi đăng xuất!';
        this.messageError = 'Vui lòng kết thúc giao dịch hiện tại trước khi đăng xuất!';
        this.modalService.open(contentError, { centered: true });
      }
    }
    else {
      this.messageError = 'Đang trong trạng thái offline, bạn không được đăng xuất!';
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
  }

  flag_nhapkh_on() {
    this.flag_nhapkh = true;
  }

  flag_nhapkh_off() {
    this.flag_nhapkh = false;
  }

  flag_nhapSrcPrc_on() {
    this.flag_nhapSrcPrc = true;
  }

  flag_nhapSrcPrc_off() {
    this.flag_nhapSrcPrc = false;
  }

  onScan(valueCode) {
    console.log(valueCode);
  }
  onError(valueError) {
    console.log(valueError);
  }

  inputFocusPaymentOn() {
    this._isFocusPayment = true;
  }

  inputFocusPaymentOff() {
    this._isFocusPayment = false;
  }

  getBg_Color() {
    if (window.navigator.onLine === true) {
      this.bgColorService.GetBackground()
        .then(result => {
          this.valueBg_Color.bg_overall = result.bg_overall;
          this.valueBg_Color.bg_content = result.bg_content;
          this.valueBg_Color.bg_sumbill = result.bg_sumbill;
          this.valueBg_Color.color_content = result.color_content;
        })
        .catch(err => console.log(err));
    } else {
      localForage.getItem('_colorBG').then((result: any) => {
        this.valueBg_Color = JSON.parse(result);
      })
        .catch(err => {
          console.log('Lỗi');
        });
    }
  }
  chitiet(contentChiTiet) {
    this.modalService.open(contentChiTiet, { centered: true });
  }
  returnWaitBill() {
    const value = 'Page_Other';
    this.checkAllPage(value);
  }

  chonHTTT() {
    // this.enterInputMoney();
    // if (this._isCheckInputMoney) {
    //   setTimeout(x => document.getElementById('valueInputMoney').focus(), 100);
    // }
    // return false;

    if (this.selectedValue.MaNhomThanhToan === '001') {
      this.checkMoneyFace = true;
      this.checkPaymentBill = false;
    } else if (this.selectedValue.MaNhomThanhToan === '003') {
      this.checkCreditCard = true;
      this.checkPaymentBill = false;
    } else if (this.selectedValue.MaNhomThanhToan === '005') {
      this.checkVoucher = true;
      this.checkPaymentBill = false;
    } else if (this.selectedValue.MaNhomThanhToan === '013') {
      this.checkQR = true;
      this.checkPaymentBill = false;
    } else if (this.selectedValue.MaNhomThanhToan === '201') {
      window["TPCGoWV"].ThanhToanVNPAY_POS(this.order.MaHD, this.total);
    } else if (this.selectedValue.MaNhomThanhToan === '202') {
      window["TPCGoWV"].ThanhToanVNPAY_QR(this.order.MaHD, this.total);
    }
  }

  @Input()
  receiveData_SPOS(TransactionCode: string, RefCode: string, Mahtt: string, status: string) {

    console.log("Dữ liệu trả về từ Spos APp: " + Mahtt + " //// Tình trạng: " + status);
    console.log("Dữ liệu trả về từ Spos Đơn hàng: " + TransactionCode + " //// Tham chiếu: " + RefCode);
  }

  @Input()
  async updateFromMyJavaApp(data: any) {

    console.log("Dữ liệu trả về từ Spos APp: " + JSON.stringify(data));
    let app_rsp: App_Response = data;
    let vnp_rsp: VNPay_Response = JSON.parse(JSON.stringify(data));
    console.log("Dữ liệu trả về từ Spos TransCode: " + vnp_rsp.TransactionCode);
    console.log("Dữ liệu trả về từ Spos MaHTTT : " + vnp_rsp.MaHTTT);
    console.log("Dữ liệu trả về từ Spos Status: " + vnp_rsp.status);
    if (vnp_rsp.status == 1) {
      //console.log("Thanh  toan thanh cong");
      //console.log("Thuc hien buoc tiep theo");
      //Thanh toán VNPAY thành công!
      const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
      console.log(index);
      if (!index) {
        const data: TTHD = {
          HTTT: {
            DoUuTien: this.selectedValue.DoUuTien,
            MaHinhThuc: this.selectedValue.MaHinhThuc,
            MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
            MaThe: vnp_rsp.TransactionCode,
            TenHinhThuc: this.selectedValue.TenHinhThuc,
            TenNhom: this.selectedValue.TenNhom
          },
          SoTienThanhToanHD: this.total
        };
        await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
          .then((result: any) => {
            data.QuyDoiNgoaiTe = result.QuyDoi;
            data.TyLeQuyDoi = result.TyLe;
          });
        // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);

        this.payBill.push(data);
      } else {
        const i = this.payBill.indexOf(index);
        this.payBill[i].SoTienThanhToanHD = this.total;
        // this.payBill[i].QuiDoiNgoaiTe = this.xc_ForeignCurr(this.payBill[i].SoTienThanhToanHD);
        await this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
          .then((result: any) => {
            this.payBill[i].QuyDoiNgoaiTe = result.QuyDoi;
            this.payBill[i].TyLeQuyDoi = result.TyLe;
          });

        this.payBill[i].HTTT.MaThe = vnp_rsp.TransactionCode;
      }
      await this.setChange_Payment();
      await this.submitPrintCart_TriPH(this.contentLitmit_CQT, this.contentError);
      //this.openBackPayment_CreditCard();
      //console.log(this.payBill);
    }
    else if (vnp_rsp.status == 0) {
      this.messageError = "Thanh toán hình thức VNPAY chưa hoàn tất! Vui lòng thử lại hoặc chọn hình thức khác!";
      this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
    else if (vnp_rsp.status == 2) {
      this.checkFlag_ScannedCode(vnp_rsp.RefCode);
    }
    //console.log("Dữ liệu trả về từ Spos Đơn hàng: " + TransactionCode + " //// Tham chiếu: " + RefCode);
  }

  nhaptien() {
    this.enterInputMoney();
    if (this._isCheckInputMoney) {
      setTimeout(x => document.getElementById('valueInputMoney').focus(), 100);
    }
    return false;
  }
  setValueLab() {
    if (this.valueNumberLabel !== 0) {
      this.valueNumberLabel += this.valueInputMoney;
    } else {
      this.valueNumberLabel = this.valueInputMoney;
    }
    if (this.payBill) {
      const index = this.payBill.find(x => x.HTTT.MaNhomThanhToan === this.selectedValue.MaNhomThanhToan);
      if (!index) {
        const pay: TTHD = { HTTT: this.selectedValue, SoTienThanhToanHD: this.valueInputMoney };
        this.xc_ForeignCurr_async(pay.SoTienThanhToanHD)
          .then((result: any) => {
            pay.QuyDoiNgoaiTe = result.QuyDoi;
            pay.TyLeQuyDoi = result.TyLe;
          });
        // .then((result: any) => pay.QuiDoiNgoaiTe = result);
        // pay.QuiDoiNgoaiTe = this.xc_ForeignCurr(pay.SoTienThanhToanHD);

        this.payBill.push(pay);
      } else {
        const i = this.payBill.indexOf(index);
        this.payBill[i].SoTienThanhToanHD += this.valueInputMoney;
      }
    } else {
      const pay: TTHD = { HTTT: this.selectedValue, SoTienThanhToanHD: this.valueInputMoney };
      pay.QuyDoiNgoaiTe = this.xc_ForeignCurr(pay.SoTienThanhToanHD);
      this.xc_ForeignCurr_async(pay.SoTienThanhToanHD)
        .then((result: any) => {
          pay.QuyDoiNgoaiTe = result.QuyDoi;
          pay.TyLeQuyDoi = result.TyLe;
        });
      this.payBill.push(pay);
    }
    console.log(this.payBill);
  }
  enterInputMoney() {
    this.valueInputMoney = null;
    this._isCheckInputMoney = !this._isCheckInputMoney;
  }
  ListHTTT() {
    this.valueInputMoney = null;
    console.log(this.payBill);
  }
  // Begin Page Camera
  bIsUsingQrScanner = false;

  ngOnCameraClicked(): void {
    this.hasDevices = true;
    this.ngGetAvailableDevices()
      .then(() => {
        return this.ngGetDevicePermissions();
      })
      .then((mediaStream: MediaStream) => {
        const mediaTracks = mediaStream.getTracks();
        mediaTracks.forEach(x => x.stop());
        this.bIsUsingQrScanner = true;
      })
      .catch(err => console.log(err));
  }

  private ngGetAvailableDevices(): Promise<MediaDeviceInfo[]> {
    try {
      return navigator
        .mediaDevices
        .enumerateDevices()
        .then((devices: MediaDeviceInfo[]) => {

          if (!devices || !devices.length) {
            return null;
          }

          devices = devices.filter((device: MediaDeviceInfo) => device.kind === 'videoinput');

          if (!devices || !devices.length) {
            return null;
          }

          return devices;
        });
    } catch (exception) {
      return new Promise((resolve, reject) => {
        reject();
      });
    }
  }
  private ngGetDevicePermissions(): Promise<MediaStream> {
    return navigator
      .mediaDevices
      .getUserMedia({ video: true });
  }


  // clearResult(): void {
  //   this.qrResultString = null;
  // }

  // onCamerasFound(devices: MediaDeviceInfo[]) {
  //   this.selectedCamera = devices[0];
  //   this.availableCameras = devices;
  // }

  // ngOnCameraSelected(deviceId: string): void {
  //   // this.selectedCamera = this.qrScanner.getDeviceById(deviceId);
  //   // Get device by id.
  //   let items = this.availableCameras.filter((availableCamera: MediaDeviceInfo) => {
  //     return availableCamera.deviceId == deviceId;
  //   });

  //   if (!items || !items.length)
  //     return;

  //   this.qrScanner.restartScan();
  //   this.selectedCamera = items[0];
  // }

  // toggleTorch(): void {
  //   this.torchEnabled = !this.torchEnabled;
  // }

  // onCodeResult(resultString: string) {
  //   this.qrResultString = resultString;
  // }

  clearResult(): void {
    this.qrResultString = null;
  }

  getBackCamera() {
    return VideoInputDevice;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    console.log(devices);
    this.currentDevice = devices[devices.length - 1];
    this.hasDevices = Boolean(devices && devices.length);
  }

  AddItemtoCart(ItemCode: string) {
    return null;
  }


  async onCodeResult(resultString: string, contentError) {
    this.qrResultString = resultString;
    var MaPLU = "";
    if (this.qrResultString.substring(0, 2) == "29") {
      MaPLU = this.qrResultString.substring(2, 7);
    } else if (this.qrResultString.substring(0, 3) === "029") {
      MaPLU = this.qrResultString.substring(3, 8);
    } else if (this.qrResultString.substring(0, 6) === "000000") {
      MaPLU = this.qrResultString.substring(8, 13);
    }
    let product: HangHoa = new HangHoa();
    if (MaPLU != "") {
      product = this.products.find(x => x.PLU === MaPLU);
    }
    else {
      product = this.products.find(x => x.MaHH === this.qrResultString || x.SKU === this.qrResultString);
    }
    if (product) {
      let p_quantity = 1;
      if (this.qrResultString.substring(0, 2) == "29" && MaPLU !== "") {
        let catSoLuongCuaHangHoaPLU: any = this.qrResultString.substring(7, 12);
        p_quantity = catSoLuongCuaHangHoaPLU / 1000;
      }
      else if (this.qrResultString.substring(0, 3) === "029" && MaPLU !== "" || this.valueInput.substring(0, 5) === "000000" && MaPLU !== "") {
        p_quantity = p_quantity;
      }
      if (!(product.DonViTinh.toLowerCase() != "met" && product.DonViTinh.toLowerCase() != "kg")) {
        //this.mr.close()
        await this.showInputQuanty().then((res: boolean) => {
          if (res) {
            if (this.scan_quantity > 0) {
              p_quantity = this.scan_quantity;
              this.scan_quantity = 0;
              if (this.listCart) {
                const index = this.listCart.find(x => x.MaHH === this.qrResultString || x.SKU === this.qrResultString);
                if (index) {
                  const amount = index.SoLuong + p_quantity;
                  const i = this.listCart.indexOf(index);
                  this.listCart[i].SoLuong = amount;
                } else {
                  const stt = this.listCart.length + 1;
                  const n: CTHoaDon = {
                    VATDauRa: product.VATDauRa,
                    HangHoaID: product.HangHoaID,
                    Stt: stt,
                    HinhAnh: product.HinhAnh,
                    MaHH: product.MaHH,
                    TenHH: product.TenHH,
                    SoLuong: p_quantity,
                    DGBan: product.GiaBanLe,
                    DGBanCK: product.GiaBanLe,
                    ChietKhau: 0,
                    TienCK: 0,
                    TyLeCK: 0,
                    TienCKHD: 0,
                    TyLeCKHD: 0,
                    SKU: product.SKU,
                    NgayGioQuet: this.GetCurTime_UTC(),
                    MaNCC: product.MaNCC
                  };
                  this.SuKienGia(n, product);
                  this.listCart.push(n);
                }
              } else {
                const n: CTHoaDon = {
                  VATDauRa: product.VATDauRa,
                  HangHoaID: product.HangHoaID,
                  Stt: 1,
                  HinhAnh: product.HinhAnh,
                  MaHH: product.MaHH,
                  TenHH: product.TenHH,
                  SoLuong: p_quantity,
                  DGBan: product.GiaBanLe,
                  DGBanCK: product.GiaBanLe,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: product.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: product.MaNCC
                };
                this.SuKienGia(n, product);
                this.cart.push(n);
                this.listCart = this.cart;

              }
              this.cart = [];
              //this.closeModal();
              this.checkPageCamera = !this.checkPageCamera; /*Coment lại để chỉnh sửa lại trang camera mới (checkPageCamera_New)*/
              //this.checkPageCamera_New = !this.checkPageCamera_New; /*Coment lại để chỉnh sửa lại trang camera mới (checkPageCamera_New)*/
              this.getInto();
              this.order.CTHoaDons = this.listCart;
              this.order.TongTien = this.total;
              this.billService.saveBillRefresh(this.order);
            }
            else {
              this.messageError = "Số lượng phải khác 0! Vui lòng nhập lại!";
              this.openMessageError(contentError);

            }
          }
        });
      }
      else {

        if (this.listCart) {
          const index = this.listCart.find(x => x.MaHH === this.qrResultString || x.SKU === this.qrResultString);
          if (index) {
            const amount = index.SoLuong + p_quantity;
            const i = this.listCart.indexOf(index);
            this.listCart[i].SoLuong = amount;
          } else {
            const stt = this.listCart.length + 1;
            const n: CTHoaDon = {
              VATDauRa: product.VATDauRa,
              HangHoaID: product.HangHoaID,
              Stt: stt,
              HinhAnh: product.HinhAnh,
              MaHH: product.MaHH,
              TenHH: product.TenHH,
              SoLuong: p_quantity,
              DGBan: product.GiaBanLe,
              DGBanCK: product.GiaBanLe,
              ChietKhau: 0,
              TienCK: 0,
              TyLeCK: 0,
              TienCKHD: 0,
              TyLeCKHD: 0,
              SKU: product.SKU,
              NgayGioQuet: this.GetCurTime_UTC(),
              MaNCC: product.MaNCC
            };
            this.SuKienGia(n, product);
            this.listCart.push(n);
          }
        } else {
          const n: CTHoaDon = {
            VATDauRa: product.VATDauRa,
            HangHoaID: product.HangHoaID,
            Stt: 1,
            HinhAnh: product.HinhAnh,
            MaHH: product.MaHH,
            TenHH: product.TenHH,
            SoLuong: p_quantity,
            DGBan: product.GiaBanLe,
            DGBanCK: product.GiaBanLe,
            ChietKhau: 0,
            TienCK: 0,
            TyLeCK: 0,
            TienCKHD: 0,
            TyLeCKHD: 0,
            SKU: product.SKU,
            NgayGioQuet: this.GetCurTime_UTC(),
            MaNCC: product.MaNCC
          };
          this.SuKienGia(n, product);
          this.cart.push(n);
          this.listCart = this.cart;

        }
        this.cart = [];
        this.closeModal();
        this.checkPageCamera = !this.checkPageCamera; /*Coment lại để chỉnh sửa lại trang camera mới (checkPageCamera_New)*/
        //this.checkPageCamera_New = !this.checkPageCamera_New; /*Coment lại để chỉnh sửa lại trang camera mới (checkPageCamera_New)*/
        this.getInto();
        this.order.CTHoaDons = this.listCart;
        this.order.TongTien = this.total;
        this.billService.saveBillRefresh(this.order);
      }
    }
    else {
      this.checkPageCamera = !this.checkPageCamera; /*Coment lại để chỉnh sửa lại trang camera mới (checkPageCamera_New)*/
      this.closeModal();
      this.messageError = 'Mã hàng không tồn tại!';
      this.openMessageError(contentError);
    }
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
    console.log(this.hasPermission);
  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }


  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }
  // End Page Camera

  checkfromlist() {
    this._isDisabledState = !this._isDisabledState;
  }

  disbtn(): boolean {
    if (this._isDisabledState) {
      this.valueModal = null;
      return false;
    } else {
      this.radioSelected = null;
      return true;
    }
  }
  async openPrintBill(contentError) {
    // const index = this.listHD_Tong.filter(x => x.LoaiHD === 1);
    // if (this.listHD_Tong.length === 0 || index.length === 0) {
    //   // this.messageError = 'Không có Hóa Đơn in lại!';
    //   this.messageError = 'Không có Giao Dịch in lại!';
    //   this.openMessageError(contentError);
    // } else {
    //   const OpenPrintBill = 'Page_Find_PrintBill';
    //   this.checkAllPage(OpenPrintBill);
    // }

    // const booldsHD = localStorage.getItem('_dsHD');

    // const boolCurHD: HoaDon = JSON.parse(localStorage.getItem('_curHD'));
    // let boolCurHD: HoaDon;

    // ------------------------------------------------- Chỉnh sửa 4h05 18/06/2022 (Thứ 7)
    //await localForage.getItem('_curHD').then((result: any) => {
    //  console.log(result);
    //  const boolCurHD: HoaDon = JSON.parse(result);
    //  if (boolCurHD === null && boolCurHD.STTHD === 1) {
    //    this.messageError = 'Không có Giao Dịch in lại!';
    //    this.openMessageError(contentError);
    //  } else {
    //    const OpenPrintBill = 'Page_Find_PrintBill';
    //    this.checkAllPage(OpenPrintBill);
    //  }
    //});
    this.valueSelectDate_PrintBillAgain = moment().format('YYYY-MM-DD');
    const OpenPrintBill = 'Page_Find_PrintBill';
    this.checkAllPage(OpenPrintBill);
    // ------------------------------------------------- Kết thúc Chỉnh sửa 4h05 18/06/2022 (Thứ 7)

  }

  async lastBillPrint(contentError) {
    var MACQT: MaCQT = new MaCQT();
    var kytu = "";
    await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
    var socuoinam = MACQT.Nam.substring(2, 4)
    if (MACQT.MaCQT.toString().length === 1) {
      kytu = "0000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 2) {
      kytu = "000" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 3) {
      kytu = "00" + MACQT.MaCQT;
    } else if (MACQT.MaCQT.toString().length === 4) {
      kytu = "0" + MACQT.MaCQT;
    } else {
      kytu = MACQT.MaCQT.toString();
    }
    var strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;

    let lastbill: HD;
    await this.billService.getLastHD()
      .then(async (data: HD) => {
        lastbill = data;
        //if (lastbill.LoaiHD == 4) {
        //  this.closeModal();
        //  this.messageError = 'Không thể in lại hóa đơn hủy.';
        //  this.openMessageError(contentError);
        //}
        //else {          
        try {
          if (lastbill.LoaiHD === 1 || lastbill.LoaiHD === 3 || lastbill.LoaiHD === 5) {
            this.dataBill = lastbill;
            this.BillTypeOne = {
              CTHoaDons: this.dataBill.CTHoaDon,
              HoaDonID: this.dataBill.HoaDonId,
              LoaiHD: this.dataBill.LoaiHD,
              MaKHTV: this.dataBill.MaKHTV,
              MaHD: this.dataBill.MaHD,
              MaNV: this.dataBill.MaNV,
              MaQuay: this.dataBill.MaQuay,
              MaCH: this.dtQBan.MaCH,
              GhiChu: this.dataBill.GhiChu,
              NgayHD: this.dataBill.NgayHD,
              STTHD: this.dataBill.STTHD,
              TongTien: this.dataBill.TongTien,
              TienCK: this.dataBill.TongTienCK,
              TienTraKhach: this.dataBill.TienTraKhach,
              intoMoney: null,
              printWaitBill: null,
              DaTraHang: this.dataBill.DaTraHang
            };
            console.log(this.BillTypeOne);
          }
          else {
            this.messageError = 'Không thể in lại hóa đơn hủy.';
            this.openMessageError(contentError);
            this.BillTypeOne = null;
            this.valueNumberBill = null;
          }

        } catch (err) {
          this.messageError = err.message;
          this.openMessageError(contentError);
          this.BillTypeOne = null;
          this.valueNumberBill = null;
        }
        let nvhdinlai = this.dsNhanVien.find(x => x.MaNV == this.BillTypeOne.MaNV);
        const setTTHD: Array<TTHD> = new Array<TTHD>();
        const setTTHDAfter: Array<TTHD> = new Array<TTHD>();
        this.dataBill.HTThanhToan.forEach(x => {
          if (x.MaHinhThuc === '0001') {
            x.SoTienThanhToanHD += this.dataBill.TienTraKhach;
          }
          const xSoTienThanhToanHD = x.SoTienThanhToanHD;
          const xHTTT: HTTT = {
            DoUuTien: x.DoUuTien,
            MaHinhThuc: x.MaHinhThuc,
            MaNhomThanhToan: x.MaNhomThanhToan,
            TenHinhThuc: x.TenHinhThuc,
            TenNhom: x.TenNhom,
            MaThe: x.MaThe
          };
          const dataTTHD: TTHD = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD };
          let dataTTHDAfter: TTHD;
          if (xHTTT.MaHinhThuc === '0001') {
            dataTTHDAfter = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD - this.dataBill.TienTraKhach };
          } else {
            dataTTHDAfter = dataTTHD;
          }

          setTTHD.push(dataTTHD);
          setTTHDAfter.push(dataTTHDAfter);
        });
        let billCustomer: KhachHang = new KhachHang();
        if (!isNullOrUndefined(this.dataBill.MaKHTV)) {
          if (this.dataBill.MaKHTV.length > 0) {
            billCustomer.MaKHTV = this.dataBill.MaKHTV
          }
        }
        else {
          billCustomer = undefined;
        }
        let tit = "";
        if (this.dataBill.LoaiHD == 3 || this.dataBill.LoaiHD == 5) {
          tit = "PHIẾU TRẢ HÀNG";
        }
        else {
          tit = "PHIẾU TÍNH TIỀN";
        }
        await this.GenerateBill(tit,
          this.dtQBan.MaQuay,
          strmaCQT,
          nvhdinlai.TenDangNhap,
          this.VietTat_TenNhanVien(nvhdinlai.TenNV),
          this.dataBill.STTHD,
          this.dataBill.CTHoaDon,
          setTTHD,
          this.dataBill.MaCH,
          setTTHDAfter,
          billCustomer,
          this.dataBill.MaHD,
          this.dataBill.GhiChu, true);

      });
    this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

    if (this.BillTypeOne) {
      this.PrintCart();
      this.BillTypeOne = null;
      this.closeModal();
    } else {
      this.closeModal();
      this.messageError = 'Mời nhập số Giao Dịch in lại!';
      this.openMessageError(contentError);
    }

  }

  async eventPrintBillAgain(contentError) {
    if (window.navigator.onLine === true) {
      if (this.valueSelectDate_PrintBillAgain !== null && this.valueNumberBill !== null) {
        const t_ValueSelectDate = moment(this.valueSelectDate_PrintBillAgain);
        const s_ValueSelectDate = t_ValueSelectDate.format('DD/MM/YYYY');
        try {
          await this.billService.getInvoiceToday(this.valueNumberBill, this.dtQBan.MaQuay, this.dtQBan.MaCH, s_ValueSelectDate)
            .then((result: HD) => {
              if (result.LoaiHD === 1 || result.LoaiHD === 3 || result.LoaiHD === 5) {
                this.dataBill = result;
                this.BillTypeOne = {
                  CTHoaDons: this.dataBill.CTHoaDon,
                  HoaDonID: this.dataBill.HoaDonId,
                  LoaiHD: this.dataBill.LoaiHD,
                  MaCH: this.dataBill.MaCH,
                  MaKHTV: this.dataBill.MaKHTV,
                  MaHD: this.dataBill.MaHD,
                  MaNV: this.dataBill.MaNV,
                  MaQuay: this.dataBill.MaQuay,
                  /*MaCH: this.dtQBan.MaCH,*/
                  GhiChu: this.dataBill.GhiChu,
                  NgayHD: this.dataBill.NgayHD,
                  STTHD: this.dataBill.STTHD,
                  TongTien: this.dataBill.TongTien,
                  TienCK: this.dataBill.TongTienCK,
                  TienTraKhach: this.dataBill.TienTraKhach,
                  intoMoney: null,
                  printWaitBill: null,
                  DaTraHang: this.dataBill.DaTraHang,
                  MaCQT: this.dataBill.MaCQT
                };
                console.log(this.BillTypeOne);
              }

              else {
                this.messageError = 'Không thể in lại hóa đơn hủy.';
                this.openMessageError(contentError);
                this.BillTypeOne = null;
                this.valueNumberBill = null;
              }
            })
        } catch (err) {
          this.messageError = err.message;
          this.openMessageError(contentError);
          this.BillTypeOne = null;
          this.valueNumberBill = null;
        }
        let nvhdinlai = this.dsNhanVien.find(x => x.MaNV == this.BillTypeOne.MaNV);
        const setTTHD: Array<TTHD> = new Array<TTHD>();
        const setTTHDAfter: Array<TTHD> = new Array<TTHD>();
        this.dataBill.HTThanhToan.forEach(x => {
          if (x.MaHinhThuc === '0001') {
            x.SoTienThanhToanHD += this.dataBill.TienTraKhach;
          }
          const xSoTienThanhToanHD = x.SoTienThanhToanHD;
          const xHTTT: HTTT = {
            DoUuTien: x.DoUuTien,
            MaHinhThuc: x.MaHinhThuc,
            MaNhomThanhToan: x.MaNhomThanhToan,
            TenHinhThuc: x.TenHinhThuc,
            TenNhom: x.TenNhom,
            MaThe: x.MaThe
          };
          const dataTTHD: TTHD = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD };
          let dataTTHDAfter: TTHD;
          if (xHTTT.MaHinhThuc === '0001') {
            dataTTHDAfter = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD - this.dataBill.TienTraKhach };
          } else {
            dataTTHDAfter = dataTTHD;
          }

          setTTHD.push(dataTTHD);
          setTTHDAfter.push(dataTTHDAfter);
        });
        let billCustomer: KhachHang = new KhachHang();
        if (this.dataBill.MaKHTV.length > 0) {
          billCustomer.MaKHTV = this.dataBill.MaKHTV
        }
        else {
          billCustomer = undefined;
        }
        let tit = "";
        if (this.dataBill.LoaiHD == 3 || this.dataBill.LoaiHD == 5) {
          tit = "PHIẾU TRẢ HÀNG";
        }
        else {
          tit = "PHIẾU TÍNH TIỀN";
        }
        await this.GenerateBill(tit,
          this.dtQBan.TenQuay,
          this.dataBill.MaCQT,
          nvhdinlai.TenDangNhap,
          this.VietTat_TenNhanVien(nvhdinlai.TenNV),
          this.dataBill.STTHD,
          this.dataBill.CTHoaDon,
          setTTHD,
          this.dataBill.MaCH,
          setTTHDAfter,
          billCustomer,
          this.dataBill.MaHD,
          this.dataBill.GhiChu, true);
        this.valueNumberBill = null;
        document.getElementById('focus-input').blur();
      } else {
        this.messageError = 'Vui lòng nhập số giao dịch để in lại!';
        this.openMessageError(contentError);
        this.valueNumberBill = null;
      }
    }
    else {
      this.messageError = 'Không thể tìm và in lại hóa đơn khi offline!';
      this.openMessageError(contentError);
      this.valueNumberBill = null;
    }
  }



  async eventgetHD_TraHang(contentError) {
    if (window.navigator.onLine === true) {
      if (this.valueSelectDate !== null && this.valueNumberBill !== null) {
        const t_ValueSelectDate = moment(this.valueSelectDate);
        const s_ValueSelectDate = t_ValueSelectDate.format('DD/MM/YYYY');
        const s_ValueSelectDate_ = t_ValueSelectDate.format('DD');
        const t_now = moment().format('DD');
        let day_InWeek = parseInt(t_now) - parseInt(s_ValueSelectDate_);
        if (day_InWeek <= 7) {
          try {
            await this.billService.getInvoiceToday(this.valueNumberBill, this.dtQBan.MaQuay, this.dtQBan.MaCH, s_ValueSelectDate)
              .then((result: HD) => {
                if (result.LoaiHD === 1 && result.DaTraHang === false) {
                  this.dataBill = result;
                  this.BillTypeOne = {
                    CTHoaDons: this.dataBill.CTHoaDon,
                    HoaDonID: this.dataBill.HoaDonId,
                    LoaiHD: this.dataBill.LoaiHD,
                    MaKHTV: this.dataBill.MaKHTV,
                    MaHD: this.dataBill.MaHD,
                    MaNV: this.dataBill.MaNV,
                    MaQuay: this.dataBill.MaQuay,
                    MaCH: this.dtQBan.MaCH,
                    NgayHD: this.dataBill.NgayHD,
                    STTHD: this.dataBill.STTHD,
                    TongTien: this.dataBill.TongTien,
                    TienCK: this.dataBill.TongTienCK,
                    TienTraKhach: this.dataBill.TienTraKhach,
                    intoMoney: null,
                    //printBill: null,
                    printWaitBill: null,
                    DaTraHang: this.dataBill.DaTraHang,
                    MaCQT: this.dataBill.MaCQT
                  };
                  console.log(this.BillTypeOne);
                } else if (result.LoaiHD === 1 && result.DaTraHang === true) {
                  this.messageError = 'Hóa đơn đã được trả.';
                  this.openMessageError(contentError);
                  this.BillTypeOne = null;
                  this.valueNumberBill = null;
                } else if (result.LoaiHD === 3 || result.LoaiHD === 5) {
                  this.messageError = 'Không thể trả hóa đơn trả hàng.';
                  this.openMessageError(contentError);
                  this.BillTypeOne = null;
                  this.valueNumberBill = null;
                } else {
                  this.messageError = 'Không thể trả hóa đơn hủy.';
                  this.openMessageError(contentError);
                  this.BillTypeOne = null;
                  this.valueNumberBill = null;
                }
              })
          } catch (err) {
            this.messageError = err.message;
            this.openMessageError(contentError);
            this.BillTypeOne = null;
            this.valueNumberBill = null;
          }
          let nvhdinlai = this.dsNhanVien.find(x => x.MaNV == this.BillTypeOne.MaNV);
          const setTTHD: Array<TTHD> = new Array<TTHD>();
          const setTTHDAfter: Array<TTHD> = new Array<TTHD>();
          this.dataBill.HTThanhToan.forEach(x => {
            //if (x.MaHinhThuc === '0001') {
            //  x.SoTienThanhToanHD = x.SoTienThanhToanHD;
            //}
            const xSoTienThanhToanHD = x.SoTienThanhToanHD;
            const xHTTT: HTTT = {
              DoUuTien: x.DoUuTien,
              MaHinhThuc: x.MaHinhThuc,
              MaNhomThanhToan: x.MaNhomThanhToan,
              TenHinhThuc: x.TenHinhThuc,
              TenNhom: x.TenNhom
            };
            const dataTTHD: TTHD = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD };
            let dataTTHDAfter: TTHD;
            if (xHTTT.MaHinhThuc === '0001') {
              dataTTHDAfter = { HTTT: xHTTT, SoTienThanhToanHD: xSoTienThanhToanHD };
            } else {
              dataTTHDAfter = dataTTHD;
            }

            setTTHD.push(dataTTHD);
            setTTHDAfter.push(dataTTHDAfter);
          });

          let billCustomer = new KhachHang();
          if (this.dataBill.MaKHTV.length > 0) {
            billCustomer.MaKHTV = this.dataBill.MaKHTV;
          }
          else {
            billCustomer = undefined;
          }
          let tit = "";
          if (this.dataBill.LoaiHD == 3) {
            tit = "PHIẾU TRẢ HÀNG";
          }
          else {
            tit = "PHIẾU TÍNH TIỀN";
          }
          await this.GenerateBill(tit,
            this.dtQBan.TenQuay,
            this.dataBill.MaCQT,
            nvhdinlai.TenDangNhap,
            this.VietTat_TenNhanVien(nvhdinlai.TenNV),
            this.dataBill.STTHD,
            this.dataBill.CTHoaDon,
            setTTHD,
            this.dataBill.MaCH,
            setTTHDAfter,
            billCustomer,
            this.dataBill.MaHD,
            this.dataBill.GhiChu);
          this.valueNumberBill = null;
          document.getElementById('focus-input').blur();
        } else {
          this.messageError = 'Vui lòng chọn trả hàng trong 7 ngày!';
          this.openMessageError(contentError);
          this.valueNumberBill = null;
        }
      }
      else {
        this.messageError = 'Vui lòng nhập số giao dịch để trả hàng!';
        this.openMessageError(contentError);
        this.valueNumberBill = null;
      }
    }
    else {
      this.messageError = 'Không thể trả hàng khi đang offline!';
      this.openMessageError(contentError);
      this.valueNumberBill = null;
    }
  }


  returnPrintBillAgain() {
    const value = 'Page_Other';
    this.checkAllPage(value);
    this.BillTypeOne = null;
  }

  async submitPrintBillAgain(contentError) {
    this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

    if (this.BillTypeOne) {
      this.PrintCart();
      this.BillTypeOne = null;
      this.closeModal();
    } else {
      this.closeModal();
      this.messageError = 'Mời nhập số Giao Dịch in lại!';
      this.openMessageError(contentError);
    }
  }


  //async readBackup() {
  //  await document.getElementById('filebackup').click();

  //}

  file_string;

  //async decrypt_putdata(encrypt_data: string): Promise<void> {
  //  const decrypt_data = this.jwtService.deCryptData(encrypt_data);
  //  // console.log(decrypt_data);
  //  const obj_data = JSON.parse(decrypt_data);
  //  // console.log(obj_data);
  //  const HDs_BackedUp: HD[] = obj_data;
  //  // console.log(HDs_BackedUp);
  //  var ketqua_SBU = false;
  //  var count_ketqua_SBU = 0;
  //  for (const hd of HDs_BackedUp) {
  //    const loaihd = hd.LoaiHD;
  //    const thongtin_hd: HoaDon = {
  //      HoaDonID: hd.HoaDonId,
  //      CTHoaDons: hd.CTHoaDon,
  //      MaQuay: hd.MaQuay,
  //      TongTien: hd.TongTien,
  //      MaKHTV: hd.MaKHTV,
  //      MaNV: hd.MaNV,
  //      NgayHD: hd.NgayHD,
  //      STTHD: hd.STTHD,
  //      MaHD: hd.MaHD,
  //      LoaiHD: hd.LoaiHD,
  //      TienTraKhach: hd.TienTraKhach,
  //      intoMoney: null,
  //      //printBill: null,
  //      printWaitBill: null
  //    };
  //    const thanhtoan_hd: TTHD[] = [];
  //    if (hd.HTThanhToan !== undefined) {

  //      for (const httoan_hd of hd.HTThanhToan) {
  //        const tthd: TTHD = {
  //          HTTT: {
  //            MaNhomThanhToan: httoan_hd.MaNhomThanhToan,
  //            MaHinhThuc: httoan_hd.MaHinhThuc,
  //            TenHinhThuc: httoan_hd.TenHinhThuc,
  //            TenNhom: httoan_hd.TenNhom,
  //            DoUuTien: httoan_hd.DoUuTien
  //          },
  //          SoTienThanhToanHD: httoan_hd.SoTienThanhToanHD
  //        };
  //        thanhtoan_hd.push(tthd);
  //      }
  //    }
  //    // console.log(loaihd, thongtin_hd, thanhtoan_hd)
  //    const ketqua1HD = await this.setCheckOneBill_SBU(loaihd, thongtin_hd, thanhtoan_hd);
  //    if (ketqua1HD === true) {
  //      count_ketqua_SBU += 1;
  //    }
  //  }
  //  if (count_ketqua_SBU > 0) {
  //    this.messageNoti = 'Upload dữ liệu thành công!';
  //    // this.colorMessage = '#008000';
  //    this.mr = this.modalService.open(this.contentNoti, { centered: true, backdrop: 'static', keyboard: false });
  //  }
  //  else {
  //    this.messageError = 'Upload dữ liệu không thành công!';
  //    // this.colorMessage = '#ff0000';
  //    this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
  //  }
  //}

  async openFile(fileList: FileList) {
    //const file = fileList[0];
    //let data;
    //const fileReader: FileReader = new FileReader();
    //fileReader.onload = (e) => {
    //  data = fileReader.result;
    //  this.file_string = fileReader.result;
    //  this.decrypt_putdata(this.file_string);
    //};
    //fileReader.readAsText(file);
    //var fileString = fileReader.result;
  }


  ngAfterViewChecked() {
    this.scrollToBottom();
    if (this.isFirstTime_LoadHelp === true && this.isCheckPageHelp_Home === true) {
      this.loadtoanchor();
      this.isFirstTime_LoadHelp = false;
    }
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.log(err);
    }
  }


  checkMaxValueNumber(event) {
    const regex = /[0-9]/;
    if (!regex.test(String.fromCharCode(event.keyCode))) {
      return false;
    } else {
      const cnt_Q = this.valueNumber.toString();
      if (cnt_Q.length >= 13) {
        return false;
      } else {
        return true;
      }
    }
    // if (!regex.test(String.fromCharCode(event.keyCode)))
    // {
    //  if (this.valueNumber.toString().split('').length > 13) {
    //      return false;
    //    } else {
    //      return false;
    //    }
    // }
    // if (this.valueNumber !== null) {
    //  if (event.key === '+' || event.key === '-' || event.key === 'e') {
    //    return false;
    //  } else {
    //    if (this.valueNumber.toString().split('').length > 13) {
    //      return false;
    //    } else {
    //      return true;
    //    }
    //  }
    // }
  }

  checkHash(contentError) {
    this._isValisSubmit_QR = true;
    const momo_pay_id = this.valueCode_QR;
    const amount_momo = +(this.total - this.valueMoney_All);
    this.momo = new Momo_Message();
    const maCH: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
    this.mr = this.modalService.open(this.contentLoading, { centered: true, backdrop: 'static', keyboard: false });
    console.log(maCH[0]);
    this.scannerQRService.callMomoAPI(this.valueCode_QR, maCH[0].MaCH, amount_momo.toString(),
      this.selectedValue.MaHinhThuc, this.dtQBan.MaQuay, this.user.MaNV,
      this.numberHD, this.order.HoaDonID).then(data => {
        console.log('RESPONE: ' + data);
        if (data.status === 0) {
          this.valueReferenceCode_QR = data.message.transid.toString();
          this.momo = data.message;
          console.log(this.momo);
          this.mr.dismiss();
          console.log(this.momo.description);
          console.log(this.momo.message);
          setTimeout(() => {
            this.submitPayment_QR(contentError);
          }, 5000);
        } else {
          this.momo.self_status = data.status;
          this.mr.dismiss();
          this.messageError = data.status + ': ' + data.message.description;
          this.openMessageError(contentError);
        }
        console.log(data);
      })
      .catch(err => {
        this.momo.self_status = 3;
        this.mr.dismiss();
        this.messageError = err.message;
        this.openMessageError(contentError);
      });
  }

  async queryHash(contentError) {
    this.mr = this.modalService.open(this.contentLoading, { centered: true });
    this.momo_query = null;
    const maCH: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
    console.log(maCH[0]);
    await this.scannerQRService.callQueryMomoAPI(maCH[0].MaCH,
      this.selectedValue.MaHinhThuc, this.dtQBan.MaQuay, this.user.MaNV,
      this.numberHD, this.order.HoaDonID).then(data => {
        console.log('RESPONE query: ' + data);
        if (data.data.status === 0) {
          this.mr.dismiss();
          this.valueReferenceCode_QR = data.data.transid.toString();
          this.momo_query = data.data;
          this.momo = data.data;
          // console.log(this.momo);
          // // console.log(this.momo.description);
          this._isValisSubmit_QR = true;
          setTimeout(() => {
            this.submitPayment_QR_withQuery(contentError);
          }, 5000);
        } else {
          this.mr.dismiss();
          this._isValisSubmit_QR = false;
          this.messageError = data.data.status + ' - ' + data.data.message;
          // this.messageError = 'Không kiểm tra được giao dịch';
          this.openMessageError(contentError);
        }
        console.log(data);
      })
      .catch(err => {
        this.mr.dismiss();
        this._isValisSubmit_QR = false;
        this.messageError = 'Không kiểm tra được giao dịch';
        // this.messageError = err.message;
        this.openMessageError(contentError);
      });
  }

  async submitPayment_Money() {
    const index: TTHD = await this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    try {
      const tthdMoney: TTHD = {
        HTTT: this.selectedValue,
        SoTienThanhToanHD: this.valueMoney
      };
      if (!index) {
        await this.xc_ForeignCurr_async(tthdMoney.SoTienThanhToanHD)
          .then((result: any) => {
            tthdMoney.QuyDoiNgoaiTe = result.QuyDoi;
            tthdMoney.TyLeQuyDoi = result.TyLe;
          });
        // tthdMoney.QuiDoiNgoaiTe = this.xc_ForeignCurr(tthdMoney.SoTienThanhToanHD);

        this.payBill.push(tthdMoney);
      } else {
        const i = this.payBill.indexOf(index);
        this.payBill[i].HTTT = this.selectedValue;
        // this.payBill[i].SoTienThanhToanHD = this.total;
        this.payBill[i].SoTienThanhToanHD = this.valueMoney;
        await this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
          .then((result: any) => {
            this.payBill[i].QuyDoiNgoaiTe = result.QuyDoi;
            this.payBill[i].TyLeQuyDoi = result.TyLe;
          });

      }
      this.setChange_Payment();
      this.openBackPayment_Money();
      console.log(this.payBill);
    } catch {
      console.log('Lỗi');
    }
  }

  async submitPayment_Point(contentError, contentConfirmCredit) {
    if (this.valuePoint === null || this.valuePoint === 0) {
      this.messageError = 'Số điểm thanh toán không hợp lệ.';
      this.mr = this.modalService.open(contentError, { centered: true, backdrop: 'static' });
      this.mr.result.then((result) => {
        // if (result) {
        //   document.getElementById('RC_QR').focus();
        // } else {
        //   document.getElementById('RC_QR').focus();
        // }
      });
    }
    else {
      await this.customerService.PointRedemp_API(this.customer.MaKHTV,
        this.valuePoint, this.customer.MaCapDo,
        this.dtQBan.MaCH, this.dtQBan.MaQuay,
        this.numberHD)
        .then(async result => {
          const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
          if (!index || index !== undefined) {
            const data: TTHD = {
              HTTT: {
                DoUuTien: this.selectedValue.DoUuTien,
                MaHinhThuc: this.selectedValue.MaHinhThuc,
                MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
                MaThe: this.customer.MaKHTV,
                TenHinhThuc: this.selectedValue.TenHinhThuc,
                TenNhom: this.selectedValue.TenNhom
              },
              SoTienThanhToanHD: this.valuePoint
            };
            await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
              .then((result: any) => {
                data.QuyDoiNgoaiTe = result.QuyDoi;
                data.TyLeQuyDoi = result.TyLe;
              });
            // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);

            localStorage.setItem('_dataPoint', JSON.stringify(data));
            this.payBill.push(data);
            this.setChange_Payment();
            this.openBackPayment_Point();
          } else {
            this.messageError = 'Thanh toán điểm chưa được hoàn tất!';
            this.openMessageError(contentError);
          }
        })
        .catch(err => {
          this.messageError = err.message;
          this.openMessageError(contentError);
        })
    }
  }

  openBackPayment_Point() {
    // const index = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '006' && x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    // if (!index) {
    //   // this.valueMoney_CreditCard = null;
    //   // this.valueReferenceCode_CreditCard = null;
    // }
    this.valuePoint = 0;
    this.checkPagePayment = true;
    this.checkPagePayment_Point = false;
    this.checkMenuFooter_B = true;
    this.checkMenuFooter_Point = false;
  }

  async ProcessPayment_CreditCart() {
    const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    console.log(index);
    if (!index) {
      const data: TTHD = {
        HTTT: {
          DoUuTien: this.selectedValue.DoUuTien,
          MaHinhThuc: this.selectedValue.MaHinhThuc,
          MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
          MaThe: this.valueReferenceCode_CreditCard,
          TenHinhThuc: this.selectedValue.TenHinhThuc,
          TenNhom: this.selectedValue.TenNhom
        },
        SoTienThanhToanHD: this.valueMoney_CreditCard
      };
      await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
        .then((result: any) => {
          data.QuyDoiNgoaiTe = result.QuyDoi;
          data.TyLeQuyDoi = result.TyLe;
        });
      // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);

      this.payBill.push(data);
    } else {
      const i = this.payBill.indexOf(index);
      this.payBill[i].SoTienThanhToanHD = this.valueMoney_CreditCard;
      // this.payBill[i].QuiDoiNgoaiTe = this.xc_ForeignCurr(this.payBill[i].SoTienThanhToanHD);
      this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
        .then((result: any) => {
          this.payBill[i].QuyDoiNgoaiTe = result.QuyDoi;
          this.payBill[i].TyLeQuyDoi = result.TyLe;
        });

      this.payBill[i].HTTT.MaThe = this.valueReferenceCode_CreditCard;
    }
    this.setChange_Payment();
    this.openBackPayment_CreditCard();
    console.log(this.payBill);
  }


  async ProcessPayment_HCG() {
    const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    console.log(index);
    if (!index) {
      const data: TTHD = {
        HTTT: {
          DoUuTien: this.selectedValue.DoUuTien,
          MaHinhThuc: this.selectedValue.MaHinhThuc,
          MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
          MaThe: this.customer.MaKHTV,
          TenHinhThuc: this.selectedValue.TenHinhThuc,
          TenNhom: this.selectedValue.TenNhom
        },
        SoTienThanhToanHD: this.valueMoney_HCG
      };
      await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
        .then((result: any) => {
          data.QuyDoiNgoaiTe = result.QuyDoi;
          data.TyLeQuyDoi = result.TyLe;
        });
      // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);

      this.payBill.push(data);
    } else {
      const i = this.payBill.indexOf(index);
      this.payBill[i].SoTienThanhToanHD = this.valueMoney_HCG;
      // this.payBill[i].QuiDoiNgoaiTe = this.xc_ForeignCurr(this.payBill[i].SoTienThanhToanHD);
      this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
        .then((result: any) => {
          this.payBill[i].QuyDoiNgoaiTe = result.QuyDoi;
          this.payBill[i].TyLeQuyDoi = result.TyLe;
        });

      this.payBill[i].HTTT.MaThe = this.customer.MaKHTV;
    }
    this.setChange_Payment();
    this.openBackPayment_HCG();
    console.log(this.payBill);
  }

  submitPayment_CreditCard(contentError, contentConfirmCredit) {
    if (this.valueReferenceCode_CreditCard === null || this.valueReferenceCode_CreditCard === '') {
      this.mr = this.modalService.open(contentConfirmCredit, { centered: true, backdrop: 'static' });
      this.mr.result.then((result) => {
        if (result) {
          this.ProcessPayment_CreditCart();
        } else {
          document.getElementById('RC_credit').focus();
        }
      });
    } else {
      try {
        if (this.valueMoney_CreditCard > (this.total - this.valueMoney_All)) {
          this.messageError = 'Số tiền nhập không dược lớn hơn số tiền phải trả!';
          this.openMessageError(contentError);
          return null;
        }
        this.ProcessPayment_CreditCart();
      } catch {
        console.log('loi');
      }
    }

  }

  submitPayment_HCG(contentError, contentConfirmCredit) {

    if (this.valueMoney_HCG > (this.total - this.valueMoney_All)) {
      this.messageError = 'Số tiền nhập không dược lớn hơn số tiền phải trả!';
      this.openMessageError(contentError);
      return null;
    }
    else if (this.valueMoney_HCG <= 0 || this.valueMoney_HCG == undefined) {
      this.messageError = 'Số tiền nhập phải lớn hơn 0!';
      this.openMessageError(contentError);
      return null;
    }
    else {
      this.ProcessPayment_HCG();
    }
    //if (this.valueReferenceCode_HCG === null || this.valueReferenceCode_HCG === '') {
    //  this.mr = this.modalService.open(contentConfirmCredit, { centered: true, backdrop: 'static' });
    //  this.mr.result.then((result) => {
    //    if (result) {

    //    } else {
    //      document.getElementById('RC_HCG').focus();
    //    }
    //  });
    //} else {
    //  try {
    //    if (this.valueMoney_HCG > (this.total - this.valueMoney_All)) {
    //      this.messageError = 'Số tiền nhập không dược lớn hơn số tiền phải trả!';
    //      this.openMessageError(contentError);
    //      return null;
    //    }
    //    this.ProcessPayment_HCG();
    //  } catch {
    //    console.log('loi');
    //  }
    //}

  }


  setChange_Payment() {
    this.valueMoney_All = 0;
    this.payBill.forEach(x => {
      this.valueMoney_All = this.valueMoney_All + x.SoTienThanhToanHD;
    });
    const index = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '013');
    if (index) {
      this.isHadMomo = true;
    }
    const index_point = this.payBill.find(x => x.HTTT.MaNhomThanhToan === '006');
    if (index_point) {
      this.isHadPoint = true;
    }
    this.valueMoney_Change = this.valueMoney_All - this.total;
    if (this.valueMoney_Change < 0) {
      this.checkDisabledHTTT = false;
    } else {
      this.checkDisabledHTTT = true;
    }
    this.openPrintOrder_triph();
  }

  setChange() {
    this.valueMoney_All = 0;
    this.payBill.forEach(x => {
      this.valueMoney_All = this.valueMoney_All + x.SoTienThanhToanHD;
    });
    this.valueMoney_Change = this.valueMoney_All - this.total;
    if (this.valueMoney_Change < 0) {
      this.valueMoney_Change = 0;
      this.checkDisabledHTTT = false;
    } else {
      this.checkDisabledHTTT = true;
    }
  }

  confirmPayment_QR(contentConfirmQR) {
    if (this.momo === null || this.momo === undefined || this.momo.self_status === 3) {
      this.mr = this.modalService.open(contentConfirmQR, { centered: true, backdrop: 'static' });
    }
  }

  async submitPayment_QR(contentError) {
    if (this.valueReferenceCode_QR === null || this.valueReferenceCode_QR.length === 0) {
      this.messageError = 'Bạn chưa nhập mã tham chiếu cho giao dịch! Vui lòng nhập mã để xác nhận.';
      this.mr = this.modalService.open(contentError, { centered: true, backdrop: 'static' });
      this.mr.result.then((result) => {
        if (result) {
          document.getElementById('RC_QR').focus();
        } else {
          document.getElementById('RC_QR').focus();
        }
      });
    }
    else {
      const amount_momo = +(this.total - this.valueMoney_All)
      const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
      if (!index || index !== undefined) {
        const data: TTHD = {
          HTTT: {
            DoUuTien: this.selectedValue.DoUuTien,
            MaHinhThuc: this.selectedValue.MaHinhThuc,
            MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
            MaThe: this.valueReferenceCode_QR,
            TenHinhThuc: this.selectedValue.TenHinhThuc,
            TenNhom: this.selectedValue.TenNhom
          },
          SoTienThanhToanHD: amount_momo
        };
        await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
          .then((result: any) => {
            data.QuyDoiNgoaiTe = result.QuyDoi;
            data.TyLeQuyDoi = result.TyLe;
          });
        // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);
        localStorage.setItem('_dataQR', JSON.stringify(data));
        this.payBill.push(data);
        this.setChange_Payment();
        this.openBackPayment_QR();
      } else {
        this.messageError = 'Thanh toán QR chưa được hoàn tất!';
        this.openMessageError(contentError);
      }
    }
  }

  async submitPayment_QR_withQuery(contentError) {
    const amount_momo = +(this.total - this.valueMoney_All)
    const index = this.payBill.find(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc);
    if (!index || index !== undefined) {
      const data: TTHD = {
        HTTT: {
          DoUuTien: this.selectedValue.DoUuTien,
          MaHinhThuc: this.selectedValue.MaHinhThuc,
          MaNhomThanhToan: this.selectedValue.MaNhomThanhToan,
          MaThe: this.valueReferenceCode_QR,
          TenHinhThuc: this.selectedValue.TenHinhThuc,
          TenNhom: this.selectedValue.TenNhom
        },
        SoTienThanhToanHD: amount_momo
      };
      await this.xc_ForeignCurr_async(data.SoTienThanhToanHD)
        .then((result: any) => {
          data.QuyDoiNgoaiTe = result.QuyDoi;
          data.TyLeQuyDoi = result.TyLe;
        });
      // data.QuiDoiNgoaiTe = this.xc_ForeignCurr(data.SoTienThanhToanHD);
      localStorage.setItem('_dataQR', JSON.stringify(data));
      this.payBill.push(data);
      this.setChange_Payment();
      this.openBackPayment_QR();
    } else {
      this.messageError = 'Thanh toán QR chưa được hoàn tất!';
      this.openMessageError(contentError);
    }
  }

  openCamera_QR(modalCamera_QR) {
    //this.mr = this.modalService.open(modalCamera_QR, { centered: true, backdrop: 'static' });
    this.call_ScanbyApp();
  }

  openCamera_Voucher(modalCamera_Voucher) {
    //this.mr = this.modalService.open(modalCamera_Voucher, { centered: true, backdrop: 'static' });
    this.call_ScanbyApp();

  }


  openCamera_Customer(modalCamera_Customer) {
    //this.mr = this.modalService.open(modalCamera_Customer, { centered: true, backdrop: 'static' });
    this.call_ScanbyApp();

  }


  openCamera_New(modalCamera_New) {
    //this.mr = this.modalService.open(modalCamera_New, { centered: true, backdrop: 'static' });
    this.call_ScanbyApp();
  }

  onCodeResult_QR(resultString: string, contentError) {
    this.closeModal();
    this.valueCode_QR = resultString;
    console.log(resultString);
    this.checkHash(contentError);
  }

  onVoucher_scanned(resultString: string, contentError) {
    this.closeModal();
    this.valueMoney_Voucher = resultString;
    this.checkBtnVoucher(contentError);
  }

  onCustomer_scanned(resultString: string, contentError) {
    this.closeModal();
    this.valueNumber = resultString;
    this.submitCustomer_hieuth(contentError);
  }

  async checkBtnVoucher(contentError) {
    if (window.navigator.onLine === true) {
      await this.voucherService.getVoucher(this.valueMoney_Voucher)
        .then((result: Voucher) => {
          if (result.DaSuDung === false || result.MaHDSuDung === '' || result.NgaySuDung === null) {
            const startDate = Date.parse(result.HieuLucTuNgay.toString());
            const endDate = Date.parse(result.HieuLucDenNgay.toString());
            const todayDate = Date.now();
            if (startDate <= todayDate && todayDate <= endDate) {
              const index = this.vouchers.find(x => x.MaPhieu === result.MaPhieu);
              if (!index) {
                this.vouchers.push(result);
                this.vouchers.forEach(x => {
                  if (x.TriGiaThanhToan === 0) {
                    const TriGiaTyLeVoucher = this.total * (x.TyLeThanhToan / 100);
                    x.TriGiaThanhToan = TriGiaTyLeVoucher;
                  }
                  if (x.MaPhieu === result.MaPhieu) {
                    this.totalVoucher = this.totalVoucher + x.TriGiaThanhToan;
                  }
                });
              } else {
                this.messageError = 'Voucher này đang được áp dụng!';
                this.openMessageError(contentError);
              }
            } else {
              this.messageError = 'Hết hiệu lực Voucher!';
              this.openMessageError(contentError);
            }
          } else {
            this.messageError = 'Voucher này đã được sử dụng!';
            this.openMessageError(contentError);
          }
        })
        .catch(result => {
          this.messageError = result;
          this.openMessageError(contentError);
        });
    } else {
      this.messageError = 'Không thể kết nối mạng. Vui lòng thử lại sau!';
      this.openMessageError(contentError);
    }
    this.valueMoney_Voucher = null;
  }

  async clearVoucher(contentError) {
    this.vouchers.length = 0;
    this.totalVoucher = 0;
    const index_voucher = this.payBill.findIndex(x => x.HTTT.MaHinhThuc === this.selectedValue.MaHinhThuc, 0);
    if (index_voucher !== undefined) {
      this.payBill.splice(index_voucher, 1);
      this.setChange_Payment();
    }
  }

  updateVoucher(contentError) {
    const hdID = this.order.HoaDonID;
    const makhtv = this.order.MaKHTV;
    this.vouchers.forEach(v => {
      this.voucherService.updateVoucher(
        v,
        this.dtQBan.MaQuay,
        this.order.HoaDonID,
        v.MaKhSuDung = makhtv,
        this.order.STTHD,
        v.MaHDSuDung = hdID,
      )
        // .then(result => {
        //   if (result) {

        //   }
        // })
        .catch(err => {
          this.messageError = err;
          this.openMessageError(contentError);
        });
    });
  }

  async submitPayment_Voucher() {
    if (this.totalVoucher > (this.total - this.valueMoney_All)) {
      this.messageError = 'Chỉ được thanh toán voucher nhỏ hơn hoặc bằng tiền cần thanh toán!';
      this.openMessageError(this.contentError);
      this.clearVoucher(this.contentError);
      // setTimeout(x => document.getElementById('VoucherCode').focus(), 3000);
    } else {
      const index: TTHD = await this.payBill.find(x => x.HTTT.MaNhomThanhToan === this.selectedValue.MaNhomThanhToan);
      try {
        const tthdMoney: TTHD = {
          HTTT: this.selectedValue,
          // SoTienThanhToanHD: this.vouchers[0].TriGiaThanhToan // code cũ
          SoTienThanhToanHD: this.totalVoucher
        };
        if (!index) {
          // tthdMoney.QuiDoiNgoaiTe = this.xc_ForeignCurr(tthdMoney.SoTienThanhToanHD);
          await this.xc_ForeignCurr_async(tthdMoney.SoTienThanhToanHD)
            .then((result: any) => {
              tthdMoney.QuyDoiNgoaiTe = result.QuyDoi;
              tthdMoney.TyLeQuyDoi = result.TyLe;
            });

          this.payBill.push(tthdMoney);
        } else {
          const i = this.payBill.indexOf(index);
          this.payBill[i].HTTT = this.selectedValue;
          //  this.payBill[i].SoTienThanhToanHD = this.voucher[0].TriGiaThanhToan + this.voucher[0].TriGiaThanhToan;
          this.payBill[i].SoTienThanhToanHD = this.totalVoucher;
          // this.payBill[i].QuiDoiNgoaiTe = this.xc_ForeignCurr(this.payBill[i].SoTienThanhToanHD);
          await this.xc_ForeignCurr_async(this.payBill[i].SoTienThanhToanHD)
            .then((result: any) => {
              tthdMoney.QuyDoiNgoaiTe = result.QuyDoi;
              tthdMoney.TyLeQuyDoi = result.TyLe;
            });
        }
        this.setChange_Payment();
        this.openBackPayment_Voucher();
        console.log(this.payBill);
      } catch {
        console.log('Lỗi');
      }
    }
  }


  GetCurTime_UTC(): string {
    const date = new Date();
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    // var time = day + `/` + month + `/` + year + ` ` + hour + `:` + minute + `:` + second;
    const time = date.toJSON();
    return time;

  }

  // setChangeVoucher() {
  //   this.payBill.forEach(x => {
  //     this.valueMoney_All = this.totalVoucher + this.valueMoney;
  //     if (this.valueMoney_All < 0) {
  //       this.valueMoney_All = 0;
  //     } else {
  //       this.valueMoney_All = this.valueMoney_All;
  //     }
  //   });
  //   this.openPrintOrder_triph();
  // }

  _checkDate() {
    return localForage.getItem('_curSoHD').then((data: string) => {
      if (data) {
        const curSoHD = JSON.parse(data);
        const dateNow = new Date();
        const date_curHD = new Date(curSoHD.NgayLapHD);
        const dayNow = dateNow.getUTCDate();
        const monthNow = dateNow.getUTCMonth() + 1;
        const day_cur = date_curHD.getUTCDate();
        const month_cur = date_curHD.getUTCMonth() + 1;
        if (dayNow === day_cur && monthNow === month_cur) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    });
  }

  async _cancelCartNextDate() {
    const now = new Date();
    const lsHD_Doi: Array<HoaDon> = await localForage.getItem('_curHDDoi').then((data: string) => JSON.parse(data));
    const lsHD: Array<HoaDon> = [];
    if (this.listCart) {
      const index: HoaDon = this.listHD_Tong.find(x => this.numberHD === x.STTHD);
      if (index) {
        const i = this.listHD_Tong.indexOf(index);
        this.listHD_Tong[i].NgayHD = index.NgayHD;
        this.listHD_Tong[i].LoaiHD = 4;
        this.listHD_Tong[i].MaQuay = this.dtQBan.MaQuay;
        this.listHD_Tong[i].MaCH = this.dtQBan.MaCH;
        this.ListHD.push({ HoaDon: this.listHD_Tong[i], TTHD: null });
        lsHD.push(this.listHD_Tong[i]);
      } else {
        this.order.CTHoaDons = this.listCart;
        this.order.LoaiHD = 4;
        this.order.NgayHD = now;
        this.order.MaNV = this.user.MaNV;
        this.order.STTHD = 1;
        const t = moment();
        const s = t.format('DDMMYY');
        this.order.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
        this.order.TongTien = this.total;
        this.ListHD.push({ HoaDon: this.order, TTHD: null });
        lsHD.push(this.order);
      }
    } if (lsHD_Doi && lsHD_Doi.length > 0) {
      lsHD_Doi.forEach(async element => {
        element.LoaiHD = 4;
        element.MaQuay = this.dtQBan.MaQuay;
        element.MaCH = this.dtQBan.MaCH;
        element.NgayHD = element.NgayHD;
        this.ListHD.push({ HoaDon: element, TTHD: null });
        lsHD.push(element);
      });
    }
    const length = lsHD.length;
    lsHD.forEach(async (data, idx) => {
      await this.setCheckOneBill(4, data, null);
      if (length === idx + 1) {
        this.Force_Logout();
        this.messageError = 'Bạn bị ép đăng xuất vì đã qua ngày mới.';
        this.openMessageError(this.contentError);
      }
    });
  }


  SuKienGia(cthd: CTHoaDon, product: HangHoa) {
    let maxValue: number = 100000;
    let maxValue2: number = 100000;
    let tongCKHD = 0;
    const todayDate = Date.now();
    const mathe = this.customer ? this.customer.MaKHTV : '';
    const macapdo = this.customer ? this.customer.MaCapDo : 'N/A';
    const dsSKG_SKU = this.dsSuKienGia.sort((x, y) => x.METHOD > y.METHOD ? 1 : -1).filter(s => s.SKU === product.SKU);
    console.log(dsSKG_SKU);
    // thêm test
    let Method = "";
    let PriceType = "";
    let DGBanCK = 0;
    let TienCK = 0;
    let ChietKhau = 0;
    let TyLeCK = 0;
    let slConLai = cthd.SoLuong;
    dsSKG_SKU.forEach(x => {
      if (maxValue > x.PRC_KEY && x.METHOD == 25) {
        maxValue = x.PRC_KEY;
      }
    })
    dsSKG_SKU.forEach(x => {
      if (maxValue2 > x.PRC_KEY && x.METHOD == 2) {
        maxValue2 = x.PRC_KEY;
      }
    })
    dsSKG_SKU.forEach(skg => {
      const startDate = Date.parse(skg.STARTDATE.toString());
      const stopDate = Date.parse(skg.STOPDATE.toString());
      const solanM2 = Math.floor(cthd.SoLuong / skg.QTY1);
      console.log(skg);
      cthd.TienCK = 0;
      cthd.TyLeCK = 0;
      cthd.ChietKhau = 0;
      if (skg.SKU === product.SKU && skg.METHOD === 25 && startDate <= todayDate && todayDate <= stopDate && slConLai > 0 && maxValue == skg.PRC_KEY) {
        // index.DGBan = skg.PRICE;
        // index.ChietKhau = (x.GiaBanLe - skg.PRICE) * 1;
        let listMe = Method.split("_");
        let check = false;
        listMe.forEach(s => {
          if (s == "21" || s == "20") {
            check = true;
            return;
          }

        })
        if (check) {
          return;
        }
        cthd.DGBan = product.GiaBanLe;
        //cthd.DGBanCK = skg.DISCPRICE;
        //cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
        //cthd.ChietKhau = cthd.TienCK * 1;
        //cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100));
        //cthd.Method = skg.METHOD.toString();
        //cthd.PriceType = skg.PRICETYPE;
        DGBanCK += cthd.DGBanCK = skg.DISCPRICE;
        TienCK += cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
        ChietKhau += cthd.TienCK * slConLai;
        TyLeCK += (cthd.TienCK / (cthd.DGBan / 100))
        Method += skg.METHOD.toString() + "_";
        PriceType += skg.PRICETYPE;
      } else if (skg.SKU === product.SKU
        && skg.METHOD === 21
        && startDate <= todayDate
        && todayDate <= stopDate
        //&& mathe === skg.CUSTNUM
        && macapdo.toLowerCase() === skg.PRICETYPE.toLowerCase()) {
        cthd.DGBan = product.GiaBanLe;
        //cthd.DGBanCK = skg.DISCPRICE;
        //cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
        //cthd.ChietKhau = cthd.TienCK * 1;
        //cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
        //cthd.Method = skg.METHOD.toString();
        //cthd.PriceType = skg.PRICETYPE;
        DGBanCK = cthd.DGBanCK = skg.DISCPRICE;
        TienCK = cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
        ChietKhau = cthd.TienCK * cthd.SoLuong;
        TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
        Method += skg.METHOD.toString() + "_";
        PriceType += skg.PRICETYPE;
        // index.ChietKhau = (x.GiaBanLe - skg.DISCPRICE) * 1;
      } else if (skg.SKU === product.SKU
        && skg.METHOD === 20
        && startDate <= todayDate
        && todayDate <= stopDate
        && mathe === skg.CUSTNUM
        && macapdo != 'N/A') {
        cthd.DGBan = product.GiaBanLe;
        //cthd.DGBanCK = cthd.DGBan - ((cthd.DGBan / 100) * skg.DISCPRICE);
        //cthd.TyLeCK = skg.DISCPRICE;
        //cthd.ChietKhau = (cthd.DGBan - cthd.DGBanCK) * 1;
        //cthd.TienCK = ((cthd.DGBan / 100) * cthd.TyLeCK);
        //cthd.Method = skg.METHOD.toString();
        //cthd.PriceType = skg.PRICETYPE;
        DGBanCK = cthd.TienCK = cthd.DGBan - ((cthd.DGBan / 100) * skg.DISCPRICE);
        TyLeCK = skg.DISCPRICE;
        ChietKhau = (cthd.DGBan - cthd.DGBanCK) * cthd.SoLuong;
        TienCK = cthd.TienCK = ((cthd.DGBan / 100) * cthd.TyLeCK);
        Method += skg.METHOD.toString() + "_";
        PriceType += skg.PRICETYPE;
      } else if (skg.SKU === cthd.SKU
        && skg.METHOD === 2
        && startDate <= todayDate
        && todayDate <= stopDate
        && solanM2 > 0 && maxValue2 == skg.PRC_KEY) {
        let listMe = Method.split("_");
        let check = false;
        listMe.forEach(s => {
          if (s == "21" || s == "20") {
            check = true;
            return;
          }

        })
        if (check) {
          return;
        }
        const SoTienCK = solanM2 * skg.DISCPRICE;
        cthd.DGBan = cthd.DGBan;
        //cthd.ChietKhau = (cthd.DGBan * cthd.SoLuong) - SoTienCK;
        //cthd.TienCK = (cthd.ChietKhau / cthd.SoLuong);
        //cthd.DGBanCK = cthd.DGBan - cthd.TienCK;
        //cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100));
        //cthd.Method = skg.METHOD.toString();
        //cthd.PriceType = skg.PRICETYPE;
        ChietKhau += (cthd.DGBan * cthd.SoLuong) - SoTienCK;
        TienCK += (ChietKhau / cthd.SoLuong);
        DGBanCK += cthd.DGBanCK = cthd.DGBan - TienCK;
        TyLeCK += (TienCK / (cthd.DGBan / 100));
        Method += skg.METHOD.toString() + "_";
        PriceType += skg.PRICETYPE;
        slConLai = cthd.SoLuong % skg.QTY1;
      }

    });
    if (DGBanCK > 0) {
      cthd.DGBanCK = DGBanCK;
    }
    else {
      cthd.DGBanCK = cthd.DGBanCK;
    }
    cthd.DGBan = cthd.DGBan;
    cthd.ChietKhau = ChietKhau;
    //cthd.ChietKhau = (cthd.DGBan * cthd.SoLuong) - ThanhTienCK_M2;
    cthd.TienCK = TienCK;
    cthd.TyLeCK = TyLeCK;
    cthd.Method = Method;
    cthd.PriceType = PriceType;
    tongCKHD += cthd.ChietKhau;
  }


  apDungLaiSuKienGia(hd: HoaDon) {
    var cthds = hd.CTHoaDons;
    let tongCKHD = 0;
    let i = 0;
    const todayDate = Date.now();
    const mathe = this.customer ? this.customer.MaKHTV : '';
    const maCapDo = this.customer ? this.customer.MaCapDo : 'N/A';
    if (cthds === undefined || cthds === null) {
      return;
    }
    //else {
    //  cthds.forEach(cthd => {
    //    const dsSKG_SKU = this.dsSuKienGia.filter(s => s.SKU === cthd.SKU);
    //    if (dsSKG_SKU.length !== 0) {
    //      dsSKG_SKU.forEach(skg => {
    //        const startDate = Date.parse(skg.STARTDATE.toString());
    //        const stopDate = Date.parse(skg.STOPDATE.toString());
    //        const solanM2 = Math.floor(cthd.SoLuong / skg.QTY1);
    //        console.log(skg);
    //        if (skg.SKU === cthd.SKU && skg.METHOD === 25 && startDate <= todayDate && todayDate <= stopDate) {
    //          // index.DGBan = skg.PRICE;
    //          // index.ChietKhau = (x.GiaBanLe - skg.PRICE) * 1;
    //          cthd.DGBan = cthd.DGBan;
    //          cthd.DGBanCK = skg.PRICE;
    //          cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
    //          cthd.ChietKhau = cthd.TienCK * cthd.SoLuong;
    //          cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
    //          cthd.Method = skg.METHOD.toString();
    //          cthd.PriceType = skg.PRICETYPE;
    //        } else if (skg.SKU === cthd.SKU
    //          && skg.METHOD === 21
    //          && startDate <= todayDate
    //          && todayDate <= stopDate
    //          //&& mathe === skg.CUSTNUM
    //          && maCapDo.toLowerCase() === skg.PRICETYPE.toLowerCase()) {
    //          cthd.DGBan = cthd.DGBan;
    //          cthd.DGBanCK = skg.DISCPRICE;
    //          cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
    //          cthd.ChietKhau = cthd.TienCK * cthd.SoLuong;
    //          cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
    //          cthd.Method = skg.METHOD.toString();
    //          cthd.PriceType = skg.PRICETYPE;
    //          // index.ChietKhau = (x.GiaBanLe - skg.DISCPRICE) * 1;
    //        } else if (skg.SKU === cthd.SKU
    //          && skg.METHOD === 20
    //          && startDate <= todayDate
    //          && todayDate <= stopDate
    //          && mathe === skg.CUSTNUM
    //          && maCapDo != 'N/A') {
    //          cthd.DGBan = cthd.DGBan;
    //          cthd.DGBanCK = cthd.DGBan - ((cthd.DGBan / 100) * skg.DISCPRICE);
    //          cthd.TyLeCK = skg.DISCPRICE;
    //          cthd.ChietKhau = (cthd.DGBan - cthd.DGBanCK) * cthd.SoLuong;
    //          cthd.TienCK = ((cthd.DGBan / 100) * cthd.TyLeCK);
    //          cthd.Method = skg.METHOD.toString();
    //          cthd.PriceType = skg.PRICETYPE;
    //        }
    //        else if (skg.SKU === cthd.SKU
    //          && skg.METHOD === 2
    //          && startDate <= todayDate
    //          && todayDate <= stopDate
    //          && solanM2 > 0) {
    //          const ThanhTienCK_M2 = solanM2 * skg.DISCPRICE;
    //          const soHHConlai = cthd.SoLuong - (solanM2 * skg.QTY1);
    //          const TienCK_M2 = (cthd.DGBan * cthd.SoLuong) - (ThanhTienCK_M2 + (soHHConlai * cthd.DGBan));
    //            cthd.DGBan = cthd.DGBan;
    //          cthd.ChietKhau = TienCK_M2;
    //          //cthd.ChietKhau = (cthd.DGBan * cthd.SoLuong) - ThanhTienCK_M2;
    //            cthd.TienCK = (cthd.ChietKhau  / cthd.SoLuong);
    //            cthd.DGBanCK = cthd.DGBan - cthd.TienCK;
    //            cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100));
    //            cthd.Method = skg.METHOD.toString();
    //            cthd.PriceType = skg.PRICETYPE;
    //        }
    //        else {
    //          cthd.DGBanCK = cthd.DGBan;
    //          cthd.TyLeCK = 0;
    //          cthd.ChietKhau = 0;
    //          cthd.TienCK = 0;
    //          cthd.TyLeCKHD = 0;
    //          cthd.TienCKHD = 0;
    //        }
    //      });
    //      tongCKHD += cthd.ChietKhau;
    //    }
    //  });
    //  hd.TienCK = hd.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
    //  this.getInto();
    //}
    else {
      cthds.forEach(cthd => {
        let maxValue: number = 100000;
        let maxValue2: number = 100000;
        const dsSKG_SKU = this.dsSuKienGia.sort((x, y) => x.METHOD > y.METHOD ? 1 : -1).filter(s => s.SKU === cthd.SKU);
        let Method = "";
        let PriceType = "";
        let DGBanCK = 0;
        let TienCK = 0;
        let ChietKhau = 0;
        let TyLeCK = 0;
        let slConLai = cthd.SoLuong;
        dsSKG_SKU.forEach(x => {
          if (maxValue > x.PRC_KEY && x.METHOD == 25) {
            maxValue = x.PRC_KEY;
          }
        })
        dsSKG_SKU.forEach(x => {
          if (maxValue2 > x.PRC_KEY && x.METHOD == 2) {
            maxValue2 = x.PRC_KEY;
          }
        })
        if (dsSKG_SKU.length !== 0) {
          let checked = dsSKG_SKU.length > 1;
          dsSKG_SKU.forEach(skg => {
            const startDate = Date.parse(skg.STARTDATE.toString());
            const stopDate = Date.parse(skg.STOPDATE.toString());
            const solanM2 = Math.floor(cthd.SoLuong / skg.QTY1);
            console.log(skg);
            /*if (i > 0) { return; }*/
            if (skg.SKU === cthd.SKU && skg.METHOD === 25 && startDate <= todayDate && todayDate <= stopDate && slConLai > 0 && maxValue == skg.PRC_KEY) {
              // index.DGBan = skg.PRICE;
              // index.ChietKhau = (x.GiaBanLe - skg.PRICE) * 1;
              let listMe = Method.split("_");
              let check = false;
              listMe.forEach(s => {
                if (s == "21" || s == "20") {
                  check = true;
                  return;
                }

              })
              if (check) {
                return;
              }
              cthd.DGBan = cthd.DGBan;
              DGBanCK += cthd.DGBanCK = skg.DISCPRICE;
              TienCK += cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
              ChietKhau += cthd.TienCK * slConLai;
              TyLeCK += (cthd.TienCK / (cthd.DGBan / 100))
              Method += skg.METHOD.toString();
              PriceType += skg.PRICETYPE;
              /*i++;*/
            } else if (skg.SKU === cthd.SKU
              && skg.METHOD === 21
              && startDate <= todayDate
              && todayDate <= stopDate
              //&& mathe === skg.CUSTNUM
              && maCapDo.toLowerCase() === skg.PRICETYPE.toLowerCase()) {
              cthd.DGBan = cthd.DGBan;
              //cthd.DGBanCK = skg.DISCPRICE;
              //cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
              //cthd.ChietKhau = cthd.TienCK * cthd.SoLuong;
              //cthd.TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
              //cthd.Method = skg.METHOD.toString();
              //cthd.PriceType = skg.PRICETYPE;
              DGBanCK = cthd.DGBanCK = skg.DISCPRICE;
              TienCK = cthd.TienCK = cthd.DGBan - cthd.DGBanCK;
              ChietKhau = cthd.TienCK * cthd.SoLuong;
              TyLeCK = (cthd.TienCK / (cthd.DGBan / 100))
              Method += skg.METHOD.toString() + "_";
              PriceType += skg.PRICETYPE;
              /* i++;*/
              // index.ChietKhau = (x.GiaBanLe - skg.DISCPRICE) * 1;
            } else if (skg.SKU === cthd.SKU
              && skg.METHOD === 20
              && startDate <= todayDate
              && todayDate <= stopDate
              && mathe === skg.CUSTNUM
              && maCapDo != 'N/A') {
              cthd.DGBan = cthd.DGBan;
              //cthd.DGBanCK = cthd.DGBan - ((cthd.DGBan / 100) * skg.DISCPRICE);
              //cthd.TyLeCK = skg.DISCPRICE;
              //cthd.ChietKhau = (cthd.DGBan - cthd.DGBanCK) * cthd.SoLuong;
              //cthd.TienCK = ((cthd.DGBan / 100) * cthd.TyLeCK);
              //cthd.Method = skg.METHOD.toString();
              //cthd.PriceType = skg.PRICETYPE;
              DGBanCK = cthd.TienCK = cthd.DGBan - ((cthd.DGBan / 100) * skg.DISCPRICE);
              TyLeCK = skg.DISCPRICE;
              ChietKhau = (cthd.DGBan - cthd.DGBanCK) * cthd.SoLuong;
              TienCK = cthd.TienCK = ((cthd.DGBan / 100) * cthd.TyLeCK);
              Method += skg.METHOD.toString() + "_";
              PriceType += skg.PRICETYPE;
              /*i++;*/
            }
            else if (skg.SKU === cthd.SKU
              && skg.METHOD === 2
              && startDate <= todayDate
              && todayDate <= stopDate
              && solanM2 > 0 && maxValue2 == skg.PRC_KEY) {
              let listMe = Method.split("_");
              let check = false;
              listMe.forEach(s => {
                if (s == "21" || s == "20") {
                  check = true;
                  return;
                }

              })
              if (check) {
                return;
              }
              const ThanhTienCK_M2 = solanM2 * skg.DISCPRICE;
              const soHHConlai = cthd.SoLuong - (solanM2 * skg.QTY1);
              const TienCK_M2 = (cthd.DGBan * cthd.SoLuong) - (ThanhTienCK_M2 + (soHHConlai * cthd.DGBan));
              cthd.DGBan = cthd.DGBan;
              ChietKhau += TienCK_M2;
              //cthd.ChietKhau = (cthd.DGBan * cthd.SoLuong) - ThanhTienCK_M2;
              TienCK += (ChietKhau / cthd.SoLuong);
              DGBanCK += cthd.DGBanCK = cthd.DGBan - TienCK;
              TyLeCK += (TienCK / (cthd.DGBan / 100));
              Method += skg.METHOD.toString() + "_";
              PriceType += skg.PRICETYPE;
              slConLai = cthd.SoLuong % skg.QTY1;
              //i++;
            }
            else {
              cthd.DGBanCK = cthd.DGBan;
              cthd.TyLeCK = 0;
              cthd.ChietKhau = 0;
              cthd.TienCK = 0;
              cthd.TyLeCKHD = 0;
              cthd.TienCKHD = 0;
            }
          });
          if (DGBanCK > 0) {
            cthd.DGBanCK = DGBanCK;
          }
          else {
            cthd.DGBanCK = cthd.DGBanCK;
          }
          cthd.DGBan = cthd.DGBan;
          cthd.ChietKhau = ChietKhau;
          //cthd.ChietKhau = (cthd.DGBan * cthd.SoLuong) - ThanhTienCK_M2;
          cthd.TienCK = TienCK;
         /* cthd.DGBanCK = DGBanCK;*/
          cthd.TyLeCK = TyLeCK;
          cthd.Method = Method;
          cthd.PriceType = PriceType;
          tongCKHD += cthd.ChietKhau;
        }
      });
      hd.TienCK = hd.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
      this.getInto();
    }
  }

  // Trí Thêm E-Invoice
  InputE_Invoice() {
    const openE_Invoice = 'PageE_Invoice';
    this.checkAllPage(openE_Invoice);
  }

  ReturnSalesnet() {
    this.checkPageE_Invoice = false;
    this.BuyerName = "";
    this.NameCompany = "";
    this.taxcode = "";
    this.phone = null;
    this.Email = "";
    this.Address = "";

    //Xóa dữ liệu UI einvoice đã tạo
    this.urlXemEinvoice0510 = "";
    this.urlXemEinvoice8 = "";
    this.flaginv0510 = false;
    this.flaginv8 = false;

  }

  ReturnSalesnet_AdjItem() {
    this.checkPagePrice_Item = false;
    this.adjustItem = null;
    this.codeAdjustItem = '';
    this.newPrice = null;
    const valueIcon = "TurnOffIcon_BGDefault";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
  }

  ReturnSalesnet_PrcItem() {
    this.checkSearchPrice_Item = false;
    this.clear_PrcItem();
    const valueIcon = "TurnOffIcon_BGDefault";
    this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
  }

  clear_PrcItem() {
    this.priceItem = null;
    this.priceItem_dc = null;
    this.priceItem_SKG = null;
    this.priceItem_SKG_str = '';
    this.codePriceItem = '';
  }


  async ChangePrice() {
    if (this.newPrice == null) {
      this.messageError = "Vui lòng nhập giá mới!"
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
    }
    else {
      await this.productService.setNewPrice(this.adjustItem.MaHH, this.newPrice)
        .then(result => {
          this.messageNoti = "Cập nhật giá thành công!";
          this.modalService.open(this.contentNoti, { centered: true, backdrop: 'static', keyboard: false });
          this.GetPrductNewPrice();
          this.ReturnSalesnet_AdjItem();
        }).catch(err => {
          this.messageError = "Cập nhật giá thất bại! Vui lòng thử lại sau!"
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
        });
    }
  }


  async ValueOutputE_Invoice() {
    this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
    /* this.mr = this.modalService.open(this.contentLoading, { centered: true, backdrop: 'static'});*/
    let nameCompany = this.NameCompany.length > 0 ? this.NameCompany : "";
    let buyerName = this.BuyerName.length > 0 ? this.BuyerName : "";
    let taxCode = this.taxcode.length > 0 ? this.taxcode : "";
    let Phone = this.phone.length > 0 ? this.phone : "";
    let Email = this.Email.length > 0 ? this.Email : "";
    let Address = this.Address.length > 0 ? this.Address : "";
    if (taxCode != "" || (nameCompany != "" && buyerName != "" && Address != "")) {
      let KHEinvoice: KhachHangEinvoice = new KhachHangEinvoice();
      KHEinvoice.TenDonVi = nameCompany;
      KHEinvoice.TenKhachHang = buyerName;
      KHEinvoice.MST = isNullOrUndefined(taxCode) ? "" : taxCode;
      KHEinvoice.SDT = Phone;
      KHEinvoice.Email = Email;
      KHEinvoice.DiaChi = Address;
      KHEinvoice.MaNVTao = this.user.MaNV;
      let HD_xuat_Einvoice: HD = new HD();
      await this.billService.getLastHD()
        .then((data: HD) => {
          HD_xuat_Einvoice = data;
        });
      await this.einvoiceService.setEinvoice_HD(HD_xuat_Einvoice, KHEinvoice)
        .then((result: any) => {
          this.closeModal();
          if (result.status == 1) {
            this.mr = this.modalService.open(this.contentEinvoice, { centered: true, backdrop: 'static' });
            // Xử lý khi interface được sang TS Cloud
            const ListEinv: Array<EinvoiceReceive> = JSON.parse(result.data);
            ListEinv.forEach(ein => {
              if (ein.VAT == "8") {
                this.urlXemEinvoice8 = ein.ViewURL;
                this.flaginv8 = true;
                //this.EinvoiceID8 = result.einID;
              } else {
                this.urlXemEinvoice0510 = ein.ViewURL;
                this.flaginv0510 = true;
              }
            });
            this.checkPageE_Invoice = false;
            //this.urlXemEinvoice0510 = result.data;
            //this.EinvoiceID = result.einID;
          }
          else {

            this.messageError = 'Không thể tạo được Einvoice! Vui lòng thử lại sau!';
            this.openMessageError(this.contentError);
          }

        })
        .catch(err => {
          this.closeModal();
          this.messageError = 'Không thể tạo được Einvoice! Vui lòng thử lại sau!';
          this.openMessageError(this.contentError);
        });
    }
    else {
      //this.closeModal();
      this.messageError = 'Vui lòng nhập đủ thông tin xuất hóa đơn!';
      this.openMessageError(this.contentError);
    }
    // Nếu mà lưu vào db thì xóa hết dữ liệu trong form 
  }



  async XemEinvoice0510(contentError) {
    window.open(this.urlXemEinvoice0510, "_blank");
    //this.ReturnSalesnet();
  }

  async XemEinvoice8(contentError) {
    window.open(this.urlXemEinvoice8, "_blank");
    //this.ReturnSalesnet();
  }


  async OpenPageReturn_Item(contentError) {
    //await localForage.getItem('_curHD').then((result: any) => {
    //  console.log(result);
    //  const boolCurHD: HoaDon = JSON.parse(result);
    //  if (boolCurHD === null && boolCurHD.STTHD === 1) {
    //    this.messageError = 'Không có Giao Dịch trả hàng!';
    //    this.openMessageError(contentError);
    //  } else {
    //    const pageReturn_Item = 'PageReturn_Item';
    //    this.checkAllPage(pageReturn_Item);
    //  }
    //});
    // -------------------------- chỉnh sửa ngày T3 9h28 AM 14/06/2022
    this.valueSelectDate = moment().format('YYYY-MM-DD');
    const pageReturn_Item = 'PageReturn_Item';
    this.checkAllPage(pageReturn_Item);
  }

  async OpenPageAdjustPrice_Item(contentError) {
    if (this.listCart === undefined || this.listCart.length === 0) {
      await this.showConfirmTillKey().then((res: boolean) => {
        if (res) {
          const pagePrice_Item = 'PagePrice_Item';
          this.checkAllPage(pagePrice_Item);
          //if (this.BillTypeOne) {
          //  this.modalService.open(this.ContentReturn_Item, { centered: true });
          //} else {
          //  // this.messageError = 'Mời nhập số Hóa Đơn in lại!';
          //  this.messageError = 'Mời nhập số Giao Dịch trả hàng!';
          //  this.openMessageError(contentError);

          //}
        }
      });
    } else {
      this.messageError = 'Vui lòng kết thúc hóa đơn. Trước khi chỉnh giá!';
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
  }

  async OpenPageSearchPrice_Item(contentError) {
    const pageSearchPrice_Item = 'PageSearchPrice_Item';
    this.checkAllPage(pageSearchPrice_Item);
  }

  async findAdjustItem(contentError) {
    if (this.codeAdjustItem == '') {
      this.messageError = 'Mời nhập UPC/SKU trước khi load thông tin!';
      this.openMessageError(contentError);
    }
    else {
      const h = this.products.find(x => x.MaHH == this.codeAdjustItem.toString() || x.SKU == this.codeAdjustItem.toString());
      if (h != null) {
        //if (h.DonViTinh.toLowerCase() === 'met') {
        this.adjustItem = h;
        //}
        //else {
        //  this.messageError = 'Hàng hóa EA không được chỉnh giá';
        //  this.openMessageError(contentError);
        //}
      }
      else {
        this.messageError = 'Hàng hóa không tồn tại!';
        this.openMessageError(contentError);
      }
    }
  }

  async findPriceItem(contentError) {
    if (this.codePriceItem == '') {
      this.messageError = 'Mời nhập UPC/SKU trước khi load thông tin!';
      this.openMessageError(contentError);
    }
    else {
      const h = this.products.find(x => x.MaHH == this.codePriceItem.toString() || x.SKU == this.codePriceItem.toString());
      if (h != null) {
        //if (h.DonViTinh.toLowerCase() === 'met') {
        this.priceItem = h;
        this.priceItem_SKG_str = "";
        this.priceItem_SKG = this.dsSuKienGia.filter(k => k.SKU == this.priceItem.SKU);
        if (this.priceItem_SKG.length > 0) {
          this.priceItem_SKG_str = "(";
          this.priceItem_dc = this.priceItem_SKG[0].DISCPRICE
          this.priceItem_SKG.forEach(skg => {
            const todayDate = Date.now();
            const startDate = Date.parse(skg.STARTDATE.toString());
            const stopDate = Date.parse(skg.STOPDATE.toString());
            if (startDate <= todayDate && todayDate <= stopDate) {
              this.priceItem_SKG_str += skg.METHOD + '-' + skg.PRICETYPE;
              this.priceItem_SKG_str += ";";
            }
          })
          this.priceItem_SKG_str += ")";
        }
        //}
        //else {
        //  this.messageError = 'Hàng hóa EA không được chỉnh giá';
        //  this.openMessageError(contentError);
        //}
      }
      else {
        this.messageError = 'Hàng hóa không tồn tại!';
        this.openMessageError(contentError);
      }
    }
  }


  async ghichu() {
    this.mr = this.modalService.open(this.contentNotes, { centered: true, backdrop: 'static' });

    //if (this.codePriceItem == null) {
    //  this.messageError = 'Mời nhập UPC/SKU trước khi load thông tin!';
    //  this.openMessageError(contentError);
    //}
    //else {
    //  const h = this.products.find(x => x.MaHH == this.codePriceItem.toString() || x.SKU == this.codePriceItem.toString());
    //  if (h != null) {
    //    //if (h.DonViTinh.toLowerCase() === 'met') {
    //    this.priceItem = h;
    //    //}
    //    //else {
    //    //  this.messageError = 'Hàng hóa EA không được chỉnh giá';
    //    //  this.openMessageError(contentError);
    //    //}
    //  }
    //  else {
    //    this.messageError = 'Hàng hóa không tồn tại!';
    //    this.openMessageError(contentError);
    //  }
    //}
  }

  async Clear_Notes() {
    this.billNotes = '';
  }

  async Confirm_Notes() {
    //this.billNotes = '';
    console.log(this.billNotes);
  }

  async OpenModalReturn_Item(contentError) {
    await this.showConfirmTillKey().then((res: boolean) => {
      if (res) {
        if (this.BillTypeOne) {
          this.modalService.open(this.ContentReturn_Item, { centered: true });
        } else {
          // this.messageError = 'Mời nhập số Hóa Đơn in lại!';
          this.messageError = 'Mời nhập số Giao Dịch trả hàng!';
          this.openMessageError(contentError);

        }
      }
    });
  }

  AllReturn_Items() {
    if (this.BillTypeOne.DaTraHang === false) {
      const OpenAll_Items = 'PageMany_Items';
      this.checkAllPage(OpenAll_Items);
    } else {
      this.messageError = "Hóa đơn đã được trả hàng!";
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
      this.BillTypeOne = null;
    }
  }


  async SubmitReturnItems() {
    const Now_Date = moment().format('YYYY-MM-DD');
    let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
    await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
    let _dtQBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
    let tpc_Till: CuaHang_Store_CTQLocation = new CuaHang_Store_CTQLocation();
    let macqt_luutru_bandau: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();

    await this.authenticationService.GetStore_CQTLocation(_dtQBan[0].MaQuay)
      .then(result => {
        tpc_Till = {
          CQT_Location: result[0].cqT_Location,
          StoreID: result[0].storeID,
          TillID: result[0].tillID
        }
      });
    await this.authenticationService.getQuayBan_MaCQT(_dtQBan[0].MaQuay)
      .then(result => {
        if (result[0] === null) {
          macqt_luutru_bandau = {
            CQT_Location: tpc_Till.CQT_Location,
            MACQT: macqt_luutru.MaCQT.toString(),
            Register: tpc_Till.TillID,
            Store: tpc_Till.StoreID,
            Update_Date: Now_Date,
            Year: macqt_luutru.Nam
          }
        } else {
          macqt_luutru_bandau = {
            CQT_Location: result[0].maCQT_Location,
            MACQT: result[0].macqt,
            Register: result[0].register,
            Store: result[0].store,
            Update_Date: result[0].update_Date,
            Year: result[0].year
          }
        }
      });
    if (tpc_Till.CQT_Location === macqt_luutru_bandau.CQT_Location) {
      if (macqt_luutru.MaCQT.toString() === "99999") {
        this.mr = this.modalService.open(this.contentLitmit_CQT, { centered: true, backdrop: 'static' })
      } else {
        // Xử lý cho phần khi chưa đủ MÃ CQT = 99999
        const t = moment();
        const date = t.format('YYYY-MM-DD');
        var strmaCQT = "";
        var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
        var MACQT: MaCQT = new MaCQT();
        await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
        var kytu = "";
        let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1
        MACQT = {
          MaCQT: MaCQTCongDon,
          MaKhuVuc: MACQT.MaKhuVuc,
          MaQuay: MACQT.MaQuay,
          Nam: MACQT.Nam,
          TenQuay: MACQT.TenQuay,
          CQT_location: MACQT.CQT_location,
          StoreID: MACQT.StoreID
        }
        await localForage.setItem('_MaCQT', JSON.stringify(MACQT))
        var socuoinam = MACQT.Nam.substring(2, 4)
        if (MACQT.MaCQT.toString().length === 1) {
          kytu = "0000" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 2) {
          kytu = "000" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 3) {
          kytu = "00" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 4) {
          kytu = "0" + MACQT.MaCQT;
        } else {
          kytu = MACQT.MaCQT.toString();
        }
        // chuyển sang lưu local cho phần này
        strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
        TPCQuayBanMaCQT = {
          Store: MACQT.StoreID,
          Register: MACQT.MaQuay,
          MACQT: MACQT.MaCQT.toString(),
          Update_Date: date,
          Year: MACQT.Nam,
          CQT_Location: MACQT.CQT_location
        }
        console.log(TPCQuayBanMaCQT)
        console.log(TPCQuayBanMaCQT.MACQT)
        let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + TPCQuayBanMaCQT.CQT_Location + "\n" + strmaCQT + "";
        //this.save_salebackup_POS(data, TPCQuayBanMaCQT.Register, MACQT.CQT_location);
        var fileNameCQT = TPCQuayBanMaCQT.Register + "_" + MACQT.CQT_location
        this.upload_saleBackup_FTP_CQT(fileNameCQT, data)
        // Kết thúc phần Trí thêm
        this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });

        if (window.navigator.onLine !== true) {
          this.closeModal();
          this.messageError = 'Không thể trả hàng khi offline. Vui lòng thử lại sau!';
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
        }
        else {
          const now = new Date();
          var value_check = this.BillTypeOne.CTHoaDons.find(x => x.checked == true);
          if (value_check) {
            const Now_Date = moment().format('YYYY-MM-DD');
            let countTrue = this.BillTypeOne.CTHoaDons.filter(x => x.checked == true);
            let countFalse = this.BillTypeOne.CTHoaDons.length;
            const t_ValueSelectDate = moment(this.valueSelectDate);
            const s_ValueSelectDate = t_ValueSelectDate.format('DD/MM/YYYY');
            const s_ValueSelectDate_ = t_ValueSelectDate.format('DD');
            const t_now = moment().format('DD');
            let day_InWeek = parseInt(t_now) - parseInt(s_ValueSelectDate_);
            console.log(day_InWeek);
            if (countTrue.length == countFalse && day_InWeek == 0) {
              this.closeModal();

              this.messageError = 'Bạn đã chọn tất cả mặt hàng trong ngày. Vui lòng chọn chức năng PosVoid!';
              this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
              this.BillTypeOne.CTHoaDons.forEach(x => {
                x.checked = false;
              })
            } else {
              this.BillTypeOne.CTHoaDons.forEach(x => {
                if (x.checked == true) {
                  this.ChangeMoney_ReturnItems = this.ChangeMoney_ReturnItems + (x.DGBan * (-(x.SoLuong)));
                  this.ChangeDiscount_ReturnITems += x.TienCKHD + x.TienCK;
                  this.listItems_Return.push(x);
                  const value_listCartReturnitem: CTHoaDon = {
                    ChietKhau: x.TienCK + x.TienCKHD,
                    TienCK: x.TienCK,
                    TyLeCK: x.TyLeCK,
                    TienCKHD: x.TienCKHD,
                    TyLeCKHD: x.TyLeCKHD,
                    DGBan: x.DGBan,
                    DGBanCK: x.DGBanCK,
                    HangHoaID: x.HangHoaID,
                    HinhAnh: x.HinhAnh,
                    MaHH: x.MaHH,
                    NgayGioQuet: this.GetCurTime_UTC(),
                    SKU: x.SKU,
                    SoLuong: -(x.SoLuong),
                    Stt: x.Stt,
                    TenHH: x.TenHH,
                    VATDauRa: x.VATDauRa,
                    checked: x.checked,
                    MaNCC: x.MaNCC
                  }
                  console.log(this.ChangeMoney_ReturnItems)
                  console.log(this.ChangeDiscount_ReturnITems)
                  this.listCart_ReturnItems.push(value_listCartReturnitem);
                  this.ChangeOrder.CTHoaDons = this.listCart_ReturnItems;
                  this.ChangeOrder.MaQuay = this.BillTypeOne.MaQuay;
                  this.ChangeOrder.MaCH = this.dtQBan.MaCH;
                  this.ChangeOrder.LoaiHD = 3;
                  this.ChangeOrder.MaNV = this.user.MaNV;
                  this.ChangeOrder.NgayHD = now;
                  this.ChangeOrder.STTHD = this.numberHD;
                  this.ChangeOrder.TongTien = -(this.ChangeMoney_ReturnItems); // TriGiaBan
                  //this.ChangeOrder.TongTien = -(this.ChangeMoney_ReturnItems);
                  this.ChangeOrder.HDGoc = this.BillTypeOne.HoaDonID;
                  this.ChangeOrder.HoaDonID = uuid();
                  this.ChangeOrder.KHTV = this.BillTypeOne.KHTV;
                  this.ChangeOrder.TienCK = -(this.ChangeDiscount_ReturnITems); // TongCK
                  this.ChangeOrder.TongTienTraHang = -(this.ChangeMoney_ReturnItems);
                  const t = moment();
                  const s = t.format('DDMMYY');
                  this.ChangeOrder.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
                }
              });
              const index: HoaDon = this.listHD_Tong.find(x => x.STTHD === this.numberHD);
              if (!index) {
                this.listHD_Tong.push(this.ChangeOrder);
              } else {
                const i = this.listHD_Tong.indexOf(index);
                this.listHD_Tong[i].LoaiHD = 3;
                this.listHD_Tong[i].NgayHD = now;
              }
              this.billService.saveTotalBillRefresh(this.listHD_Tong);
              const hhtt: HTTT = {
                DoUuTien: 1,
                MaHinhThuc: "0001",
                MaNhomThanhToan: "001",
                MaThe: "",
                TenHinhThuc: "Tiền mặt",
                TenNhom: "Tiền mặt"
              }
              const paybillreturn: TTHD = {
                HTTT: hhtt,
                SoTienThanhToanHD: -(this.ChangeOrder.TongTienTraHang),
                QuyDoiNgoaiTe: 1 * (-this.ChangeOrder.TongTienTraHang),
                TyLeQuyDoi: 1
              };
              this.payBill.push(paybillreturn);
              this.ListHD.push({ HoaDon: this.ChangeOrder, TTHD: this.payBill });
              console.log(this.ListHD);
              var value = "ManyReturn_Items";
              await this.openPrintOrder_triph_ReturnItems(value, this.ChangeOrder.MaHD, strmaCQT);
              let isValid = await this.setCheckOneBill_TraHang(3, this.ChangeOrder, this.payBill, strmaCQT, TPCQuayBanMaCQT);
              if (isValid === true) {
                this.PrintCart();
                this.listCart_ReturnItems = [];
                await this.getLengthHD();
                this.payBill = [];
                await localForage.removeItem('_customer');
                await localStorage.removeItem('_dataQR');
                await localStorage.removeItem('_dataPoint');
                await this.setNumberMaxBill();
                this.ChangeMoney_ReturnItems = 0;
                this.ChangeDiscount_ReturnITems = 0;
                this.returnPrintBillAgain();
                this.closeModal();

              }
            }
          } else {
            this.closeModal();

            this.messageError = 'Vui lòng chọn hàng hóa cần trả!';
            this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
          }
        }
      }
    } else {
      // Xử lý cho phần CQT thay đổi. Thông báo kết ca quầy
      this.closeModal();
      this.messageError = 'Vui lòng kết ca để nhập quầy lại.';
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
  }

  async openPrintOrder_triph_ReturnItems(value: string, mahd: string, MaCQT: string) {
    // const deCryptDSBill = localStorage.getItem('_dsBill');

    const payBillAfter: Array<TTHD> = new Array<TTHD>();
    let totalPayment = 0;
    this.payBill.forEach(x => {
      totalPayment = totalPayment + x.SoTienThanhToanHD;
    });
    this.ChangeOrder.TienTraKhach = totalPayment - this.total;
    await this.payBill.forEach(x => {

      const payment: HTTT = {
        DoUuTien: x.HTTT.DoUuTien,
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        TenNhom: x.HTTT.TenNhom,
        MaThe: x.HTTT.MaThe
      };

      let xSoTienThanhToanHD: number;
      if (x.HTTT.MaHinhThuc === '0001') {
        xSoTienThanhToanHD = x.SoTienThanhToanHD;
      } else {
        xSoTienThanhToanHD = x.SoTienThanhToanHD;
      }
      const pay: TTHD = { HTTT: payment, SoTienThanhToanHD: xSoTienThanhToanHD };
      payBillAfter.push(pay);
    });
    await this.GenerateBill("PHIẾU TRẢ HÀNG",
      this.dtQBan.TenQuay, MaCQT, this.user.TenDangNhap,
      this.VietTat_TenNhanVien(this.user.TenNV),
      this.ChangeOrder.STTHD,
      this.ChangeOrder.CTHoaDons,
      this.payBill,
      this.dtQBan.MaCH,
      payBillAfter,
      this.customer,
      this.ChangeOrder.MaHD,
      this.billNotes);
    this.changeCheckMoney_Payment();
  }



  async PosVoid() {
    const Now_Date = moment().format('YYYY-MM-DD');
    let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
    await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
    let _dtQBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
    let tpc_Till: CuaHang_Store_CTQLocation = new CuaHang_Store_CTQLocation();
    let macqt_luutru_bandau: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();

    await this.authenticationService.GetStore_CQTLocation(_dtQBan[0].MaQuay)
      .then(result => {
        tpc_Till = {
          CQT_Location: result[0].cqT_Location,
          StoreID: result[0].storeID,
          TillID: result[0].tillID
        }
      });
    await this.authenticationService.getQuayBan_MaCQT(_dtQBan[0].MaQuay)
      .then(result => {
        if (result[0] === null) {
          macqt_luutru_bandau = {
            CQT_Location: tpc_Till.CQT_Location,
            MACQT: macqt_luutru.MaCQT.toString(),
            Register: tpc_Till.TillID,
            Store: tpc_Till.StoreID,
            Update_Date: Now_Date,
            Year: macqt_luutru.Nam
          }
        } else {
          macqt_luutru_bandau = {
            CQT_Location: result[0].maCQT_Location,
            MACQT: result[0].macqt,
            Register: result[0].register,
            Store: result[0].store,
            Update_Date: result[0].update_Date,
            Year: result[0].year
          }
        }
      });
    if (tpc_Till.CQT_Location === macqt_luutru_bandau.CQT_Location) {
      if (macqt_luutru.MaCQT.toString() === "99999") {
        this.mr = this.modalService.open(this.contentLitmit_CQT, { centered: true, backdrop: 'static' })
      } else {
        // Xử lý cho phần Mã CQT vượt quá 99999
        const t = moment();
        const date = t.format('YYYY-MM-DD');
        var strmaCQT = "";
        var TPCQuayBanMaCQT: TPC_QuayBan_MaCQT = new TPC_QuayBan_MaCQT();
        var MACQT: MaCQT = new MaCQT();
        await localForage.getItem('_MaCQT').then((result: any) => { MACQT = JSON.parse(result) });
        var kytu = "";
        let MaCQTCongDon: number = parseInt(MACQT.MaCQT.toString()) + 1
        MACQT = {
          MaCQT: MaCQTCongDon,
          MaKhuVuc: MACQT.MaKhuVuc,
          MaQuay: MACQT.MaQuay,
          Nam: MACQT.Nam,
          TenQuay: MACQT.TenQuay,
          CQT_location: MACQT.CQT_location,
          StoreID: MACQT.StoreID
        }
        await localForage.setItem('_MaCQT', JSON.stringify(MACQT))
        var socuoinam = MACQT.Nam.substring(2, 4)
        if (MACQT.MaCQT.toString().length === 1) {
          kytu = "0000" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 2) {
          kytu = "000" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 3) {
          kytu = "00" + MACQT.MaCQT;
        } else if (MACQT.MaCQT.toString().length === 4) {
          kytu = "0" + MACQT.MaCQT;
        } else {
          kytu = MACQT.MaCQT.toString();
        }
        // chuyển sang lưu local cho phần này
        strmaCQT = "M1" + "-" + socuoinam + "-" + MACQT.CQT_location + MACQT.TenQuay + kytu;
        TPCQuayBanMaCQT = {
          Store: MACQT.StoreID,
          Register: MACQT.MaQuay,
          MACQT: MACQT.MaCQT.toString(),
          Update_Date: date,
          Year: MACQT.Nam,
          CQT_Location: MACQT.CQT_location
        }
        console.log(TPCQuayBanMaCQT)
        console.log(TPCQuayBanMaCQT.MACQT)
        let data = "" + TPCQuayBanMaCQT.Store + "\n" + TPCQuayBanMaCQT.Register + "\n" + TPCQuayBanMaCQT.Year + "\n" + TPCQuayBanMaCQT.CQT_Location + "\n" + strmaCQT + "";
        //this.save_salebackup_POS(data, TPCQuayBanMaCQT.Register, MACQT.CQT_location);
        var fileNameCQT = TPCQuayBanMaCQT.Register + "_" + MACQT.CQT_location
        this.upload_saleBackup_FTP_CQT(fileNameCQT, data)
        // Kết thúc phần Trí thêm
        this.mr = this.modalService.open(this.PageFindLoad, { centered: true, backdrop: 'static' });
        const t_ValueSelectDate = moment(this.valueSelectDate);
        const s_ValueSelectDate = t_ValueSelectDate.format('DD/MM/YYYY');
        const s_ValueSelectDate_ = t_ValueSelectDate.format('DD');
        const t_now = moment().format('DD');
        let day_InWeek = parseInt(t_now) - parseInt(s_ValueSelectDate_);
        if (day_InWeek == 0) {
          console.log(this.dataBill);
          if (this.BillTypeOne.DaTraHang === false) {
            const now = new Date();
            console.log(this.payBill);
            this.BillTypeOne.CTHoaDons.forEach(x => {
              this.ChangeMoney_ReturnItems = this.ChangeMoney_ReturnItems + (x.DGBan * (-(x.SoLuong)));
              this.ChangeDiscount_ReturnITems += x.TienCKHD + x.TienCK;
              const value_listCartReturnitem: CTHoaDon = {
                ChietKhau: x.TienCKHD + x.TienCK,
                TienCK: x.TienCK,
                TyLeCK: x.TyLeCK,
                TienCKHD: x.TienCKHD,
                TyLeCKHD: x.TyLeCKHD,
                DGBan: x.DGBan,
                DGBanCK: x.DGBanCK,
                HangHoaID: x.HangHoaID,
                HinhAnh: x.HinhAnh,
                MaHH: x.MaHH,
                NgayGioQuet: this.GetCurTime_UTC(),
                SKU: x.SKU,
                SoLuong: -(x.SoLuong),
                Stt: x.Stt,
                TenHH: x.TenHH,
                VATDauRa: x.VATDauRa,
                checked: x.checked,
                MaNCC: x.MaNCC
              }
              this.listCart_ReturnItems.push(value_listCartReturnitem);
              this.ChangeOrder.CTHoaDons = this.listCart_ReturnItems;
              this.ChangeOrder.MaQuay = this.BillTypeOne.MaQuay;
              this.ChangeOrder.MaCH = this.dtQBan.MaCH;
              this.ChangeOrder.LoaiHD = 5;
              this.ChangeOrder.MaNV = this.BillTypeOne.MaNV;
              this.ChangeOrder.NgayHD = now;
              this.ChangeOrder.STTHD = this.numberHD;
              this.ChangeOrder.TongTien = -(this.ChangeMoney_ReturnItems); // TriGiaBan
              this.ChangeOrder.HDGoc = this.BillTypeOne.HoaDonID;
              this.ChangeOrder.HoaDonID = uuid();
              this.ChangeOrder.KHTV = this.BillTypeOne.KHTV;
              this.ChangeOrder.TienCK = -(this.ChangeDiscount_ReturnITems); // TongCK
              this.ChangeOrder.TongTienTraHang = -(this.ChangeMoney_ReturnItems);
              const t = moment();
              const s = t.format('DDMMYY');
              this.ChangeOrder.MaHD = this.dtQBan.MaQuay + s + this.order.STTHD.toString().padStart(4, '0');
            });
            await this.einvoiceService.getTPC_Einvoice(this.ChangeOrder.HDGoc)
              .then(async (result: ServerResponse) => {
                if (result.code === 0) {
                  const index: HoaDon = this.listHD_Tong.find(x => x.STTHD === this.numberHD);
                  if (!index) {
                    this.listHD_Tong.push(this.ChangeOrder);
                  } else {
                    const i = this.listHD_Tong.indexOf(index);
                    this.listHD_Tong[i].LoaiHD = 5;
                    this.listHD_Tong[i].NgayHD = now;
                  }
                  this.billService.saveTotalBillRefresh(this.listHD_Tong);
                  this.dataBill.HTThanhToan.forEach(hinhthuc => {
                    const httt: HTTT = {
                      DoUuTien: hinhthuc.DoUuTien,
                      MaHinhThuc: hinhthuc.MaHinhThuc,
                      MaNhomThanhToan: hinhthuc.MaNhomThanhToan,
                      MaThe: hinhthuc.MaThe,
                      TenHinhThuc: hinhthuc.TenHinhThuc,
                      TenNhom: hinhthuc.TenNhom
                    }
                    const paybillreturn: TTHD = {
                      HTTT: httt,
                      SoTienThanhToanHD: -(hinhthuc.SoTienThanhToanHD),
                      QuyDoiNgoaiTe: 1 * (-(hinhthuc.SoTienThanhToanHD)),
                      TyLeQuyDoi: 1
                    };
                    this.payBill.push(paybillreturn);
                  })
                  this.ListHD.push({ HoaDon: this.ChangeOrder, TTHD: this.payBill });
                  console.log(this.ListHD);
                  var value = "AllReturn_Items";
                  await this.openPrintOrder_triph_ReturnItems(value, this.ChangeOrder.MaHD, strmaCQT);
                  let isValid = await this.setCheckOneBill_TraHang(5, this.ChangeOrder, this.payBill, strmaCQT, TPCQuayBanMaCQT);
                  if (isValid === true) {
                    this.PrintCart();
                    this.listCart_ReturnItems = [];
                    this.listCart_ReturnItems = [];
                    await this.getLengthHD();
                    this.payBill = [];
                    await localForage.removeItem('_customer');
                    await localStorage.removeItem('_dataQR');
                    await localStorage.removeItem('_dataPoint');
                    await this.setNumberMaxBill();
                    this.ChangeMoney_ReturnItems = 0;
                    this.ChangeDiscount_ReturnITems = 0;
                    this.returnPrintBillAgain();
                    this.closeModal();
                  }
                }
                else {
                  this.closeModal();

                  this.messageError = "Đã ghi nhận thông tin xuất Einvoice. Không thể hủy hóa đơn";
                  this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
                }
              })
              .catch(err => {
                this.closeModal();

                this.messageError = "Đã xảy ra lỗi vui lòng thử lại sau";
                this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
              });
          } else {
            this.closeModal();

            this.messageError = "Hóa đơn đã được trả hàng!";
            this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
            this.BillTypeOne = null;
          }
        }
        else {
          this.closeModal();

          this.messageError = "Không thể Hủy hóa đơn đã qua ngày! Vui lòng chọn chức năng trả hàng";
          this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
        }
      }
    } else {
      // Xử lý cho phần thay đổi Mã CQT
      this.closeModal();
      this.messageError = "Vui lòng kết ca để nhập quầy lại.";
      this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
    }
  }


  Clear_Input_PageCameraNew() {
    this.valueQuanlity_PageCamera = undefined;
    this.valueUPC_PageCamera = undefined;
  }


  async Add_Product_PageCameraNew() {
    if (this.valueQuanlity_PageCamera !== undefined && this.valueUPC_PageCamera !== undefined) {
      if (this.valueQuanlity_PageCamera === null || this.valueQuanlity_PageCamera <= 0) { this.valueQuanlity_PageCamera = 1; }
      if (this.valueQuanlity_PageCamera > 999) { this.valueQuanlity_PageCamera = 999; }
      if (this.valueQuanlity_PageCamera % 1 != 0) {
        const h = this.products.find(x => x.MaHH == this.valueUPC_PageCamera.toString() || x.SKU == this.valueUPC_PageCamera.toString())
        if (h.ChoChinhGia === false) {
          if (h.DonViTinh.toLowerCase() != "met" && h.DonViTinh.toLowerCase() != "kg") {
            this.messageError = "Hàng hóa đơn vị tính EA không được phép nhập số thập phân";
            this.modalService.open(this.contentError, { centered: true, backdrop: 'static' });
            this.valueQuanlity_PageCamera = (this.valueQuanlity_PageCamera / 1) - (this.valueQuanlity_PageCamera % 1);
            return;
          }
        }
      }
      const getDSHH = await localForage.getItem('_dsHH').then((result: any) => result);
      var deCryptDSHH;
      if (getDSHH !== null) {
        deCryptDSHH = this.jwtService.deCryptData(getDSHH);
      }
      else {
        deCryptDSHH = null;
      }
      const ListHH: Array<HangHoa> = JSON.parse(deCryptDSHH);
      console.log(ListHH)
      // lấy mã PLU
      var MaPLU = "";
      if (this.valueUPC_PageCamera.substring(0, 2) == "29") {
        MaPLU = this.valueUPC_PageCamera.substring(2, 7);
      } else if (this.valueUPC_PageCamera.substring(0, 3) === "029") {
        MaPLU = this.valueUPC_PageCamera.substring(3, 8);
      } else if (this.valueUPC_PageCamera.substring(0, 6) === "000000") {
        MaPLU = this.valueUPC_PageCamera.substring(8, 13);
      }
      let index: HangHoa = new HangHoa();
      if (MaPLU != "") {
        index = ListHH.find(x => x.PLU === MaPLU);
      }
      else {
        index = ListHH.find(x => x.MaHH === this.valueUPC_PageCamera.toString() || x.SKU === this.valueUPC_PageCamera.toString());
      }

      if (this.valueUPC_PageCamera.substring(0, 2) == "29" && MaPLU !== "") {
        let catSoLuongCuaHangHoaPLU: any = this.valueUPC_PageCamera.substring(7, 12);
        this.valueQuanlity_PageCamera = catSoLuongCuaHangHoaPLU / 1000;
      }
      else if (this.valueUPC_PageCamera.substring(0, 3) === "029" && MaPLU !== "" || this.valueUPC_PageCamera.substring(0, 5) === "000000" && MaPLU !== "") {
        this.valueQuanlity_PageCamera = this.valueQuanlity_PageCamera;
      }
      if (index !== undefined) {
        if (index.ChoChinhGia === true) {
          this.price0Item = index;
          await this.show0PriceItem().then((res: boolean) => {
            if (res) {
              if (this.listCart == null) {
                let CartNull: CTHoaDon = {
                  HangHoaID: index.HangHoaID,
                  VATDauRa: index.VATDauRa,
                  Stt: 1,
                  HinhAnh: index.HinhAnh,
                  MaHH: index.MaHH,
                  TenHH: index.TenHH,
                  DGBan: this.priceadd,
                  DGBanCK: this.priceadd,
                  SoLuong: this.valueQuanlity_PageCamera,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: index.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: index.MaNCC
                };
                this.SuKienGia(CartNull, index);
                this.cart.push(CartNull);
                this.listCart = this.cart;
                this.valueUPC_PageCamera = undefined;
                this.valueQuanlity_PageCamera = undefined;
                this.getInto();
              } else {
                const length = this.listCart.length + 1;
                let Cart: CTHoaDon = {
                  VATDauRa: index.VATDauRa,
                  HangHoaID: index.HangHoaID,
                  Stt: length,
                  HinhAnh: index.HinhAnh,
                  MaHH: index.MaHH,
                  TenHH: index.TenHH,
                  DGBan: this.priceadd,
                  DGBanCK: this.priceadd,
                  SoLuong: this.valueQuanlity_PageCamera,
                  ChietKhau: 0,
                  TienCK: 0,
                  TyLeCK: 0,
                  TienCKHD: 0,
                  TyLeCKHD: 0,
                  SKU: index.SKU,
                  NgayGioQuet: this.GetCurTime_UTC(),
                  MaNCC: index.MaNCC
                };
                this.SuKienGia(Cart, index);
                this.listCart.push(Cart);
              }
              this.valueUPC_PageCamera = undefined;
              this.valueQuanlity_PageCamera = undefined;
              this.getInto();

              this.order.CTHoaDons = this.listCart;
              this.order.TongTien = this.total;
              this.order.TienCK = this.order.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
              this.billService.saveBillRefresh(this.order);
              this.checkPageHome = true;
              this.checkPageCamera_New = false;
              const valueIcon = "TurnOffIcon_BGDefault";
              this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
              this.priceadd = 1;
              this.price0Item = null;
            }
            else {
              this.priceadd = 1;
              this.price0Item = null;
            }
          })
        }
        else {
          if (this.listCart == null) {
            let CartNull: CTHoaDon = {
              HangHoaID: index.HangHoaID,
              VATDauRa: index.VATDauRa,
              Stt: 1,
              HinhAnh: index.HinhAnh,
              MaHH: index.MaHH,
              TenHH: index.TenHH,
              DGBan: index.GiaBanLe,
              DGBanCK: index.GiaBanLe,
              SoLuong: this.valueQuanlity_PageCamera,
              ChietKhau: 0,
              TienCK: 0,
              TyLeCK: 0,
              TienCKHD: 0,
              TyLeCKHD: 0,
              SKU: index.SKU,
              NgayGioQuet: this.GetCurTime_UTC(),
              MaNCC: index.MaNCC
            };
            this.SuKienGia(CartNull, index);
            this.cart.push(CartNull);
            this.listCart = this.cart;
            this.valueUPC_PageCamera = undefined;
            this.valueQuanlity_PageCamera = undefined;
            this.getInto();
          } else {
            const indexCart: CTHoaDon = this.listCart.find(x => x.MaHH === index.MaHH || x.SKU === index.SKU);
            if (indexCart) {
              const i = this.listCart.indexOf(indexCart);
              this.listCart[i].SoLuong = this.listCart[i].SoLuong + this.valueQuanlity_PageCamera;
              this.listCart[i].ChietKhau = this.listCart[i].ChietKhau * this.listCart[i].SoLuong;
            } else {
              const length = this.listCart.length + 1;
              let Cart: CTHoaDon = {
                VATDauRa: index.VATDauRa,
                HangHoaID: index.HangHoaID,
                Stt: length,
                HinhAnh: index.HinhAnh,
                MaHH: index.MaHH,
                TenHH: index.TenHH,
                DGBan: index.GiaBanLe,
                DGBanCK: index.GiaBanLe,
                SoLuong: this.valueQuanlity_PageCamera,
                ChietKhau: 0,
                TienCK: 0,
                TyLeCK: 0,
                TienCKHD: 0,
                TyLeCKHD: 0,
                SKU: index.SKU,
                NgayGioQuet: this.GetCurTime_UTC(),
                MaNCC: index.MaNCC
              };
              this.SuKienGia(Cart, index);
              this.listCart.push(Cart);
            }
            this.valueUPC_PageCamera = undefined;
            this.valueQuanlity_PageCamera = undefined;
            this.getInto();
          }
          this.order.CTHoaDons = this.listCart;
          this.order.TongTien = this.total;
          this.order.TienCK = this.order.CTHoaDons.map(o => o.ChietKhau).reduce((sum, current) => sum + current, 0);
          this.billService.saveBillRefresh(this.order);
          this.checkPageHome = true;
          this.checkPageCamera_New = false;
          const valueIcon = "TurnOffIcon_BGDefault";
          this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
        }


      } else {
        this.messageError = 'Mã hàng không tồn tại!';
        this.mr = this.modalService.open(this.contentError, { centered: true });
        this.valueUPC_PageCamera = undefined;
        this.valueQuanlity_PageCamera = undefined;
      }
    } else {
      this.messageError = 'Không được để trống dữ liệu';
      this.mr = this.modalService.open(this.contentError, { centered: true });
      this.valueUPC_PageCamera = undefined;
      this.valueQuanlity_PageCamera = undefined;
    }
  }


  async GetPrductNewPrice() {
    await localForage.getItem('_dsHH').then((result: string) => {
      const deCryptDSHH = this.jwtService.deCryptData(result);
      const danhsachHangHoa: Array<HangHoa> = JSON.parse(deCryptDSHH);
      // danhsachHangHoa.forEach(element => {
      //   productService.getImgProduct(element.MaHH).then(data => element.HinhAnh = data);
      // });

      this.products = danhsachHangHoa;
      this.onepartten_product = 4 * Math.round(this.products.length / 10);
      this.sum = this.onepartten_product;
      // const str = this.jwtService.enCryptData(danhsachHangHoa);
      // this.getlocalconfig.getConfigLocalForage()
      //   .then(async res => {
      //     await localForage.setItem('_dsHH', str);
      //   });
      //   const index: HangHoa = this.products.find(x => x.HinhAnh === true);
      // console.log('con cho nay ' +index);
      this.appendItemsDown(0, this.sum);
      //console.log(this.products);
    });
  }



  bareCode_ForBill(mahd: string) {
    const canvas = document.createElement('canvas');

    const dataURL = bwipjs
      .toCanvas(canvas, {
        bcid: 'code128', // Barcode type
        text: mahd,
        scale: 1, // 3x scaling factor
        height: 10, // Bar height, in millimeters,
        includetext: false, // Show human-readable text
      })
      .toDataURL('image/png');
    return dataURL;
  }


  async QRCode_ForBill(mahd: string) {
    var getURIWebHDDT = await this.billService.GetURIWebHDDT();
    const canvas = document.createElement('canvas');
    var link = `${getURIWebHDDT}/HoaDon/XuatHoaDon?MaHD=${mahd}`;
    console.log(link);
    const dataURL = bwipjs
      .toCanvas(canvas, {
        bcid: 'qrcode', // Barcode type
        text: link,
        scale: 1, // 3x scaling factor
        includetext: false, // Show human-readable text
      })
      .toDataURL('image/png');
    console.log(dataURL);
    return dataURL;
  }


  async showModalGiamGia() {
    await this.showConfirmTillKey().then((res: boolean) => {
      if (res) {
        this.mr = this.modalService.open(this.contentDiscount, { centered: true, backdrop: 'static' });
        document.getElementById('discount_input').focus();
        this.mr.result.then((result) => {
          if (result.toString() == 'true') {
            if (this.discount_percent < 1 || this.discount_percent > 50) {
              //this.mo();
              this.messageError = 'Phần trăm giảm giá phải nằm trong khoảng từ 1% đến 50%';
              this.mr = this.modalService.open(this.contentError, { centered: true });

            }
            else {
              this.listCart_bef_discount = JSON.parse(JSON.stringify(this.listCart));
              //this.listCart_bef_discount = .slice();
              const trigiasauckhd = this.total - ((this.total * this.discount_percent) / 100);
              let tongcktay = (this.total - trigiasauckhd);
              this.totaldiscount_HD = tongcktay;
              var count_nodiscount = this.listCart.filter(x => x.ChietKhau == 0).length
              let cktay_ct = 0;
              this.listCart.filter(x => x.ChietKhau == 0).forEach((ct, i) => {
                if (i == count_nodiscount - 1) {
                  ct.ChietKhau = tongcktay - cktay_ct;
                  ct.TienCKHD = ct.ChietKhau / ct.SoLuong;
                  ct.DGBanCK = ct.DGBan - ct.TienCKHD;
                  ct.TyLeCKHD = (ct.TienCKHD / (ct.DGBan / 100))
                }
                else {
                  ct.ChietKhau = (ct.DGBan * ct.SoLuong) - ((ct.DGBan * ct.SoLuong) - (((ct.DGBan * ct.SoLuong) * this.discount_percent) / 100));
                  cktay_ct += ct.ChietKhau;
                  ct.TienCKHD = ct.ChietKhau / ct.SoLuong;
                  ct.DGBanCK = ct.DGBan - ct.TienCKHD;
                  ct.TyLeCKHD = (ct.TienCKHD / (ct.DGBan / 100))
                }
              });
              console.log(this.listCart);
              this.getInto();
              console.log(this.listCart_bef_discount);
            }

          }
          else if (result.toString() == 'false') {
            if (this.listCart_bef_discount && this.listCart_bef_discount.length > 0) {
              this.listCart = JSON.parse(JSON.stringify(this.listCart_bef_discount));
              this.listCart_bef_discount = [];
              this.discount_percent = 0;
              this.getInto();
            }
            else {
              this.messageError = 'Không thể bỏ CK khi chưa áp dụng CK';
              this.mr = this.modalService.open(this.contentError, { centered: true });
            }
          }
          else {
            //this.scan_quantity = 0;
            this.discount_percent = 0
            this.closeModal();
          }
        });
      }
    });
  }

  async showModalChangePass() {
    this.mr = this.modalService.open(this.contentChangePass, { centered: true, backdrop: 'static', keyboard: false });
    await this.mr.result.then(async (result) => {
      if (result.toString() == 'true') {
        const user_cp = this.dsNhanVien.find(x => x.TenDangNhap == this.user.TenDangNhap && x.MaCH == this.user.MaCH);
        if (user_cp) {
          const pw = this.jwtService.EncodePass(this.us_cp.oldPass);
          const oldPass_true = user_cp.MatKhau === pw;
          if (!oldPass_true) {
            this.messageError = 'Mật khẩu cũ không chính xác!';
            this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
            return null;
          }
          if (this.us_cp.newPass == this.us_cp.oldPass) {
            this.messageError = 'Mật khẩu cũ và mật khẩu mới không được trùng nhau!';
            this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
            return null;
          }
          if (this.us_cp.newPass != this.us_cp.newPass_confirm) {
            this.messageError = 'Mật khẩu mới và mật khẩu mới nhập lại phải giống nhau!';
            this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
            return null;
          }
          await this.employeesService.changePass(user_cp, this.us_cp).then(result => {
            if (result == true) {
              this.us_cp = new User_CP();
              this.messageNoti = 'Cập nhật mật khẩu thành công';
              this.mr = this.modalService.open(this.contentNoti, { centered: true, backdrop: 'static', keyboard: false });
            }
            else {
              this.messageError = 'Cập nhật mật khẩu thất bại! Thử lại sau.';
              this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });
            }
          }).catch(err => {
            this.messageError = 'Cập nhật mật khẩu thất bại! Thử lại sau.';
            this.mr = this.modalService.open(this.contentError, { centered: true, backdrop: 'static', keyboard: false });

          });
        }
      }
    });
  }

  ChangeTurnOn_TurnOff_Background_Icon(value: string) {
    if (value === "iconCamera") {
      if (this.checkChangeBG_IconCamera == true) {
        this.checkChangeBG_IconCamera = false;
      } else {
        this.call_ScanbyApp();
        this.checkChangeBG_IconCamera = true;
        this.checkChangeBG_IconFind = false;
        this.checkChangeBG_IconCustomer = false;
        this.checkChangeBG_IconGear = false;
      }
    } else if (value === "iconFind") {
      if (this.checkChangeBG_IconFind == true) {
        this.checkChangeBG_IconFind = false;
      } else {
        this.checkChangeBG_IconFind = true;
        this.checkChangeBG_IconCustomer = false;
        this.checkChangeBG_IconCamera = false;
        this.checkChangeBG_IconGear = false;
      }
    } else if (value === "iconCustomer") {
      if (this.checkChangeBG_IconCustomer == true) {
        this.checkChangeBG_IconCustomer = false;
      } else {
        this.checkChangeBG_IconCustomer = true;
        this.checkChangeBG_IconFind = false;
        this.checkChangeBG_IconCamera = false;
        this.checkChangeBG_IconGear = false;
      }
    } else if (value === "iconGear") {
      if (this.checkChangeBG_IconGear == true) {
        this.checkChangeBG_IconGear = false;
      } else {
        this.checkChangeBG_IconGear = true;
        this.checkChangeBG_IconFind = false;
        this.checkChangeBG_IconCamera = false;
        this.checkChangeBG_IconCustomer = false;
      }
    } else {
      this.checkChangeBG_IconCamera = false;
      this.checkChangeBG_IconCustomer = false;
      this.checkChangeBG_IconFind = false;
      this.checkChangeBG_IconGear = false;
    }
  }


  OpenPageCameraNew_IconEdit() {
    const value = 'Page_CameraNew';
    this.checkAllPage(value);
    this.checkIconCamera_WhenEdit_InCamera = true;
    this.checkChangeColor_IconEidt_PageCamera = true;
    this.checkChangeColor_IconCamera_New_PageCamera = false;
  }

  OpenPageCameraNew_IconCamera() {
    const value = 'Page_Camera';
    this.checkAllPage(value);
    this.checkIconCamera_WhenEdit_InCamera = false;
    this.checkChangeColor_IconEidt_PageCamera = false;
    this.checkChangeColor_IconCamera_New_PageCamera = true;
    this.call_ScanbyApp();
  }

  checkFlag_ScannedCode(RefCode: string) {
    if (this.checkPageCamera == true) {
      if (RefCode == "null" || RefCode === undefined) {
        this.OpenPageCameraNew_IconEdit();
      }
      else {
        const valueIcon = "TurnOffIcon_BGDefault";
        this.ChangeTurnOn_TurnOff_Background_Icon(valueIcon);
        this.onCodeResult(RefCode, this.contentError);
      }
    }
    if (this.checkPageCustomer == true) {
      this.onCustomer_scanned(RefCode, this.contentError);
    }
    if (this.checkPagePayment_Voucher == true) {
      this.onVoucher_scanned(RefCode, this.contentError);
    }
    if (this.checkPagePayment_QR == true) {
      this.onCodeResult_QR(RefCode, this.contentError);
    }
  }

  call_ScanbyApp() {
    window["TPCGoWV"].ScanCode();
  }

  openModalSearchPhone() {
    this.mr = this.modalService.open(this.contentSearchKHTV, { centered: true, backdrop: 'static', keyboard: false });
  }

  Search_CustomerbyPhone() {
    this.customerService.getCustomer_SGC('', this.value_searchSDT)
      .then((result) => {
        this.lst_customer = result;
      })
      .catch(error => {
        this.value_searchSDT = '';
        this.valueNumber = '';
        this.closeModal();
        this.messageError = error;
        this.openMessageError(this.contentError);
      });

  }

  Confirm_CustomerbyPhone() {
    this.valueNumber = this.radioSelected_KHTV;
    this.submitCustomer_hieuth(this.contentError);
    this.value_searchSDT = '';
    this.lst_customer = [];
  }

  Cancel_CustomerbyPhone() {
    this.value_searchSDT = '';
    this.valueNumber = '';
    this.lst_customer = [];
  }



  //checkBox_KHTV(id: string) {
  //  const product: HangHoa = this.products.find(x => x.MaHH === id);
  //  if (product !== null) {
  //    const cart = this.checkCart.findIndex(n => n.MaHH === product.MaHH);
  //    console.log(cart);
  //    if (cart >= 0) {
  //      product.checked = false;
  //      this.checkCart.splice(cart, 1);
  //    } else {
  //      product.checked = true;
  //      this.checkCart.push(product);
  //    }
  //  }
  //}

  async Logout_MaCQT() {
    if (window.navigator.onLine === true) {
      this.listCart = [];
      const Now_Date = moment().format('YYYY-MM-DD');
      let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
      await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
      var tpcQuayBanMaCQT: any = {
        Store: macqt_luutru.StoreID,
        Register: macqt_luutru.MaQuay,
        Year: macqt_luutru.Nam,
        MACQT: macqt_luutru.MaCQT,
        Update_Date: Now_Date,
        CQT_Location: macqt_luutru.CQT_location
      }
      this.products = [];
      this.upload_saleBackup_FTP();
      this.upload_saleBackup_FTP_CQT_Logout();
      await this.authenticationService.UpdateQuayBan_MaCQT_Logout(tpcQuayBanMaCQT);
      await this.setCheckAllBill();
      await this.setNumberMaxBill();
      await this.authenticationService.logout_ForMaCQT();
      await this.authenticationService.out_to_quayban();
      //this.closeModal();
      //this.messageError = 'Đang trong trạng thái offline, bạn không được đăng xuất!';
      //this.mr = this.modalService.open(this.contentQBban_MaCQT, { centered: true, backdrop: 'static' });
    }
    else {
      this.closeModal();
      this.messageError = 'Đang trong trạng thái offline, bạn không được đăng xuất!';
      this.mr = this.modalService.open(this.contentQBban_MaCQT, { centered: true, backdrop: 'static' });
    }
  }

  async SubmitReturnLitmit_CQT(contentLitmit_CQT) {
    let macqt_luutru: MaCQT_LuuTru = new MaCQT_LuuTru();
    await localForage.getItem('_MaCQT').then((result: any) => macqt_luutru = JSON.parse(result));
    if (macqt_luutru.MaCQT.toString() === "99999") {
      //this.messageError = 'Mã cơ quan thuế vượt quá số lượng.';
      //this.openMessageError(contentError);
      this.closeModal();
      this.mr = this.modalService.open(this.contentLitmit_CQT, { centered: true, backdrop: 'static' })
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/components/banhang/banhang.component.ts